import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { GynecologySidebar } from "../Layouts/GynecologySidebar";
import { Preview, print } from "react-html2pdf";
import Select from "react-select";
import makeAnimated from "react-select/animated";
// import 'react-select/dist/css/react-select.css';
export class GHistoryTaking extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    var values = [];
    this.state = {
      chiefComplaint: "",
      historyofPresentIllness: "",
      physicalGeneral: "",
      obstetricGynecologicalExam: "",
      // diagnosis: "",
      plan: "",
      treatment: "",
      options: {},
      diagnosis: [],
      patientName: localStorage.getItem("currentVisitName"),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.addNewDiagnosis = this.addNewDiagnosis.bind(this);

    this.handleMultiChange = this.handleMultiChange.bind(this);
  }

  handleMultiChange(option) {
    this.setState({
      diagnosis: option,
    });
  }

  componentDidMount() {
    $(".plus_btn").click(function () {
      $(".ICDhidden").show();
    });

    const options = [
      {
        label: "Pregnancy, childbirth or the puerperium",
        value: "Pregnancy, childbirth or the puerperium",
      },
      {
        label: "Abortive outcome of pregnancy",
        value: "Abortive outcome of pregnancy",
      },
      { label: "Abortion", value: "Abortion" },
      { label: "Spontaneous abortion", value: "Spontaneous abortion" },
      {
        label:
          "Spontaneous abortion, incomplete, complicated by genital tract or pelvic infection",
        value:
          "Spontaneous abortion, incomplete, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Spontaneous abortion, incomplete, complicated by delayed or excessive haemorrhage",
        value:
          "Spontaneous abortion, incomplete, complicated by delayed or excessive haemorrhage",
      },
      {
        label: "Spontaneous abortion, incomplete, complicated by embolism",
        value: "Spontaneous abortion, incomplete, complicated by embolism",
      },
      {
        label:
          "Spontaneous abortion, incomplete, with other or unspecified complications",
        value:
          "Spontaneous abortion, incomplete, with other or unspecified complications",
      },
      {
        label: "Spontaneous abortion, incomplete, without complication",
        value: "Spontaneous abortion, incomplete, without complication",
      },
      {
        label:
          "Spontaneous abortion, complete or unspecified, complicated by genital tract or pelvic infection",
        value:
          "Spontaneous abortion, complete or unspecified, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Spontaneous abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
        value:
          "Spontaneous abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
      },
      {
        label:
          "Spontaneous abortion, complete or unspecified, complicated by embolism",
        value:
          "Spontaneous abortion, complete or unspecified, complicated by embolism",
      },
      {
        label:
          "Spontaneous abortion, complete or unspecified, with other or unspecified complications",
        value:
          "Spontaneous abortion, complete or unspecified, with other or unspecified complications",
      },
      {
        label:
          "Spontaneous abortion, complete or unspecified, without complication",
        value:
          "Spontaneous abortion, complete or unspecified, without complication",
      },
      { label: "Induced abortion", value: "Induced abortion" },
      {
        label:
          "Induced abortion, incomplete, complicated by genital tract or pelvic infection",
        value:
          "Induced abortion, incomplete, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Induced abortion, incomplete, complicated by delayed or excessive haemorrhage",
        value:
          "Induced abortion, incomplete, complicated by delayed or excessive haemorrhage",
      },
      {
        label: "Induced abortion, incomplete, complicated by embolism",
        value: "Induced abortion, incomplete, complicated by embolism",
      },
      {
        label:
          "Induced abortion, incomplete, with other or unspecified complications",
        value:
          "Induced abortion, incomplete, with other or unspecified complications",
      },
      {
        label: "Induced abortion, incomplete, without complication",
        value: "Induced abortion, incomplete, without complication",
      },
      {
        label:
          "Induced abortion, complete or unspecified, complicated by genital tract or pelvic infection",
        value:
          "Induced abortion, complete or unspecified, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Induced abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
        value:
          "Induced abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
      },
      {
        label:
          "Induced abortion, complete or unspecified, complicated by embolism",
        value:
          "Induced abortion, complete or unspecified, complicated by embolism",
      },
      {
        label:
          "Induced abortion, complete or unspecified, with other complication",
        value:
          "Induced abortion, complete or unspecified, with other complication",
      },
      {
        label:
          "Induced abortion, complete or unspecified, without complication",
        value:
          "Induced abortion, complete or unspecified, without complication",
      },
      { label: "Unspecified abortion", value: "Unspecified abortion" },
      {
        label:
          "Unspecified abortion, incomplete, complicated by genital tract or pelvic infection",
        value:
          "Unspecified abortion, incomplete, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Unspecified abortion, incomplete, complicated by delayed or excessive haemorrhage",
        value:
          "Unspecified abortion, incomplete, complicated by delayed or excessive haemorrhage",
      },
      {
        label: "Unspecified abortion, incomplete, complicated by embolism",
        value: "Unspecified abortion, incomplete, complicated by embolism",
      },
      {
        label:
          "Unspecified abortion, incomplete, with other or unspecified complications",
        value:
          "Unspecified abortion, incomplete, with other or unspecified complications",
      },
      {
        label: "Unspecified abortion, incomplete, without complication",
        value: "Unspecified abortion, incomplete, without complication",
      },
      {
        label:
          "Unspecified abortion, complete or unspecified, complicated by genital tract or pelvic infection",
        value:
          "Unspecified abortion, complete or unspecified, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Unspecified abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
        value:
          "Unspecified abortion, complete or unspecified, complicated by delayed or excessive haemorrhage",
      },
      {
        label:
          "Unspecified abortion, complete or unspecified, complicated by embolism",
        value:
          "Unspecified abortion, complete or unspecified, complicated by embolism",
      },
      {
        label:
          "Unspecified abortion, complete or unspecified, with other or unspecified complications",
        value:
          "Unspecified abortion, complete or unspecified, with other or unspecified complications",
      },
      {
        label:
          "Unspecified abortion, complete or unspecified, without complication",
        value:
          "Unspecified abortion, complete or unspecified, without complication",
      },
      {
        label: "Failed attempted abortion",
        value: "Failed attempted abortion",
      },
      {
        label:
          "Failed medical abortion, complicated by genital tract or pelvic infection",
        value:
          "Failed medical abortion, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Failed medical abortion, complicated by delayed or excessive haemorrhage",
        value:
          "Failed medical abortion, complicated by delayed or excessive haemorrhage",
      },
      {
        label: "Failed medical abortion, complicated by embolism",
        value: "Failed medical abortion, complicated by embolism",
      },
      {
        label:
          "Failed medical abortion, with other or unspecified complications",
        value:
          "Failed medical abortion, with other or unspecified complications",
      },
      {
        label: "Failed medical abortion, without complication",
        value: "Failed medical abortion, without complication",
      },
      {
        label:
          "Other or unspecified failed attempted abortion, complicated by genital tract or pelvic infection",
        value:
          "Other or unspecified failed attempted abortion, complicated by genital tract or pelvic infection",
      },
      {
        label:
          "Other or unspecified failed attempted abortion, complicated by delayed or excessive haemorrhage",
        value:
          "Other or unspecified failed attempted abortion, complicated by delayed or excessive haemorrhage",
      },
      {
        label:
          "Other or unspecified failed attempted abortion, complicated by embolism",
        value:
          "Other or unspecified failed attempted abortion, complicated by embolism",
      },
      {
        label:
          "Other or unspecified failed attempted abortion, with other or unspecified complications",
        value:
          "Other or unspecified failed attempted abortion, with other or unspecified complications",
      },
      {
        label:
          "Other or unspecified failed attempted abortion, without complication",
        value:
          "Other or unspecified failed attempted abortion, without complication",
      },
      { label: "Ectopic pregnancy", value: "Ectopic pregnancy" },
      { label: "Abdominal pregnancy", value: "Abdominal pregnancy" },
      { label: "Tubal pregnancy", value: "Tubal pregnancy" },
      { label: "Ovarian pregnancy", value: "Ovarian pregnancy" },
      {
        label: "Other specified ectopic pregnancy",
        value: "Other specified ectopic pregnancy",
      },
      {
        label: "Ectopic pregnancy, unspecified",
        value: "Ectopic pregnancy, unspecified",
      },
      { label: "Molar pregnancy", value: "Molar pregnancy" },
      {
        label: "Complete hydatidiform mole",
        value: "Complete hydatidiform mole",
      },
      {
        label: "Incomplete or partial hydatidiform mole",
        value: "Incomplete or partial hydatidiform mole",
      },
      {
        label: "Other specified molar pregnancy",
        value: "Other specified molar pregnancy",
      },
      {
        label: "Molar pregnancy, unspecified",
        value: "Molar pregnancy, unspecified",
      },
      { label: "Missed abortion", value: "Missed abortion" },
      {
        label: "Blighted ovum or nonhydatidiform mole",
        value: "Blighted ovum or nonhydatidiform mole",
      },
      {
        label: "Complications following abortion, ectopic or molar pregnancy",
        value: "Complications following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Genital tract or pelvic infection following abortion, ectopic or molar pregnancy",
        value:
          "Genital tract or pelvic infection following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Delayed or excessive haemorrhage following abortion, ectopic or molar pregnancy",
        value:
          "Delayed or excessive haemorrhage following abortion, ectopic or molar pregnancy",
      },
      {
        label: "Embolism following abortion, ectopic or molar pregnancy",
        value: "Embolism following abortion, ectopic or molar pregnancy",
      },
      {
        label: "Shock following abortion, ectopic or molar pregnancy",
        value: "Shock following abortion, ectopic or molar pregnancy",
      },
      {
        label: "Renal failure following abortion, ectopic or molar pregnancy",
        value: "Renal failure following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Metabolic disorders following abortion, ectopic or molar pregnancy",
        value:
          "Metabolic disorders following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Damage to pelvic organs and tissues following abortion, ectopic or molar pregnancy",
        value:
          "Damage to pelvic organs and tissues following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Other venous complications following abortion, ectopic or molar pregnancy",
        value:
          "Other venous complications following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Other specified complications following abortion, ectopic or molar pregnancy",
        value:
          "Other specified complications following abortion, ectopic or molar pregnancy",
      },
      {
        label:
          "Complications following abortion, ectopic or molar pregnancy, unspecified",
        value:
          "Complications following abortion, ectopic or molar pregnancy, unspecified",
      },
      {
        label: "Abortive outcome of pregnancy, unspecified",
        value: "Abortive outcome of pregnancy, unspecified",
      },
      {
        label:
          "Oedema, proteinuria, or hypertensive disorders in pregnancy, childbirth, or the puerperium",
        value:
          "Oedema, proteinuria, or hypertensive disorders in pregnancy, childbirth, or the puerperium",
      },
      {
        label:
          "Pre-existing hypertension complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing hypertension complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing essential hypertension complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing essential hypertension complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing hypertensive heart disease complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing hypertensive heart disease complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing hypertensive renal disease complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing hypertensive renal disease complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing hypertensive heart and renal disease complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing hypertensive heart and renal disease complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing secondary hypertension complicating pregnancy, childbirth or the puerperium",
        value:
          "Pre-existing secondary hypertension complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Other specified pre-existing hypertension complicating pregnancy, childbirth or the puerperium",
        value:
          "Other specified pre-existing hypertension complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Pre-existing hypertension complicating pregnancy, childbirth or the puerperium, unspecified",
        value:
          "Pre-existing hypertension complicating pregnancy, childbirth or the puerperium, unspecified",
      },
      {
        label: "Pre-eclampsia superimposed on chronic hypertension",
        value: "Pre-eclampsia superimposed on chronic hypertension",
      },
      {
        label: "Gestational oedema or proteinuria without hypertension",
        value: "Gestational oedema or proteinuria without hypertension",
      },
      {
        label: "Gestational proteinuria without hypertension",
        value: "Gestational proteinuria without hypertension",
      },
      {
        label: "Gestational oedema without hypertension",
        value: "Gestational oedema without hypertension",
      },
      {
        label: "Gestational oedema with proteinuria without hypertension",
        value: "Gestational oedema with proteinuria without hypertension",
      },
      { label: "Gestational hypertension", value: "Gestational hypertension" },
      { label: "Pre-eclampsia", value: "Pre-eclampsia" },
      {
        label: "Mild to moderate pre-eclampsia",
        value: "Mild to moderate pre-eclampsia",
      },
      { label: "Severe pre-eclampsia", value: "Severe pre-eclampsia" },
      { label: "HELLP syndrome", value: "HELLP syndrome" },
      {
        label: "Pre-eclampsia, unspecified",
        value: "Pre-eclampsia, unspecified",
      },
      { label: "Eclampsia", value: "Eclampsia" },
      { label: "Eclampsia in pregnancy", value: "Eclampsia in pregnancy" },
      { label: "Eclampsia in labour", value: "Eclampsia in labour" },
      {
        label: "Eclampsia in the puerperium",
        value: "Eclampsia in the puerperium",
      },
      {
        label: "Eclampsia, time period unspecified",
        value: "Eclampsia, time period unspecified",
      },
      {
        label:
          "Oedema, proteinuria, or hypertensive disorders in pregnancy, childbirth, or the puerperium, unspecified",
        value:
          "Oedema, proteinuria, or hypertensive disorders in pregnancy, childbirth, or the puerperium, unspecified",
      },
      { label: "Obstetric haemorrhage", value: "Obstetric haemorrhage" },
      {
        label: "Haemorrhage in early pregnancy",
        value: "Haemorrhage in early pregnancy",
      },
      { label: "Threatened abortion", value: "Threatened abortion" },
      {
        label: "Other specified haemorrhage in early pregnancy",
        value: "Other specified haemorrhage in early pregnancy",
      },
      {
        label: "Haemorrhage in early pregnancy, unspecified",
        value: "Haemorrhage in early pregnancy, unspecified",
      },
      { label: "Antepartum haemorrhage", value: "Antepartum haemorrhage" },
      {
        label: "Antepartum haemorrhage with coagulation defect",
        value: "Antepartum haemorrhage with coagulation defect",
      },
      {
        label: "Other specified antepartum haemorrhage",
        value: "Other specified antepartum haemorrhage",
      },
      {
        label: "Antepartum haemorrhage, unspecified",
        value: "Antepartum haemorrhage, unspecified",
      },
      { label: "Intrapartum haemorrhage", value: "Intrapartum haemorrhage" },
      {
        label: "Intrapartum haemorrhage with coagulation defect",
        value: "Intrapartum haemorrhage with coagulation defect",
      },
      {
        label:
          "Intrapartum haemorrhage resulting from obstructed labour with uterine rupture",
        value:
          "Intrapartum haemorrhage resulting from obstructed labour with uterine rupture",
      },
      {
        label:
          "Intrapartum haemorrhage resulting from obstructed labour without mention of uterine rupture",
        value:
          "Intrapartum haemorrhage resulting from obstructed labour without mention of uterine rupture",
      },
      {
        label: "Other specified intrapartum haemorrhage",
        value: "Other specified intrapartum haemorrhage",
      },
      {
        label: "Intrapartum haemorrhage, unspecified",
        value: "Intrapartum haemorrhage, unspecified",
      },
      { label: "Postpartum haemorrhage", value: "Postpartum haemorrhage" },
      { label: "Third-stage haemorrhage", value: "Third-stage haemorrhage" },
      {
        label: "Other immediate postpartum haemorrhage",
        value: "Other immediate postpartum haemorrhage",
      },
      {
        label: "Delayed or secondary postpartum haemorrhage",
        value: "Delayed or secondary postpartum haemorrhage",
      },
      {
        label: "Postpartum coagulation defects",
        value: "Postpartum coagulation defects",
      },
      {
        label:
          "Postpartum haemorrhage following obstructed labour with uterine rupture",
        value:
          "Postpartum haemorrhage following obstructed labour with uterine rupture",
      },
      {
        label:
          "Postpartum haemorrhage following obstructed labour without mention of uterine rupture",
        value:
          "Postpartum haemorrhage following obstructed labour without mention of uterine rupture",
      },
      {
        label: "Other specified postpartum haemorrhage",
        value: "Other specified postpartum haemorrhage",
      },
      {
        label: "Postpartum haemorrhage, unspecified",
        value: "Postpartum haemorrhage, unspecified",
      },
      {
        label: "Obstetric haemorrhage, unspecified",
        value: "Obstetric haemorrhage, unspecified",
      },
      {
        label:
          "Certain specified maternal disorders predominantly related to pregnancy",
        value:
          "Certain specified maternal disorders predominantly related to pregnancy",
      },
      {
        label: "Excessive vomiting in pregnancy",
        value: "Excessive vomiting in pregnancy",
      },
      {
        label: "Mild hyperemesis gravidarum",
        value: "Mild hyperemesis gravidarum",
      },
      {
        label: "Hyperemesis gravidarum with metabolic disturbance",
        value: "Hyperemesis gravidarum with metabolic disturbance",
      },
      {
        label: "Late vomiting of pregnancy",
        value: "Late vomiting of pregnancy",
      },
      {
        label: "Other specified excessive vomiting in pregnancy",
        value: "Other specified excessive vomiting in pregnancy",
      },
      {
        label: "Excessive vomiting in pregnancy, unspecified",
        value: "Excessive vomiting in pregnancy, unspecified",
      },
      {
        label: "Venous complications in pregnancy",
        value: "Venous complications in pregnancy",
      },
      {
        label: "Varicose veins of lower extremity in pregnancy",
        value: "Varicose veins of lower extremity in pregnancy",
      },
      {
        label: "Genital varices in pregnancy",
        value: "Genital varices in pregnancy",
      },
      {
        label: "Superficial thrombophlebitis in pregnancy",
        value: "Superficial thrombophlebitis in pregnancy",
      },
      {
        label: "Deep phlebothrombosis in pregnancy",
        value: "Deep phlebothrombosis in pregnancy",
      },
      {
        label: "Haemorrhoids in pregnancy",
        value: "Haemorrhoids in pregnancy",
      },
      {
        label: "Cerebral venous thrombosis in pregnancy",
        value: "Cerebral venous thrombosis in pregnancy",
      },
      {
        label: "Other specified venous complications in pregnancy",
        value: "Other specified venous complications in pregnancy",
      },
      {
        label: "Venous complications in pregnancy, unspecified",
        value: "Venous complications in pregnancy, unspecified",
      },
      {
        label: "Infections of genitourinary tract in pregnancy",
        value: "Infections of genitourinary tract in pregnancy",
      },
      {
        label: "Infections of kidney in pregnancy",
        value: "Infections of kidney in pregnancy",
      },
      {
        label: "Infections of bladder in pregnancy",
        value: "Infections of bladder in pregnancy",
      },
      {
        label: "Infections of urethra in pregnancy",
        value: "Infections of urethra in pregnancy",
      },
      {
        label: "Infections of other parts of urinary tract in pregnancy",
        value: "Infections of other parts of urinary tract in pregnancy",
      },
      {
        label: "Infections of the genital tract in pregnancy",
        value: "Infections of the genital tract in pregnancy",
      },
      {
        label:
          "Infections of genitourinary tract in pregnancy, other specified site",
        value:
          "Infections of genitourinary tract in pregnancy, other specified site",
      },
      {
        label:
          "Infection of genitourinary tract in pregnancy, site unspecified",
        value:
          "Infection of genitourinary tract in pregnancy, site unspecified",
      },
      {
        label: "Diabetes mellitus in pregnancy",
        value: "Diabetes mellitus in pregnancy",
      },
      {
        label: "Pre-existing type 1 diabetes mellitus in pregnancy",
        value: "Pre-existing type 1 diabetes mellitus in pregnancy",
      },
      {
        label: "Pre-existing type 2 diabetes mellitus in pregnancy",
        value: "Pre-existing type 2 diabetes mellitus in pregnancy",
      },
      {
        label: "Diabetes mellitus arising in pregnancy",
        value: "Diabetes mellitus arising in pregnancy",
      },
      {
        label: "Other specified diabetes mellitus in pregnancy",
        value: "Other specified diabetes mellitus in pregnancy",
      },
      {
        label: "Diabetes mellitus in pregnancy, unspecified",
        value: "Diabetes mellitus in pregnancy, unspecified",
      },
      {
        label: "Malnutrition in pregnancy",
        value: "Malnutrition in pregnancy",
      },
      {
        label:
          "Maternal care for other conditions predominantly related to pregnancy",
        value:
          "Maternal care for other conditions predominantly related to pregnancy",
      },
      {
        label: "Liver disorders in pregnancy, childbirth or the puerperium",
        value: "Liver disorders in pregnancy, childbirth or the puerperium",
      },
      { label: "Pregnancy dermatoses", value: "Pregnancy dermatoses" },
      { label: "Gestational pemphigoid", value: "Gestational pemphigoid" },
      { label: "Pruritus of pregnancy", value: "Pruritus of pregnancy" },
      {
        label: "Polymorphic eruption of pregnancy",
        value: "Polymorphic eruption of pregnancy",
      },
      {
        label: "Other specified pregnancy dermatoses",
        value: "Other specified pregnancy dermatoses",
      },
      {
        label: "Excessive weight gain in pregnancy",
        value: "Excessive weight gain in pregnancy",
      },
      {
        label: "Low weight gain in pregnancy",
        value: "Low weight gain in pregnancy",
      },
      {
        label: "Pregnancy care of habitual aborter",
        value: "Pregnancy care of habitual aborter",
      },
      {
        label: "Retained intrauterine contraceptive device in pregnancy",
        value: "Retained intrauterine contraceptive device in pregnancy",
      },
      {
        label: "Maternal hypotension syndrome",
        value: "Maternal hypotension syndrome",
      },
      {
        label:
          "Subluxation of symphysis pubis in pregnancy, childbirth or the puerperium",
        value:
          "Subluxation of symphysis pubis in pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Maternal care for other specified conditions predominantly related to pregnancy",
        value:
          "Maternal care for other specified conditions predominantly related to pregnancy",
      },
      {
        label:
          "Maternal care for unspecified conditions predominantly related to pregnancy",
        value:
          "Maternal care for unspecified conditions predominantly related to pregnancy",
      },
      {
        label: "Clinical findings on antenatal screening of mother",
        value: "Clinical findings on antenatal screening of mother",
      },
      {
        label:
          "Abnormal haematological finding on antenatal screening of mother",
        value:
          "Abnormal haematological finding on antenatal screening of mother",
      },
      {
        label: "Abnormal biochemical finding on antenatal screening of mother",
        value: "Abnormal biochemical finding on antenatal screening of mother",
      },
      {
        label: "Abnormal cytological finding on antenatal screening of mother",
        value: "Abnormal cytological finding on antenatal screening of mother",
      },
      {
        label: "Abnormal ultrasonic finding on antenatal screening of mother",
        value: "Abnormal ultrasonic finding on antenatal screening of mother",
      },
      {
        label: "Abnormal radiological finding on antenatal screening of mother",
        value: "Abnormal radiological finding on antenatal screening of mother",
      },
      {
        label:
          "Abnormal chromosomal or genetic finding on antenatal screening of mother",
        value:
          "Abnormal chromosomal or genetic finding on antenatal screening of mother",
      },
      {
        label:
          "Other specified clinical findings on antenatal screening of mother",
        value:
          "Other specified clinical findings on antenatal screening of mother",
      },
      {
        label:
          "Clinical findings on antenatal screening of mother, unspecified",
        value:
          "Clinical findings on antenatal screening of mother, unspecified",
      },
      {
        label: "Complications of anaesthesia during pregnancy",
        value: "Complications of anaesthesia during pregnancy",
      },
      {
        label: "Pulmonary complications of anaesthesia during pregnancy",
        value: "Pulmonary complications of anaesthesia during pregnancy",
      },
      {
        label: "Cardiac complications of anaesthesia during pregnancy",
        value: "Cardiac complications of anaesthesia during pregnancy",
      },
      {
        label:
          "Central nervous system complications of anaesthesia during pregnancy",
        value:
          "Central nervous system complications of anaesthesia during pregnancy",
      },
      {
        label: "Toxic reaction to local anaesthesia during pregnancy",
        value: "Toxic reaction to local anaesthesia during pregnancy",
      },
      {
        label:
          "Spinal or epidural anaesthesia-induced headache during pregnancy",
        value:
          "Spinal or epidural anaesthesia-induced headache during pregnancy",
      },
      {
        label: "Failed or difficult intubation during pregnancy",
        value: "Failed or difficult intubation during pregnancy",
      },
      {
        label: "Awareness under general anaesthesia during pregnancy",
        value: "Awareness under general anaesthesia during pregnancy",
      },
      {
        label: "Other specified complications of anaesthesia during pregnancy",
        value: "Other specified complications of anaesthesia during pregnancy",
      },
      {
        label: "Complications of anaesthesia during pregnancy, unspecified",
        value: "Complications of anaesthesia during pregnancy, unspecified",
      },
      {
        label:
          "Maternal disorders predominantly related to pregnancy, unspecified",
        value:
          "Maternal disorders predominantly related to pregnancy, unspecified",
      },
      {
        label:
          "Maternal care related to the fetus, amniotic cavity or possible delivery problems",
        value:
          "Maternal care related to the fetus, amniotic cavity or possible delivery problems",
      },
      {
        label: "Maternal care related to multiple gestation",
        value: "Maternal care related to multiple gestation",
      },
      { label: "Twin pregnancy", value: "Twin pregnancy" },
      { label: "Triplet pregnancy", value: "Triplet pregnancy" },
      { label: "Quadruplet pregnancy", value: "Quadruplet pregnancy" },
      {
        label: "Maternal care related to other specified multiple gestation",
        value: "Maternal care related to other specified multiple gestation",
      },
      {
        label: "Maternal care related to unspecified multiple gestation",
        value: "Maternal care related to unspecified multiple gestation",
      },
      {
        label:
          "Maternal care related to complications specific to multiple gestation",
        value:
          "Maternal care related to complications specific to multiple gestation",
      },
      { label: "Papyraceous fetus", value: "Papyraceous fetus" },
      {
        label: "Continuing pregnancy after abortion of one fetus or more",
        value: "Continuing pregnancy after abortion of one fetus or more",
      },
      {
        label:
          "Continuing pregnancy after intrauterine death of one fetus or more",
        value:
          "Continuing pregnancy after intrauterine death of one fetus or more",
      },
      {
        label:
          "Loss of pregnancy after abortion or intrauterine death of one fetus or more",
        value:
          "Loss of pregnancy after abortion or intrauterine death of one fetus or more",
      },
      {
        label:
          "Other specified maternal care related to complications specific to multiple gestation",
        value:
          "Other specified maternal care related to complications specific to multiple gestation",
      },
      {
        label:
          "Maternal care related to complications specific to multiple gestation, unspecified",
        value:
          "Maternal care related to complications specific to multiple gestation, unspecified",
      },
      {
        label: "Maternal care for known or suspected malpresentation of fetus",
        value: "Maternal care for known or suspected malpresentation of fetus",
      },
      {
        label: "Maternal care for unstable lie",
        value: "Maternal care for unstable lie",
      },
      {
        label: "Maternal care for breech presentation",
        value: "Maternal care for breech presentation",
      },
      {
        label: "Maternal care for transverse or oblique lie",
        value: "Maternal care for transverse or oblique lie",
      },
      {
        label: "Maternal care for face, brow or chin presentation",
        value: "Maternal care for face, brow or chin presentation",
      },
      {
        label: "Maternal care for high head at term",
        value: "Maternal care for high head at term",
      },
      {
        label:
          "Maternal care for multiple gestation with malpresentation of one fetus or more",
        value:
          "Maternal care for multiple gestation with malpresentation of one fetus or more",
      },
      {
        label: "Maternal care for compound presentation",
        value: "Maternal care for compound presentation",
      },
      {
        label:
          "Maternal care for known or suspected other specified malpresentation of fetus",
        value:
          "Maternal care for known or suspected other specified malpresentation of fetus",
      },
      {
        label:
          "Maternal care for known or suspected malpresentation of fetus, unspecified",
        value:
          "Maternal care for known or suspected malpresentation of fetus, unspecified",
      },
      {
        label: "Maternal care for known or suspected disproportion",
        value: "Maternal care for known or suspected disproportion",
      },
      {
        label:
          "Maternal care for disproportion due to deformity of maternal pelvic bones",
        value:
          "Maternal care for disproportion due to deformity of maternal pelvic bones",
      },
      {
        label:
          "Maternal care for disproportion due to generally contracted pelvis",
        value:
          "Maternal care for disproportion due to generally contracted pelvis",
      },
      {
        label:
          "Maternal care for disproportion due to inlet contraction of pelvis",
        value:
          "Maternal care for disproportion due to inlet contraction of pelvis",
      },
      {
        label:
          "Maternal care for disproportion due to outlet contraction of pelvis",
        value:
          "Maternal care for disproportion due to outlet contraction of pelvis",
      },
      {
        label:
          "Maternal care for disproportion of mixed maternal and fetal origin",
        value:
          "Maternal care for disproportion of mixed maternal and fetal origin",
      },
      {
        label: "Maternal care for disproportion due to unusually large fetus",
        value: "Maternal care for disproportion due to unusually large fetus",
      },
      {
        label: "Maternal care for disproportion due to hydrocephalic fetus",
        value: "Maternal care for disproportion due to hydrocephalic fetus",
      },
      {
        label:
          "Maternal care for known or suspected other specified disproportion",
        value:
          "Maternal care for known or suspected other specified disproportion",
      },
      {
        label:
          "Maternal care for known or suspected disproportion, unspecified",
        value:
          "Maternal care for known or suspected disproportion, unspecified",
      },
      {
        label:
          "Maternal care for known or suspected abnormality of pelvic organs",
        value:
          "Maternal care for known or suspected abnormality of pelvic organs",
      },
      {
        label: "Maternal care for congenital malformation of uterus",
        value: "Maternal care for congenital malformation of uterus",
      },
      {
        label: "Maternal care for tumour of corpus uteri",
        value: "Maternal care for tumour of corpus uteri",
      },
      {
        label: "Maternal care due to uterine scar from previous surgery",
        value: "Maternal care due to uterine scar from previous surgery",
      },
      {
        label: "Maternal care for cervical incompetence",
        value: "Maternal care for cervical incompetence",
      },
      {
        label: "Maternal care for abnormality of vagina",
        value: "Maternal care for abnormality of vagina",
      },
      {
        label: "Maternal care for abnormality of vulva or perineum",
        value: "Maternal care for abnormality of vulva or perineum",
      },
      {
        label:
          "Maternal care for known or suspected other specified abnormality of pelvic organs",
        value:
          "Maternal care for known or suspected other specified abnormality of pelvic organs",
      },
      {
        label:
          "Maternal care for known or suspected abnormality of pelvic organs, unspecified",
        value:
          "Maternal care for known or suspected abnormality of pelvic organs, unspecified",
      },
      {
        label:
          "Maternal care for known or suspected fetal abnormality or damage",
        value:
          "Maternal care for known or suspected fetal abnormality or damage",
      },
      {
        label:
          "Maternal care for known or suspected central nervous system malformation in fetus",
        value:
          "Maternal care for known or suspected central nervous system malformation in fetus",
      },
      {
        label:
          "Maternal care for known or suspected chromosomal abnormality in fetus",
        value:
          "Maternal care for known or suspected chromosomal abnormality in fetus",
      },
      {
        label:
          "Maternal care for known or suspected hereditary disease in fetus",
        value:
          "Maternal care for known or suspected hereditary disease in fetus",
      },
      {
        label:
          "Maternal care for known or suspected damage to fetus from viral disease in mother",
        value:
          "Maternal care for known or suspected damage to fetus from viral disease in mother",
      },
      {
        label:
          "Maternal care for known or suspected other specified fetal abnormality or damage",
        value:
          "Maternal care for known or suspected other specified fetal abnormality or damage",
      },
      {
        label:
          "Maternal care for known or suspected fetal abnormality or damage, unspecified",
        value:
          "Maternal care for known or suspected fetal abnormality or damage, unspecified",
      },
      {
        label: "Maternal care for other known or suspected fetal problems",
        value: "Maternal care for other known or suspected fetal problems",
      },
      {
        label: "Maternal care for red cell antibodies",
        value: "Maternal care for red cell antibodies",
      },
      {
        label: "Maternal care for hydrops fetalis",
        value: "Maternal care for hydrops fetalis",
      },
      {
        label: "Maternal care for signs of fetal hypoxia",
        value: "Maternal care for signs of fetal hypoxia",
      },
      {
        label: "Maternal care for intrauterine death",
        value: "Maternal care for intrauterine death",
      },
      {
        label: "Maternal care for fetal growth restriction",
        value: "Maternal care for fetal growth restriction",
      },
      {
        label: "Maternal care for suspected macrosomia",
        value: "Maternal care for suspected macrosomia",
      },
      {
        label: "Maternal care for viable fetus in abdominal pregnancy",
        value: "Maternal care for viable fetus in abdominal pregnancy",
      },
      {
        label: "Maternal care for other specified fetal problems",
        value: "Maternal care for other specified fetal problems",
      },
      {
        label:
          "Maternal care for other known or suspected fetal problems, unspecified",
        value:
          "Maternal care for other known or suspected fetal problems, unspecified",
      },
      {
        label: "Maternal care related to polyhydramnios",
        value: "Maternal care related to polyhydramnios",
      },
      {
        label:
          "Maternal care related to certain specified disorders of amniotic fluid or membranes",
        value:
          "Maternal care related to certain specified disorders of amniotic fluid or membranes",
      },
      { label: "Oligohydramnios", value: "Oligohydramnios" },
      {
        label: "Infection of amniotic sac or membranes",
        value: "Infection of amniotic sac or membranes",
      },
      {
        label: "Other specified disorders of amniotic fluid and membranes",
        value: "Other specified disorders of amniotic fluid and membranes",
      },
      {
        label: "Disorders of amniotic fluid and membranes, unspecified",
        value: "Disorders of amniotic fluid and membranes, unspecified",
      },
      {
        label: "Maternal care related to premature rupture of membranes",
        value: "Maternal care related to premature rupture of membranes",
      },
      {
        label:
          "Premature rupture of membranes, onset of labour within 24 hours",
        value:
          "Premature rupture of membranes, onset of labour within 24 hours",
      },
      {
        label: "Premature rupture of membranes, onset of labour after 24 hours",
        value: "Premature rupture of membranes, onset of labour after 24 hours",
      },
      {
        label: "Premature rupture of membranes, labour delayed by therapy",
        value: "Premature rupture of membranes, labour delayed by therapy",
      },
      {
        label: "Preterm premature rupture of membranes",
        value: "Preterm premature rupture of membranes",
      },
      {
        label:
          "Other specified maternal care related to premature rupture of membranes",
        value:
          "Other specified maternal care related to premature rupture of membranes",
      },
      {
        label:
          "Maternal care related to premature rupture of membranes, unspecified",
        value:
          "Maternal care related to premature rupture of membranes, unspecified",
      },
      {
        label: "Maternal care related to placental disorders",
        value: "Maternal care related to placental disorders",
      },
      {
        label: "Placental transfusion syndromes",
        value: "Placental transfusion syndromes",
      },
      { label: "Malformation of placenta", value: "Malformation of placenta" },
      {
        label: "Morbidly adherent placenta",
        value: "Morbidly adherent placenta",
      },
      {
        label: "Other specified maternal care related to placental disorders",
        value: "Other specified maternal care related to placental disorders",
      },
      {
        label: "Maternal care related to placental disorders, unspecified",
        value: "Maternal care related to placental disorders, unspecified",
      },
      {
        label:
          "Maternal care related to placenta praevia or low lying placenta",
        value:
          "Maternal care related to placenta praevia or low lying placenta",
      },
      {
        label: "Placenta praevia specified as without haemorrhage",
        value: "Placenta praevia specified as without haemorrhage",
      },
      {
        label: "Placenta praevia with haemorrhage",
        value: "Placenta praevia with haemorrhage",
      },
      {
        label:
          "Maternal care related to placenta praevia or low lying placenta, unspecified",
        value:
          "Maternal care related to placenta praevia or low lying placenta, unspecified",
      },
      {
        label: "Maternal care related to premature separation of placenta",
        value: "Maternal care related to premature separation of placenta",
      },
      {
        label: "Premature separation of placenta with coagulation defect",
        value: "Premature separation of placenta with coagulation defect",
      },
      {
        label:
          "Other specified maternal care related to premature separation of placenta",
        value:
          "Other specified maternal care related to premature separation of placenta",
      },
      {
        label:
          "Maternal care related to premature separation of placenta, unspecified",
        value:
          "Maternal care related to premature separation of placenta, unspecified",
      },
      {
        label: "Maternal care related to false labour",
        value: "Maternal care related to false labour",
      },
      {
        label: "False labour before 37 completed weeks of gestation",
        value: "False labour before 37 completed weeks of gestation",
      },
      {
        label: "False labour at or after 37 completed weeks of gestation",
        value: "False labour at or after 37 completed weeks of gestation",
      },
      {
        label: "Maternal care related to false labour, unspecified",
        value: "Maternal care related to false labour, unspecified",
      },
      {
        label: "Maternal care related to prolonged pregnancy",
        value: "Maternal care related to prolonged pregnancy",
      },
      {
        label:
          "Maternal care related to other specified fetus, amniotic cavity or possible delivery problems",
        value:
          "Maternal care related to other specified fetus, amniotic cavity or possible delivery problems",
      },
      {
        label:
          "Maternal care related to unspecified fetus, amniotic cavity or possible delivery problems",
        value:
          "Maternal care related to unspecified fetus, amniotic cavity or possible delivery problems",
      },
      {
        label: "Complications of labour or delivery",
        value: "Complications of labour or delivery",
      },
      {
        label: "Preterm labour or delivery",
        value: "Preterm labour or delivery",
      },
      {
        label: "Preterm labour without delivery",
        value: "Preterm labour without delivery",
      },
      {
        label: "Preterm spontaneous labour with preterm delivery",
        value: "Preterm spontaneous labour with preterm delivery",
      },
      {
        label: "Preterm labour with term delivery",
        value: "Preterm labour with term delivery",
      },
      {
        label:
          "Preterm delivery following iatrogenic induction of labour or caesarean section",
        value:
          "Preterm delivery following iatrogenic induction of labour or caesarean section",
      },
      {
        label: "Other specified preterm labour or delivery",
        value: "Other specified preterm labour or delivery",
      },
      {
        label: "Preterm labour or delivery, unspecified",
        value: "Preterm labour or delivery, unspecified",
      },
      {
        label: "Failed induction of labour",
        value: "Failed induction of labour",
      },
      {
        label: "Failed medical induction of labour",
        value: "Failed medical induction of labour",
      },
      {
        label: "Failed instrumental induction of labour",
        value: "Failed instrumental induction of labour",
      },
      {
        label: "Failed induction of labour, unspecified",
        value: "Failed induction of labour, unspecified",
      },
      {
        label: "Abnormalities of forces of labour",
        value: "Abnormalities of forces of labour",
      },
      { label: "Primary uterine inertia", value: "Primary uterine inertia" },
      {
        label: "Secondary uterine inertia",
        value: "Secondary uterine inertia",
      },
      { label: "Other uterine inertia", value: "Other uterine inertia" },
      { label: "Precipitate labour", value: "Precipitate labour" },
      {
        label: "Hypertonic, incoordinate, or prolonged uterine contractions",
        value: "Hypertonic, incoordinate, or prolonged uterine contractions",
      },
      {
        label: "Other specified abnormalities of forces of labour",
        value: "Other specified abnormalities of forces of labour",
      },
      {
        label: "Abnormalities of forces of labour, unspecified",
        value: "Abnormalities of forces of labour, unspecified",
      },
      { label: "Long labour", value: "Long labour" },
      {
        label: "Prolonged first stage of labour",
        value: "Prolonged first stage of labour",
      },
      {
        label: "Prolonged second stage of labour",
        value: "Prolonged second stage of labour",
      },
      {
        label: "Delayed delivery of successive neonates",
        value: "Delayed delivery of successive neonates",
      },
      { label: "Long labour, unspecified", value: "Long labour, unspecified" },
      {
        label:
          "Obstructed labour due to malposition or malpresentation of fetus",
        value:
          "Obstructed labour due to malposition or malpresentation of fetus",
      },
      {
        label: "Obstructed labour due to incomplete rotation of fetal head",
        value: "Obstructed labour due to incomplete rotation of fetal head",
      },
      {
        label: "Obstructed labour due to breech presentation",
        value: "Obstructed labour due to breech presentation",
      },
      {
        label: "Obstructed labour due to face presentation",
        value: "Obstructed labour due to face presentation",
      },
      {
        label: "Obstructed labour due to brow presentation",
        value: "Obstructed labour due to brow presentation",
      },
      {
        label: "Obstructed labour due to shoulder presentation",
        value: "Obstructed labour due to shoulder presentation",
      },
      {
        label: "Obstructed labour due to compound presentation",
        value: "Obstructed labour due to compound presentation",
      },
      {
        label:
          "Obstructed labour due to other malposition and malpresentation of fetus",
        value:
          "Obstructed labour due to other malposition and malpresentation of fetus",
      },
      {
        label:
          "Obstructed labour due to malposition or malpresentation of fetus, unspecified",
        value:
          "Obstructed labour due to malposition or malpresentation of fetus, unspecified",
      },
      {
        label: "Obstructed labour due to maternal pelvic abnormality",
        value: "Obstructed labour due to maternal pelvic abnormality",
      },
      {
        label: "Obstructed labour due to deformed pelvis",
        value: "Obstructed labour due to deformed pelvis",
      },
      {
        label: "Obstructed labour due to generally contracted pelvis",
        value: "Obstructed labour due to generally contracted pelvis",
      },
      {
        label: "Obstructed labour due to pelvic inlet contraction",
        value: "Obstructed labour due to pelvic inlet contraction",
      },
      {
        label:
          "Obstructed labour due to pelvic outlet or mid-cavity contraction",
        value:
          "Obstructed labour due to pelvic outlet or mid-cavity contraction",
      },
      {
        label:
          "Obstructed labour due to foetopelvic disproportion, unspecified",
        value:
          "Obstructed labour due to foetopelvic disproportion, unspecified",
      },
      {
        label: "Obstructed labour due to abnormality of maternal pelvic organs",
        value: "Obstructed labour due to abnormality of maternal pelvic organs",
      },
      {
        label: "Obstructed labour due to other maternal pelvic abnormalities",
        value: "Obstructed labour due to other maternal pelvic abnormalities",
      },
      {
        label:
          "Obstructed labour due to maternal pelvic abnormality, unspecified",
        value:
          "Obstructed labour due to maternal pelvic abnormality, unspecified",
      },
      {
        label: "Obstructed labour due to other causes",
        value: "Obstructed labour due to other causes",
      },
      {
        label: "Obstructed labour due to shoulder dystocia",
        value: "Obstructed labour due to shoulder dystocia",
      },
      {
        label: "Obstructed labour due to locked twins",
        value: "Obstructed labour due to locked twins",
      },
      {
        label: "Obstructed labour due to unusually large fetus",
        value: "Obstructed labour due to unusually large fetus",
      },
      {
        label: "Obstructed labour due to other abnormalities of fetus",
        value: "Obstructed labour due to other abnormalities of fetus",
      },
      {
        label: "Obstructed labour due to other specified causes",
        value: "Obstructed labour due to other specified causes",
      },
      {
        label: "Obstructed labour due to unspecified causes",
        value: "Obstructed labour due to unspecified causes",
      },
      {
        label: "Labour or delivery complicated by fetal distress",
        value: "Labour or delivery complicated by fetal distress",
      },
      {
        label: "Labour or delivery complicated by fetal heart rate anomaly",
        value: "Labour or delivery complicated by fetal heart rate anomaly",
      },
      {
        label: "Labour or delivery complicated by meconium in amniotic fluid",
        value: "Labour or delivery complicated by meconium in amniotic fluid",
      },
      {
        label:
          "Labour or delivery complicated by biochemical evidence of fetal stress",
        value:
          "Labour or delivery complicated by biochemical evidence of fetal stress",
      },
      {
        label:
          "Other specified labour or delivery complicated by fetal distress",
        value:
          "Other specified labour or delivery complicated by fetal distress",
      },
      {
        label: "Labour or delivery complicated by fetal distress, unspecified",
        value: "Labour or delivery complicated by fetal distress, unspecified",
      },
      {
        label: "Labour or delivery complicated by umbilical cord complications",
        value: "Labour or delivery complicated by umbilical cord complications",
      },
      {
        label: "Labour or delivery complicated by prolapse of cord",
        value: "Labour or delivery complicated by prolapse of cord",
      },
      {
        label:
          "Labour or delivery complicated by cord around neck, with compression",
        value:
          "Labour or delivery complicated by cord around neck, with compression",
      },
      {
        label: "Labour or delivery complicated by short cord",
        value: "Labour or delivery complicated by short cord",
      },
      {
        label: "Labour or delivery complicated by vasa praevia",
        value: "Labour or delivery complicated by vasa praevia",
      },
      {
        label: "Labour or delivery complicated by vascular lesion of cord",
        value: "Labour or delivery complicated by vascular lesion of cord",
      },
      {
        label:
          "Labour or delivery complicated by other cord entanglement, with compression",
        value:
          "Labour or delivery complicated by other cord entanglement, with compression",
      },
      {
        label:
          "Labour and delivery complicated by other specified umbilical cord complications",
        value:
          "Labour and delivery complicated by other specified umbilical cord complications",
      },
      {
        label:
          "Labour or delivery complicated by umbilical cord complications, unspecified",
        value:
          "Labour or delivery complicated by umbilical cord complications, unspecified",
      },
      {
        label: "Perineal laceration during delivery",
        value: "Perineal laceration during delivery",
      },
      {
        label: "First degree perineal laceration during delivery",
        value: "First degree perineal laceration during delivery",
      },
      {
        label: "Second degree perineal laceration during delivery",
        value: "Second degree perineal laceration during delivery",
      },
      {
        label: "Third degree perineal laceration during delivery",
        value: "Third degree perineal laceration during delivery",
      },
      {
        label: "Fourth degree perineal laceration during delivery",
        value: "Fourth degree perineal laceration during delivery",
      },
      {
        label: "Perineal laceration during delivery, unspecified",
        value: "Perineal laceration during delivery, unspecified",
      },
      {
        label: "Certain specified obstetric trauma",
        value: "Certain specified obstetric trauma",
      },
      {
        label: "Rupture of uterus before onset of labour",
        value: "Rupture of uterus before onset of labour",
      },
      {
        label: "Rupture of uterus during labour",
        value: "Rupture of uterus during labour",
      },
      {
        label: "Postpartum inversion of uterus",
        value: "Postpartum inversion of uterus",
      },
      {
        label: "Obstetric laceration of cervix",
        value: "Obstetric laceration of cervix",
      },
      {
        label: "Obstetric high vaginal laceration",
        value: "Obstetric high vaginal laceration",
      },
      {
        label: "Obstetric uterine laceration or tear",
        value: "Obstetric uterine laceration or tear",
      },
      {
        label: "Other obstetric injury to pelvic organs",
        value: "Other obstetric injury to pelvic organs",
      },
      {
        label: "Obstetric damage to pelvic joints or ligaments",
        value: "Obstetric damage to pelvic joints or ligaments",
      },
      {
        label: "Obstetric haematoma of pelvis",
        value: "Obstetric haematoma of pelvis",
      },
      {
        label: "Other specified obstetric trauma",
        value: "Other specified obstetric trauma",
      },
      {
        label: "Obstetric trauma, unspecified",
        value: "Obstetric trauma, unspecified",
      },
      {
        label: "Retained placenta or membranes, without haemorrhage",
        value: "Retained placenta or membranes, without haemorrhage",
      },
      {
        label: "Retained placenta without haemorrhage",
        value: "Retained placenta without haemorrhage",
      },
      {
        label:
          "Retained portions of placenta or membranes, without haemorrhage",
        value:
          "Retained portions of placenta or membranes, without haemorrhage",
      },
      {
        label: "Complications of anaesthesia during labour or delivery",
        value: "Complications of anaesthesia during labour or delivery",
      },
      {
        label:
          "Aspiration pneumonitis due to anaesthesia during labour or delivery",
        value:
          "Aspiration pneumonitis due to anaesthesia during labour or delivery",
      },
      {
        label:
          "Other pulmonary complications of anaesthesia during labour or delivery",
        value:
          "Other pulmonary complications of anaesthesia during labour or delivery",
      },
      {
        label: "Cardiac complications of anaesthesia during labour or delivery",
        value: "Cardiac complications of anaesthesia during labour or delivery",
      },
      {
        label:
          "Central nervous system complications of anaesthesia during labour or delivery",
        value:
          "Central nervous system complications of anaesthesia during labour or delivery",
      },
      {
        label: "Toxic reaction to local anaesthesia during labour or delivery",
        value: "Toxic reaction to local anaesthesia during labour or delivery",
      },
      {
        label:
          "Spinal or epidural anaesthesia-induced headache during labour or delivery",
        value:
          "Spinal or epidural anaesthesia-induced headache during labour or delivery",
      },
      {
        label:
          "Other complications of spinal or epidural anaesthesia during labour or delivery",
        value:
          "Other complications of spinal or epidural anaesthesia during labour or delivery",
      },
      {
        label: "Failed or difficult intubation during labour or delivery",
        value: "Failed or difficult intubation during labour or delivery",
      },
      {
        label: "Awareness under general anaesthesia during labour or delivery",
        value: "Awareness under general anaesthesia during labour or delivery",
      },
      {
        label:
          "Other specified complications of anaesthesia during labour or delivery",
        value:
          "Other specified complications of anaesthesia during labour or delivery",
      },
      {
        label:
          "Complications of anaesthesia during labour or delivery, unspecified",
        value:
          "Complications of anaesthesia during labour or delivery, unspecified",
      },
      {
        label:
          "Certain specified complications of labour or delivery, not elsewhere classified",
        value:
          "Certain specified complications of labour or delivery, not elsewhere classified",
      },
      {
        label: "Maternal distress during labour or delivery",
        value: "Maternal distress during labour or delivery",
      },
      {
        label: "Shock during or following labour or delivery",
        value: "Shock during or following labour or delivery",
      },
      {
        label: "Pyrexia during labour, not elsewhere classified",
        value: "Pyrexia during labour, not elsewhere classified",
      },
      {
        label: "Other complications of obstetric surgery or procedures",
        value: "Other complications of obstetric surgery or procedures",
      },
      {
        label: "Delayed delivery after artificial rupture of membranes",
        value: "Delayed delivery after artificial rupture of membranes",
      },
      {
        label:
          "Delayed delivery after spontaneous or unspecified rupture of membranes",
        value:
          "Delayed delivery after spontaneous or unspecified rupture of membranes",
      },
      {
        label: "Vaginal delivery following previous caesarean section",
        value: "Vaginal delivery following previous caesarean section",
      },
      {
        label: "Failed application of vacuum extractor or forceps, unspecified",
        value: "Failed application of vacuum extractor or forceps, unspecified",
      },
      {
        label: "Failed trial of labour, unspecified",
        value: "Failed trial of labour, unspecified",
      },
      {
        label:
          "Other specified complications of labour or delivery, not elsewhere classified",
        value:
          "Other specified complications of labour or delivery, not elsewhere classified",
      },
      {
        label: "Other specified complications of labour or delivery",
        value: "Other specified complications of labour or delivery",
      },
      {
        label: "Complications of labour or delivery, unspecified",
        value: "Complications of labour or delivery, unspecified",
      },
      { label: "Delivery", value: "Delivery" },
      {
        label: "Single spontaneous delivery",
        value: "Single spontaneous delivery",
      },
      {
        label: "Spontaneous vertex delivery",
        value: "Spontaneous vertex delivery",
      },
      {
        label: "Spontaneous breech delivery",
        value: "Spontaneous breech delivery",
      },
      {
        label: "Single spontaneous delivery with other specified presentation",
        value: "Single spontaneous delivery with other specified presentation",
      },
      {
        label: "Single spontaneous delivery, unspecified",
        value: "Single spontaneous delivery, unspecified",
      },
      {
        label: "Single delivery by forceps or vacuum extractor",
        value: "Single delivery by forceps or vacuum extractor",
      },
      {
        label: "Single delivery by caesarean section",
        value: "Single delivery by caesarean section",
      },
      {
        label: "Delivery by elective caesarean section",
        value: "Delivery by elective caesarean section",
      },
      {
        label: "Delivery by emergency caesarean section",
        value: "Delivery by emergency caesarean section",
      },
      {
        label: "Single delivery by caesarean hysterectomy",
        value: "Single delivery by caesarean hysterectomy",
      },
      {
        label: "Single delivery by caesarean section, unspecified",
        value: "Single delivery by caesarean section, unspecified",
      },
      {
        label: "Other assisted single delivery",
        value: "Other assisted single delivery",
      },
      { label: "Breech extraction", value: "Breech extraction" },
      {
        label: "Other assisted breech delivery",
        value: "Other assisted breech delivery",
      },
      {
        label: "Other manipulation-assisted delivery",
        value: "Other manipulation-assisted delivery",
      },
      {
        label: "Delivery of viable fetus in abdominal pregnancy",
        value: "Delivery of viable fetus in abdominal pregnancy",
      },
      {
        label: "Destructive operation for delivery",
        value: "Destructive operation for delivery",
      },
      {
        label: "Other assisted single delivery, unspecified",
        value: "Other assisted single delivery, unspecified",
      },
      { label: "Multiple delivery", value: "Multiple delivery" },
      {
        label: "Multiple delivery, all spontaneous",
        value: "Multiple delivery, all spontaneous",
      },
      {
        label: "Multiple delivery, all by forceps or vacuum extractor",
        value: "Multiple delivery, all by forceps or vacuum extractor",
      },
      {
        label: "Multiple delivery, all by caesarean section",
        value: "Multiple delivery, all by caesarean section",
      },
      {
        label: "Multiple delivery by combination of methods with caesarean",
        value: "Multiple delivery by combination of methods with caesarean",
      },
      {
        label: "Other specified multiple delivery",
        value: "Other specified multiple delivery",
      },
      {
        label: "Multiple delivery, unspecified",
        value: "Multiple delivery, unspecified",
      },
      { label: "Delivery, unspecified", value: "Delivery, unspecified" },
      {
        label: "Complications predominantly related to the puerperium",
        value: "Complications predominantly related to the puerperium",
      },
      {
        label: "Infections in the puerperium",
        value: "Infections in the puerperium",
      },
      { label: "Puerperal sepsis", value: "Puerperal sepsis" },
      {
        label: "Infection of obstetric surgical wound",
        value: "Infection of obstetric surgical wound",
      },
      {
        label: "Other infection of genital tract following delivery",
        value: "Other infection of genital tract following delivery",
      },
      {
        label: "Urinary tract infection following delivery",
        value: "Urinary tract infection following delivery",
      },
      {
        label: "Pyrexia of unknown origin following delivery",
        value: "Pyrexia of unknown origin following delivery",
      },
      {
        label: "Other specified infections in the puerperium",
        value: "Other specified infections in the puerperium",
      },
      {
        label: "Infections in the puerperium, unspecified",
        value: "Infections in the puerperium, unspecified",
      },
      {
        label: "Venous complications in the puerperium",
        value: "Venous complications in the puerperium",
      },
      {
        label: "Superficial thrombophlebitis in the puerperium",
        value: "Superficial thrombophlebitis in the puerperium",
      },
      {
        label: "Deep phlebothrombosis in the puerperium",
        value: "Deep phlebothrombosis in the puerperium",
      },
      {
        label: "Haemorrhoids in the puerperium",
        value: "Haemorrhoids in the puerperium",
      },
      {
        label: "Cerebral venous thrombosis in the puerperium",
        value: "Cerebral venous thrombosis in the puerperium",
      },
      {
        label: "Other specified venous complications in the puerperium",
        value: "Other specified venous complications in the puerperium",
      },
      {
        label: "Venous complications in the puerperium, unspecified",
        value: "Venous complications in the puerperium, unspecified",
      },
      { label: "Obstetric embolism", value: "Obstetric embolism" },
      { label: "Obstetric air embolism", value: "Obstetric air embolism" },
      { label: "Amniotic fluid embolism", value: "Amniotic fluid embolism" },
      {
        label: "Obstetric blood-clot embolism",
        value: "Obstetric blood-clot embolism",
      },
      {
        label: "Obstetric pyaemic or septic embolism",
        value: "Obstetric pyaemic or septic embolism",
      },
      {
        label: "Other specified obstetric embolism",
        value: "Other specified obstetric embolism",
      },
      {
        label: "Obstetric embolism, unspecified",
        value: "Obstetric embolism, unspecified",
      },
      {
        label: "Complications of anaesthesia during the puerperium",
        value: "Complications of anaesthesia during the puerperium",
      },
      {
        label: "Pulmonary complications of anaesthesia during the puerperium",
        value: "Pulmonary complications of anaesthesia during the puerperium",
      },
      {
        label: "Cardiac complications of anaesthesia during the puerperium",
        value: "Cardiac complications of anaesthesia during the puerperium",
      },
      {
        label:
          "Central nervous system complications of anaesthesia during the puerperium",
        value:
          "Central nervous system complications of anaesthesia during the puerperium",
      },
      {
        label:
          "Spinal or epidural anaesthesia-induced headache during the puerperium",
        value:
          "Spinal or epidural anaesthesia-induced headache during the puerperium",
      },
      {
        label:
          "Other complications of spinal or epidural anaesthesia during the puerperium",
        value:
          "Other complications of spinal or epidural anaesthesia during the puerperium",
      },
      {
        label: "Failed or difficult intubation during the puerperium",
        value: "Failed or difficult intubation during the puerperium",
      },
      {
        label: "Awareness under general anaesthesia during the puerperium",
        value: "Awareness under general anaesthesia during the puerperium",
      },
      {
        label:
          "Other specified complications of anaesthesia during the puerperium",
        value:
          "Other specified complications of anaesthesia during the puerperium",
      },
      {
        label:
          "Complications of anaesthesia during the puerperium, unspecified",
        value:
          "Complications of anaesthesia during the puerperium, unspecified",
      },
      {
        label: "Certain specified complications of the puerperium",
        value: "Certain specified complications of the puerperium",
      },
      {
        label: "Disruption of caesarean section wound",
        value: "Disruption of caesarean section wound",
      },
      {
        label: "Disruption of perineal obstetric wound",
        value: "Disruption of perineal obstetric wound",
      },
      {
        label: "Haematoma of obstetric wound",
        value: "Haematoma of obstetric wound",
      },
      {
        label: "Cardiomyopathy in the puerperium",
        value: "Cardiomyopathy in the puerperium",
      },
      {
        label: "Postpartum acute renal failure",
        value: "Postpartum acute renal failure",
      },
      { label: "Postpartum thyroiditis", value: "Postpartum thyroiditis" },
      { label: "Puerperal osteomalacia", value: "Puerperal osteomalacia" },
      {
        label: "Other specified complications of the puerperium",
        value: "Other specified complications of the puerperium",
      },
      {
        label: "Complications of the puerperium, unspecified",
        value: "Complications of the puerperium, unspecified",
      },
      {
        label: "Infections of breast associated with childbirth",
        value: "Infections of breast associated with childbirth",
      },
      {
        label: "Abscess of breast associated with childbirth",
        value: "Abscess of breast associated with childbirth",
      },
      {
        label: "Nonpurulent mastitis associated with childbirth",
        value: "Nonpurulent mastitis associated with childbirth",
      },
      {
        label:
          "Other specified infections of breast associated with childbirth",
        value:
          "Other specified infections of breast associated with childbirth",
      },
      {
        label: "Infections of breast associated with childbirth, unspecified",
        value: "Infections of breast associated with childbirth, unspecified",
      },
      {
        label:
          "Certain specified disorders of breast or lactation associated with childbirth",
        value:
          "Certain specified disorders of breast or lactation associated with childbirth",
      },
      {
        label: "Retracted nipple associated with childbirth",
        value: "Retracted nipple associated with childbirth",
      },
      {
        label: "Cracked nipple associated with childbirth",
        value: "Cracked nipple associated with childbirth",
      },
      {
        label:
          "Other or unspecified disorders of breast associated with childbirth",
        value:
          "Other or unspecified disorders of breast associated with childbirth",
      },
      { label: "Agalactia", value: "Agalactia" },
      { label: "Hypogalactia", value: "Hypogalactia" },
      { label: "Suppressed lactation", value: "Suppressed lactation" },
      { label: "Galactorrhoea", value: "Galactorrhoea" },
      {
        label: "Other or unspecified disorders of lactation",
        value: "Other or unspecified disorders of lactation",
      },
      {
        label:
          "Complications predominantly related to the puerperium, unspecified",
        value:
          "Complications predominantly related to the puerperium, unspecified",
      },
      {
        label: "Certain obstetric conditions, not elsewhere classified",
        value: "Certain obstetric conditions, not elsewhere classified",
      },
      {
        label: "Obstetric death of unspecified cause",
        value: "Obstetric death of unspecified cause",
      },
      {
        label:
          "Death from any obstetric cause occurring more than 42 days but less than one year after delivery",
        value:
          "Death from any obstetric cause occurring more than 42 days but less than one year after delivery",
      },
      {
        label: "Death from sequelae of obstetric causes",
        value: "Death from sequelae of obstetric causes",
      },
      {
        label: "Death from sequelae of direct obstetric cause",
        value: "Death from sequelae of direct obstetric cause",
      },
      {
        label: "Death from sequelae of indirect obstetric cause",
        value: "Death from sequelae of indirect obstetric cause",
      },
      {
        label: "Death from sequelae of obstetric causes, unspecified",
        value: "Death from sequelae of obstetric causes, unspecified",
      },
      {
        label:
          "Maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
        value:
          "Maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Tuberculosis complicating pregnancy, childbirth or the puerperium",
        value:
          "Tuberculosis complicating pregnancy, childbirth or the puerperium",
      },
      { label: "Tuberculous placenta", value: "Tuberculous placenta" },
      {
        label:
          "Other specified tuberculosis complicating pregnancy, childbirth or the puerperium",
        value:
          "Other specified tuberculosis complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Tuberculosis complicating pregnancy, childbirth or the puerperium, unspecified",
        value:
          "Tuberculosis complicating pregnancy, childbirth or the puerperium, unspecified",
      },
      {
        label: "Syphilis complicating pregnancy, childbirth or the puerperium",
        value: "Syphilis complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Gonorrhoea complicating pregnancy, childbirth or the puerperium",
        value:
          "Gonorrhoea complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Other infections with a predominantly sexual mode of transmission complicating pregnancy, childbirth or the puerperium",
        value:
          "Other infections with a predominantly sexual mode of transmission complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Viral hepatitis complicating pregnancy, childbirth or the puerperium",
        value:
          "Viral hepatitis complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Other viral diseases complicating pregnancy, childbirth or the puerperium",
        value:
          "Other viral diseases complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Protozoal diseases complicating pregnancy, childbirth or the puerperium",
        value:
          "Protozoal diseases complicating pregnancy, childbirth or the puerperium",
      },
      {
        label: "Malaria complicating pregnancy, childbirth, or the puerperium",
        value: "Malaria complicating pregnancy, childbirth, or the puerperium",
      },
      {
        label:
          "Other specified protozoal diseases complicating pregnancy, childbirth or the puerperium",
        value:
          "Other specified protozoal diseases complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Protozoal diseases complicating pregnancy, childbirth or the puerperium, unspecified",
        value:
          "Protozoal diseases complicating pregnancy, childbirth or the puerperium, unspecified",
      },
      {
        label:
          "Human immunodeficiency disease complicating pregnancy, childbirth or the puerperium",
        value:
          "Human immunodeficiency disease complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Other specified maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
        value:
          "Other specified maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium, unspecified",
        value:
          "Maternal infectious diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium, unspecified",
      },
      {
        label:
          "Certain maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
        value:
          "Certain maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
      },
      {
        label: "Anaemia complicating pregnancy, childbirth or the puerperium",
        value: "Anaemia complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Other diseases of the blood or blood-forming organs or certain disorders involving the immune mechanism complicating pregnancy, childbirth or the puerperium",
        value:
          "Other diseases of the blood or blood-forming organs or certain disorders involving the immune mechanism complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Endocrine, nutritional or metabolic diseases complicating pregnancy, childbirth or the puerperium",
        value:
          "Endocrine, nutritional or metabolic diseases complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Diseases of the nervous system complicating pregnancy, childbirth or the puerperium",
        value:
          "Diseases of the nervous system complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Diseases of the circulatory system complicating pregnancy, childbirth or the puerperium",
        value:
          "Diseases of the circulatory system complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Diseases of the respiratory system complicating pregnancy, childbirth or the puerperium",
        value:
          "Diseases of the respiratory system complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Diseases of the digestive system complicating pregnancy, childbirth or the puerperium",
        value:
          "Diseases of the digestive system complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Diseases of the skin complicating pregnancy, childbirth or the puerperium",
        value:
          "Diseases of the skin complicating pregnancy, childbirth or the puerperium",
      },
      {
        label: "Congenital anomaly complicating pregnancy",
        value: "Congenital anomaly complicating pregnancy",
      },
      {
        label:
          "Other specified maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
        value:
          "Other specified maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium",
      },
      {
        label:
          "Maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium, unspecified",
        value:
          "Maternal diseases classifiable elsewhere but complicating pregnancy, childbirth or the puerperium, unspecified",
      },
      {
        label:
          "Sequelae of complication of pregnancy, childbirth or the puerperium",
        value:
          "Sequelae of complication of pregnancy, childbirth or the puerperium",
      },
      {
        label: "Other specified obstetric conditions, not elsewhere classified",
        value: "Other specified obstetric conditions, not elsewhere classified",
      },
      {
        label: "Unspecified obstetric condition",
        value: "Unspecified obstetric condition",
      },
      {
        label: "Certain conditions originating in the perinatal period",
        value: "Certain conditions originating in the perinatal period",
      },
      {
        label:
          "Fetus or newborn affected by maternal factors or by complications of pregnancy, labour or delivery",
        value:
          "Fetus or newborn affected by maternal factors or by complications of pregnancy, labour or delivery",
      },
      {
        label:
          "Fetus or newborn affected by maternal conditions that may be unrelated to present pregnancy",
        value:
          "Fetus or newborn affected by maternal conditions that may be unrelated to present pregnancy",
      },
      {
        label: "Fetus or newborn affected by maternal hypertensive disorders",
        value: "Fetus or newborn affected by maternal hypertensive disorders",
      },
      {
        label:
          "Fetus or newborn affected by gestational oedema or proteinuria without hypertension",
        value:
          "Fetus or newborn affected by gestational oedema or proteinuria without hypertension",
      },
      {
        label:
          "Fetus or newborn affected by maternal renal or urinary tract diseases",
        value:
          "Fetus or newborn affected by maternal renal or urinary tract diseases",
      },
      {
        label: "Fetus or newborn affected by maternal infectious diseases",
        value: "Fetus or newborn affected by maternal infectious diseases",
      },
      {
        label: "Fetus or newborn affected by periodontal disease in mother",
        value: "Fetus or newborn affected by periodontal disease in mother",
      },
      {
        label: "Fetus or newborn affected by maternal respiratory diseases",
        value: "Fetus or newborn affected by maternal respiratory diseases",
      },
      {
        label: "Fetus or newborn affected by maternal nutritional disorders",
        value: "Fetus or newborn affected by maternal nutritional disorders",
      },
      {
        label: "Fetus or newborn affected by maternal malnutrition",
        value: "Fetus or newborn affected by maternal malnutrition",
      },
      {
        label: "Fetus or newborn affected by maternal overweight or obesity",
        value: "Fetus or newborn affected by maternal overweight or obesity",
      },
      {
        label:
          "Other specified fetus or newborn affected by maternal nutritional disorders",
        value:
          "Other specified fetus or newborn affected by maternal nutritional disorders",
      },
      {
        label:
          "Fetus or newborn affected by maternal nutritional disorders, unspecified",
        value:
          "Fetus or newborn affected by maternal nutritional disorders, unspecified",
      },
      {
        label: "Fetus or newborn affected by abnormal maternal chemistry",
        value: "Fetus or newborn affected by abnormal maternal chemistry",
      },
      {
        label: "Fetus or newborn affected by maternal injury",
        value: "Fetus or newborn affected by maternal injury",
      },
      {
        label: "Fetus or newborn affected by maternal chemotherapy",
        value: "Fetus or newborn affected by maternal chemotherapy",
      },
      {
        label: "Fetus or newborn affected by surgical procedure on mother",
        value: "Fetus or newborn affected by surgical procedure on mother",
      },
      {
        label: "Fetus or newborn affected by maternal anaemia",
        value: "Fetus or newborn affected by maternal anaemia",
      },
      {
        label:
          "Foetus or newborn affected by other specified maternal condition that may be unrelated to present pregnancy",
        value:
          "Foetus or newborn affected by other specified maternal condition that may be unrelated to present pregnancy",
      },
      {
        label:
          "Foetus or newborn affected by unspecified maternal condition that may be unrelated to present pregnancy",
        value:
          "Foetus or newborn affected by unspecified maternal condition that may be unrelated to present pregnancy",
      },
      {
        label:
          "Fetus or newborn affected by maternal complications of pregnancy",
        value:
          "Fetus or newborn affected by maternal complications of pregnancy",
      },
      {
        label: "Fetus or newborn affected by incompetence of cervix uteri",
        value: "Fetus or newborn affected by incompetence of cervix uteri",
      },
      {
        label: "Fetus or newborn affected by premature rupture of membranes",
        value: "Fetus or newborn affected by premature rupture of membranes",
      },
      {
        label: "Fetus or newborn affected by oligohydramnios",
        value: "Fetus or newborn affected by oligohydramnios",
      },
      {
        label: "Fetus or newborn affected by polyhydramnios",
        value: "Fetus or newborn affected by polyhydramnios",
      },
      {
        label: "Fetus or newborn affected by ectopic pregnancy",
        value: "Fetus or newborn affected by ectopic pregnancy",
      },
      {
        label: "Fetus or newborn affected by multiple pregnancy",
        value: "Fetus or newborn affected by multiple pregnancy",
      },
      {
        label: "Fetus or newborn affected by maternal death",
        value: "Fetus or newborn affected by maternal death",
      },
      {
        label: "Fetus or newborn affected by malpresentation before labour",
        value: "Fetus or newborn affected by malpresentation before labour",
      },
      {
        label: "Fetus or newborn affected by maternal blood loss",
        value: "Fetus or newborn affected by maternal blood loss",
      },
      {
        label:
          "Foetus or newborn affected by other specified maternal complication of pregnancy",
        value:
          "Foetus or newborn affected by other specified maternal complication of pregnancy",
      },
      {
        label:
          "Foetus or newborn affected by unspecified maternal complication of pregnancy",
        value:
          "Foetus or newborn affected by unspecified maternal complication of pregnancy",
      },
      {
        label: "Fetus or newborn affected by complications of placenta",
        value: "Fetus or newborn affected by complications of placenta",
      },
      {
        label: "Fetus or newborn affected by placenta praevia",
        value: "Fetus or newborn affected by placenta praevia",
      },
      {
        label:
          "Fetus or newborn affected by placental oedema or large placenta",
        value:
          "Fetus or newborn affected by placental oedema or large placenta",
      },
      {
        label: "Fetus or newborn affected by placental infarction",
        value: "Fetus or newborn affected by placental infarction",
      },
      {
        label:
          "Fetus or newborn affected by placental insufficiency or small placenta",
        value:
          "Fetus or newborn affected by placental insufficiency or small placenta",
      },
      {
        label: "Fetus or newborn affected by placental transfusion syndromes",
        value: "Fetus or newborn affected by placental transfusion syndromes",
      },
      {
        label:
          "Foetus or newborn affected by other specified complication of placenta",
        value:
          "Foetus or newborn affected by other specified complication of placenta",
      },
      {
        label:
          "Foetus or newborn affected by unspecified complication of placenta",
        value:
          "Foetus or newborn affected by unspecified complication of placenta",
      },
      {
        label: "Fetus or newborn affected by complications of umbilical cord",
        value: "Fetus or newborn affected by complications of umbilical cord",
      },
      {
        label: "Fetus or newborn affected by prolapsed cord",
        value: "Fetus or newborn affected by prolapsed cord",
      },
      {
        label:
          "Fetus or newborn affected by other compression of umbilical cord",
        value:
          "Fetus or newborn affected by other compression of umbilical cord",
      },
      {
        label:
          "Fetus or newborn affected by abnormalities of umbilical cord length",
        value:
          "Fetus or newborn affected by abnormalities of umbilical cord length",
      },
      {
        label: "Fetus or newborn affected by short umbilical cord",
        value: "Fetus or newborn affected by short umbilical cord",
      },
      {
        label: "Fetus or newborn affected by long umbilical cord",
        value: "Fetus or newborn affected by long umbilical cord",
      },
      {
        label:
          "Other specified fetus or newborn affected by abnormalities of umbilical cord length",
        value:
          "Other specified fetus or newborn affected by abnormalities of umbilical cord length",
      },
      {
        label:
          "Fetus or newborn affected by abnormalities of umbilical cord length, unspecified",
        value:
          "Fetus or newborn affected by abnormalities of umbilical cord length, unspecified",
      },
      {
        label: "Fetus or newborn affected by vasa praevia",
        value: "Fetus or newborn affected by vasa praevia",
      },
      {
        label:
          "Fetus or newborn affected by traumatic injury of the umbilical cord",
        value:
          "Fetus or newborn affected by traumatic injury of the umbilical cord",
      },
      {
        label:
          "Foetus or newborn affected by other specified complication of umbilical cord",
        value:
          "Foetus or newborn affected by other specified complication of umbilical cord",
      },
      {
        label:
          "Foetus or newborn affected by unspecified complication of umbilical cord",
        value:
          "Foetus or newborn affected by unspecified complication of umbilical cord",
      },
      {
        label: "Fetus or newborn affected by other abnormalities of membranes",
        value: "Fetus or newborn affected by other abnormalities of membranes",
      },
      {
        label: "Fetus or newborn affected by chorioamnionitis",
        value: "Fetus or newborn affected by chorioamnionitis",
      },
      {
        label: "Fetus or newborn affected by amniotic Band Syndrome",
        value: "Fetus or newborn affected by amniotic Band Syndrome",
      },
      {
        label:
          "Foetus or newborn affected by other specified abnormality of membranes",
        value:
          "Foetus or newborn affected by other specified abnormality of membranes",
      },
      {
        label:
          "Foetus or newborn affected by unspecified abnormality of membranes",
        value:
          "Foetus or newborn affected by unspecified abnormality of membranes",
      },
      {
        label:
          "Fetus or newborn affected by certain complications of labour or delivery",
        value:
          "Fetus or newborn affected by certain complications of labour or delivery",
      },
      {
        label: "Fetus or newborn affected by breech delivery or extraction",
        value: "Fetus or newborn affected by breech delivery or extraction",
      },
      {
        label:
          "Fetus or newborn affected by other malpresentation, malposition or disproportion during labour or delivery",
        value:
          "Fetus or newborn affected by other malpresentation, malposition or disproportion during labour or delivery",
      },
      {
        label: "Fetus or newborn affected by forceps delivery",
        value: "Fetus or newborn affected by forceps delivery",
      },
      {
        label: "Fetus or newborn affected by delivery by vacuum extractor",
        value: "Fetus or newborn affected by delivery by vacuum extractor",
      },
      {
        label: "Fetus or newborn affected by caesarean delivery",
        value: "Fetus or newborn affected by caesarean delivery",
      },
      {
        label: "Fetus or newborn affected by precipitate delivery",
        value: "Fetus or newborn affected by precipitate delivery",
      },
      {
        label: "Fetus or newborn affected by abnormal uterine contractions",
        value: "Fetus or newborn affected by abnormal uterine contractions",
      },
      {
        label:
          "Fetus or newborn affected by abnormality in fetal intrauterine heart rate or rhythm",
        value:
          "Fetus or newborn affected by abnormality in fetal intrauterine heart rate or rhythm",
      },
      {
        label:
          "Fetus and newborn affected by abnormality in fetal intrauterine heart rate or rhythm before onset of labour",
        value:
          "Fetus and newborn affected by abnormality in fetal intrauterine heart rate or rhythm before onset of labour",
      },
      {
        label:
          "Fetus and newborn affected by abnormality in fetal intrauterine heart rate or rhythm during labour",
        value:
          "Fetus and newborn affected by abnormality in fetal intrauterine heart rate or rhythm during labour",
      },
      {
        label:
          "Fetus or newborn affected by abnormality in fetal intrauterine heart rate or rhythm, unspecified",
        value:
          "Fetus or newborn affected by abnormality in fetal intrauterine heart rate or rhythm, unspecified",
      },
      {
        label: "Meconium passage during delivery",
        value: "Meconium passage during delivery",
      },
      {
        label:
          "Fetus or newborn affected or suspected to be affected by other specified complications of labour or delivery",
        value:
          "Fetus or newborn affected or suspected to be affected by other specified complications of labour or delivery",
      },
      {
        label:
          "Fetus or newborn affected or suspected to be affected by unspecified complications of labour or delivery",
        value:
          "Fetus or newborn affected or suspected to be affected by unspecified complications of labour or delivery",
      },
      {
        label:
          "Fetus or newborn affected by noxious influences transmitted via placenta or breast milk",
        value:
          "Fetus or newborn affected by noxious influences transmitted via placenta or breast milk",
      },
      {
        label:
          "Fetus or newborn affected by maternal anaesthesia or analgesia in pregnancy, labour or delivery",
        value:
          "Fetus or newborn affected by maternal anaesthesia or analgesia in pregnancy, labour or delivery",
      },
      {
        label: "Fetus or newborn affected by maternal use of tobacco",
        value: "Fetus or newborn affected by maternal use of tobacco",
      },
      {
        label: "Fetus or newborn affected by maternal use of alcohol",
        value: "Fetus or newborn affected by maternal use of alcohol",
      },
      {
        label:
          "Fetus or newborn affected by maternal use of drugs of addiction",
        value:
          "Fetus or newborn affected by maternal use of drugs of addiction",
      },
      {
        label:
          "Fetus or newborn affected by maternal use of nutritional chemical substances",
        value:
          "Fetus or newborn affected by maternal use of nutritional chemical substances",
      },
      {
        label:
          "Fetus or newborn affected by maternal exposure to environmental chemical substances",
        value:
          "Fetus or newborn affected by maternal exposure to environmental chemical substances",
      },
      {
        label:
          "Foetus or newborn affected by other specified noxious influence transmitted via placenta or breast milk",
        value:
          "Foetus or newborn affected by other specified noxious influence transmitted via placenta or breast milk",
      },
      {
        label:
          "Foetus or newborn affected by unspecified noxious influence transmitted via placenta or breast milk",
        value:
          "Foetus or newborn affected by unspecified noxious influence transmitted via placenta or breast milk",
      },
      {
        label: "Neonatal dermatoses due to maternal antibodies",
        value: "Neonatal dermatoses due to maternal antibodies",
      },
      {
        label: "Neonatal lupus erythematosus",
        value: "Neonatal lupus erythematosus",
      },
      { label: "Neonatal pemphigus", value: "Neonatal pemphigus" },
      {
        label: "Other specified neonatal dermatoses due to maternal antibodies",
        value: "Other specified neonatal dermatoses due to maternal antibodies",
      },
      {
        label:
          "Fetus or newborn affected by unspecified maternal factors or by complications of pregnancy, labour or delivery",
        value:
          "Fetus or newborn affected by unspecified maternal factors or by complications of pregnancy, labour or delivery",
      },
      {
        label:
          "Disorders of newborn related to length of gestation or fetal growth",
        value:
          "Disorders of newborn related to length of gestation or fetal growth",
      },
      {
        label:
          "Disorders of newborn related to slow fetal growth or fetal malnutrition",
        value:
          "Disorders of newborn related to slow fetal growth or fetal malnutrition",
      },
      {
        label: "Small for gestational age",
        value: "Small for gestational age",
      },
      {
        label: "Small for gestational age, symmetrical",
        value: "Small for gestational age, symmetrical",
      },
      {
        label: "Small for gestational age, asymmetrical",
        value: "Small for gestational age, asymmetrical",
      },
      {
        label: "Small for gestational age, unspecified",
        value: "Small for gestational age, unspecified",
      },
      {
        label: "Intrauterine growth restriction",
        value: "Intrauterine growth restriction",
      },
      {
        label: "Asymmetrical intrauterine growth restriction",
        value: "Asymmetrical intrauterine growth restriction",
      },
      {
        label: "Symmetrical intrauterine growth restriction",
        value: "Symmetrical intrauterine growth restriction",
      },
      {
        label:
          "Intrauterine growth restriction associated with small for gestational age",
        value:
          "Intrauterine growth restriction associated with small for gestational age",
      },
      {
        label: "Other specified intrauterine growth restriction",
        value: "Other specified intrauterine growth restriction",
      },
      {
        label: "Intrauterine growth restriction, unspecified",
        value: "Intrauterine growth restriction, unspecified",
      },
      {
        label:
          "Fetal intrauterine malnutrition without mention of small for gestational age",
        value:
          "Fetal intrauterine malnutrition without mention of small for gestational age",
      },
      {
        label:
          "Other specified disorders of newborn related to slow fetal growth or fetal malnutrition",
        value:
          "Other specified disorders of newborn related to slow fetal growth or fetal malnutrition",
      },
      {
        label:
          "Disorders of newborn related to slow fetal growth or fetal malnutrition, unspecified",
        value:
          "Disorders of newborn related to slow fetal growth or fetal malnutrition, unspecified",
      },
      {
        label:
          "Disorders of newborn related to short gestation or low birth weight, not elsewhere classified",
        value:
          "Disorders of newborn related to short gestation or low birth weight, not elsewhere classified",
      },
      {
        label: "Extremely low birth weight of newborn",
        value: "Extremely low birth weight of newborn",
      },
      {
        label: "Extremely low birth weight of newborn, 499g or less",
        value: "Extremely low birth weight of newborn, 499g or less",
      },
      {
        label: "Extremely low birth weight of newborn, 500-749g",
        value: "Extremely low birth weight of newborn, 500-749g",
      },
      {
        label: "Extremely low birth weight of newborn, 750-999g",
        value: "Extremely low birth weight of newborn, 750-999g",
      },
      {
        label: "Extremely low birth weight of newborn, unspecified",
        value: "Extremely low birth weight of newborn, unspecified",
      },
      {
        label: "Very low birth weight of newborn",
        value: "Very low birth weight of newborn",
      },
      {
        label: "Very low birth weight of newborn, 1000-1249g",
        value: "Very low birth weight of newborn, 1000-1249g",
      },
      {
        label: "Very low birth weight of newborn, 1250-1499g",
        value: "Very low birth weight of newborn, 1250-1499g",
      },
      {
        label: "Very low birth weight of newborn, unspecified",
        value: "Very low birth weight of newborn, unspecified",
      },
      {
        label: "Low birth weight of newborn",
        value: "Low birth weight of newborn",
      },
      {
        label: "Low birth weight of newborn, 1500-1999g",
        value: "Low birth weight of newborn, 1500-1999g",
      },
      {
        label: "Low birth weight of newborn, 2000-2499g",
        value: "Low birth weight of newborn, 2000-2499g",
      },
      {
        label: "Low birth weight of newborn, unspecified",
        value: "Low birth weight of newborn, unspecified",
      },
      {
        label: "Extreme prematurity of newborn",
        value: "Extreme prematurity of newborn",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age less than 22 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age less than 22 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 22 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 22 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 23 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 23 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 24 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 24 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 25 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 25 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 26 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 26 completed weeks",
      },
      {
        label:
          "Extreme prematurity of newborn, gestational age 27 completed weeks",
        value:
          "Extreme prematurity of newborn, gestational age 27 completed weeks",
      },
      {
        label: "Extreme prematurity of newborn, unspecified",
        value: "Extreme prematurity of newborn, unspecified",
      },
      { label: "Preterm newborn", value: "Preterm newborn" },
      {
        label: "Preterm newborn, gestational age 28 completed weeks",
        value: "Preterm newborn, gestational age 28 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 29 completed weeks",
        value: "Preterm newborn, gestational age 29 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 30 completed weeks",
        value: "Preterm newborn, gestational age 30 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 31 completed weeks",
        value: "Preterm newborn, gestational age 31 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 32 completed weeks",
        value: "Preterm newborn, gestational age 32 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 33 completed weeks",
        value: "Preterm newborn, gestational age 33 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 34 completed weeks",
        value: "Preterm newborn, gestational age 34 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 35 completed weeks",
        value: "Preterm newborn, gestational age 35 completed weeks",
      },
      {
        label: "Preterm newborn, gestational age 36 completed weeks",
        value: "Preterm newborn, gestational age 36 completed weeks",
      },
      {
        label: "Preterm newborn, unspecified",
        value: "Preterm newborn, unspecified",
      },
      {
        label:
          "Disorders of newborn related to long gestation or high birth weight",
        value:
          "Disorders of newborn related to long gestation or high birth weight",
      },
      {
        label: "Exceptionally large newborn",
        value: "Exceptionally large newborn",
      },
      {
        label: "Large newborn for gestational age",
        value: "Large newborn for gestational age",
      },
      { label: "Post-term newborn", value: "Post-term newborn" },
      { label: "Postmaturity syndrome", value: "Postmaturity syndrome" },
      {
        label:
          "Other specified disorders of newborn related to length of gestation or fetal growth",
        value:
          "Other specified disorders of newborn related to length of gestation or fetal growth",
      },
      {
        label:
          "Disorders of newborn related to length of gestation or fetal growth, unspecified",
        value:
          "Disorders of newborn related to length of gestation or fetal growth, unspecified",
      },
      { label: "Birth injury", value: "Birth injury" },
      {
        label: "Birth injury to central nervous system",
        value: "Birth injury to central nervous system",
      },
      {
        label: "Intracranial laceration or haemorrhage due to birth injury",
        value: "Intracranial laceration or haemorrhage due to birth injury",
      },
      {
        label: "Subdural haemorrhage due to birth injury",
        value: "Subdural haemorrhage due to birth injury",
      },
      {
        label: "Cerebral haemorrhage due to birth injury",
        value: "Cerebral haemorrhage due to birth injury",
      },
      {
        label: "Cerebellar haemorrhage due to birth injury",
        value: "Cerebellar haemorrhage due to birth injury",
      },
      {
        label: "Intraventricular haemorrhage due to birth injury",
        value: "Intraventricular haemorrhage due to birth injury",
      },
      {
        label: "Subarachnoid haemorrhage due to birth injury",
        value: "Subarachnoid haemorrhage due to birth injury",
      },
      {
        label: "Tentorial tear due to birth injury",
        value: "Tentorial tear due to birth injury",
      },
      {
        label: "Cerebellar contusion due to birth injury",
        value: "Cerebellar contusion due to birth injury",
      },
      {
        label: "Cerebral contusion due to birth injury",
        value: "Cerebral contusion due to birth injury",
      },
      {
        label: "Extradural or epidural haemorrhage due to birth injury",
        value: "Extradural or epidural haemorrhage due to birth injury",
      },
      {
        label:
          "Other specified intracranial laceration or haemorrhage due to birth injury",
        value:
          "Other specified intracranial laceration or haemorrhage due to birth injury",
      },
      {
        label:
          "Intracranial laceration or haemorrhage due to birth injury, unspecified",
        value:
          "Intracranial laceration or haemorrhage due to birth injury, unspecified",
      },
      {
        label: "Cerebral oedema due to birth injury",
        value: "Cerebral oedema due to birth injury",
      },
      {
        label: "Birth injury to spine or spinal cord",
        value: "Birth injury to spine or spinal cord",
      },
      {
        label: "Birth injury to brainstem",
        value: "Birth injury to brainstem",
      },
      {
        label: "Other specified birth injury to central nervous system",
        value: "Other specified birth injury to central nervous system",
      },
      {
        label: "Birth injury to central nervous system, unspecified",
        value: "Birth injury to central nervous system, unspecified",
      },
      { label: "Birth injury to eye", value: "Birth injury to eye" },
      { label: "Birth injury to scalp", value: "Birth injury to scalp" },
      {
        label: "Bruising of scalp due to birth injury",
        value: "Bruising of scalp due to birth injury",
      },
      {
        label: "Cephalohaematoma due to birth injury",
        value: "Cephalohaematoma due to birth injury",
      },
      {
        label: "Chignon due to birth injury",
        value: "Chignon due to birth injury",
      },
      {
        label: "Monitoring injury of scalp of newborn",
        value: "Monitoring injury of scalp of newborn",
      },
      {
        label:
          "Subgaleal epicranial subaponeurotic haemorrhage due to birth injury",
        value:
          "Subgaleal epicranial subaponeurotic haemorrhage due to birth injury",
      },
      {
        label: "Other specified birth injury to scalp",
        value: "Other specified birth injury to scalp",
      },
      {
        label: "Birth injury to scalp, unspecified",
        value: "Birth injury to scalp, unspecified",
      },
      {
        label: "Birth injury to skin or soft tissues",
        value: "Birth injury to skin or soft tissues",
      },
      {
        label: "Birth injury to sternocleidomastoid",
        value: "Birth injury to sternocleidomastoid",
      },
      {
        label: "Birth injury to external genitalia",
        value: "Birth injury to external genitalia",
      },
      {
        label: "Subcutaneous fat necrosis due to birth injury",
        value: "Subcutaneous fat necrosis due to birth injury",
      },
      { label: "Birth injury to face", value: "Birth injury to face" },
      {
        label: "Other specified birth injury to skin or soft tissues",
        value: "Other specified birth injury to skin or soft tissues",
      },
      {
        label: "Birth injury to peripheral nervous system",
        value: "Birth injury to peripheral nervous system",
      },
      {
        label: "Birth injury to cranial nerves",
        value: "Birth injury to cranial nerves",
      },
      {
        label: "Birth injury to facial nerve",
        value: "Birth injury to facial nerve",
      },
      {
        label: "Birth injury to other specified cranial nerve",
        value: "Birth injury to other specified cranial nerve",
      },
      {
        label: "Birth injury to unspecified cranial nerve",
        value: "Birth injury to unspecified cranial nerve",
      },
      {
        label: "Brachial plexus palsy in newborn",
        value: "Brachial plexus palsy in newborn",
      },
      { label: "Erb paralysis", value: "Erb paralysis" },
      { label: "Klumpke paralysis", value: "Klumpke paralysis" },
      {
        label: "Brachial plexus palsy in newborn, unspecified",
        value: "Brachial plexus palsy in newborn, unspecified",
      },
      {
        label: "Phrenic nerve paralysis due to birth injury",
        value: "Phrenic nerve paralysis due to birth injury",
      },
      {
        label: "Birth injury to other specified peripheral nerve",
        value: "Birth injury to other specified peripheral nerve",
      },
      {
        label: "Birth injury to unspecified peripheral nerve",
        value: "Birth injury to unspecified peripheral nerve",
      },
      { label: "Birth injury to skeleton", value: "Birth injury to skeleton" },
      {
        label: "Fracture of skull due to birth injury",
        value: "Fracture of skull due to birth injury",
      },
      {
        label: "Linear skull fracture due to birth injury",
        value: "Linear skull fracture due to birth injury",
      },
      {
        label: "Depressed skull fracture due to birth injury",
        value: "Depressed skull fracture due to birth injury",
      },
      {
        label: "Other specified fracture of skull due to birth injury",
        value: "Other specified fracture of skull due to birth injury",
      },
      {
        label: "Fracture of skull due to birth injury, unspecified",
        value: "Fracture of skull due to birth injury, unspecified",
      },
      {
        label: "Occipital osteodiastasis due to birth injury",
        value: "Occipital osteodiastasis due to birth injury",
      },
      {
        label: "Birth injury to facial bones",
        value: "Birth injury to facial bones",
      },
      {
        label: "Mandibular bone fracture due to birth injury",
        value: "Mandibular bone fracture due to birth injury",
      },
      {
        label: "Nasal bone fracture due to birth injury",
        value: "Nasal bone fracture due to birth injury",
      },
      {
        label: "Other specified birth injury to facial bones",
        value: "Other specified birth injury to facial bones",
      },
      {
        label: "Birth injury to facial bones, unspecified",
        value: "Birth injury to facial bones, unspecified",
      },
      { label: "Birth injury of thorax", value: "Birth injury of thorax" },
      {
        label:
          "Fracture, dislocation or subluxation of spine due to birth injury",
        value:
          "Fracture, dislocation or subluxation of spine due to birth injury",
      },
      {
        label: "Fracture of clavicle due to birth injury",
        value: "Fracture of clavicle due to birth injury",
      },
      {
        label: "Birth injury to long bones",
        value: "Birth injury to long bones",
      },
      {
        label: "Other specified birth injury to skeleton",
        value: "Other specified birth injury to skeleton",
      },
      {
        label: "Birth injury to other organs",
        value: "Birth injury to other organs",
      },
      { label: "Birth injury to liver", value: "Birth injury to liver" },
      { label: "Birth injury to spleen", value: "Birth injury to spleen" },
      {
        label: "Adrenal haemorrhage due to birth injury",
        value: "Adrenal haemorrhage due to birth injury",
      },
      {
        label: "Birth injury to other specified organ",
        value: "Birth injury to other specified organ",
      },
      {
        label: "Birth injury, unspecified",
        value: "Birth injury, unspecified",
      },
      {
        label: "Infections of the fetus or newborn",
        value: "Infections of the fetus or newborn",
      },
      {
        label: "Sepsis of fetus or newborn",
        value: "Sepsis of fetus or newborn",
      },
      {
        label: "Other bacterial infections of the fetus or newborn",
        value: "Other bacterial infections of the fetus or newborn",
      },
      { label: "Congenital tuberculosis", value: "Congenital tuberculosis" },
      { label: "Neonatal listeriosis", value: "Neonatal listeriosis" },
      {
        label: "Bacterial infection of the foetus or newborn, unspecified",
        value: "Bacterial infection of the foetus or newborn, unspecified",
      },
      {
        label: "Viral infection in the fetus or newborn",
        value: "Viral infection in the fetus or newborn",
      },
      {
        label: "Congenital Zika virus infection",
        value: "Congenital Zika virus infection",
      },
      {
        label: "Congenital Epstein-Barr virus infection",
        value: "Congenital Epstein-Barr virus infection",
      },
      {
        label: "Congenital Varicella Zoster virus infection",
        value: "Congenital Varicella Zoster virus infection",
      },
      {
        label: "Congenital cytomegalovirus infection",
        value: "Congenital cytomegalovirus infection",
      },
      {
        label: "Congenital echovirus infection",
        value: "Congenital echovirus infection",
      },
      {
        label: "Congenital enterovirus infection",
        value: "Congenital enterovirus infection",
      },
      {
        label: "Congenital human immunodeficiency virus infection",
        value: "Congenital human immunodeficiency virus infection",
      },
      {
        label: "Congenital parvovirus syndrome",
        value: "Congenital parvovirus syndrome",
      },
      {
        label: "Congenital rubella syndrome",
        value: "Congenital rubella syndrome",
      },
      {
        label: "Congenital viral hepatitis",
        value: "Congenital viral hepatitis",
      },
      {
        label: "Perinatal Herpes simplex infection",
        value: "Perinatal Herpes simplex infection",
      },
      {
        label: "Other specified viral infection in the fetus or newborn",
        value: "Other specified viral infection in the fetus or newborn",
      },
      {
        label: "Viral infection in the fetus or newborn, unspecified",
        value: "Viral infection in the fetus or newborn, unspecified",
      },
      {
        label: "Fungal infection of fetus or newborn",
        value: "Fungal infection of fetus or newborn",
      },
      {
        label: "Malassezia infection in newborn",
        value: "Malassezia infection in newborn",
      },
      { label: "Neonatal aspergillosis", value: "Neonatal aspergillosis" },
      { label: "Neonatal candidosis", value: "Neonatal candidosis" },
      {
        label: "Other specified fungal infection of fetus or newborn",
        value: "Other specified fungal infection of fetus or newborn",
      },
      {
        label: "Fungal infection of fetus or newborn, unspecified",
        value: "Fungal infection of fetus or newborn, unspecified",
      },
      {
        label: "Parasitic diseases in the fetus or newborn",
        value: "Parasitic diseases in the fetus or newborn",
      },
      { label: "Congenital toxoplasmosis", value: "Congenital toxoplasmosis" },
      {
        label: "Congenital falciparum malaria",
        value: "Congenital falciparum malaria",
      },
      {
        label: "Other specified parasitic diseases in the fetus or newborn",
        value: "Other specified parasitic diseases in the fetus or newborn",
      },
      {
        label: "Parasitic diseases in the fetus or newborn, unspecified",
        value: "Parasitic diseases in the fetus or newborn, unspecified",
      },
      {
        label: "Neonatal infections of certain specified sites",
        value: "Neonatal infections of certain specified sites",
      },
      {
        label: "Neonatal conjunctivitis or dacryocystitis",
        value: "Neonatal conjunctivitis or dacryocystitis",
      },
      { label: "Omphalitis of newborn", value: "Omphalitis of newborn" },
      {
        label: "Neonatal urinary tract infection",
        value: "Neonatal urinary tract infection",
      },
      {
        label: "Neonatal infectious mastitis",
        value: "Neonatal infectious mastitis",
      },
      { label: "Neonatal meningitis", value: "Neonatal meningitis" },
      {
        label: "Neonatal infections of other specified sites",
        value: "Neonatal infections of other specified sites",
      },
      {
        label: "Other specified infections of the fetus or newborn",
        value: "Other specified infections of the fetus or newborn",
      },
      {
        label: "Infections of the fetus or newborn, unspecified",
        value: "Infections of the fetus or newborn, unspecified",
      },
      {
        label: "Haemorrhagic or haematological disorders of fetus or newborn",
        value: "Haemorrhagic or haematological disorders of fetus or newborn",
      },
      { label: "Fetal blood loss", value: "Fetal blood loss" },
      {
        label: "Fetal blood loss from vasa praevia",
        value: "Fetal blood loss from vasa praevia",
      },
      {
        label: "Fetal blood loss from ruptured cord",
        value: "Fetal blood loss from ruptured cord",
      },
      {
        label: "Fetal blood loss from placenta",
        value: "Fetal blood loss from placenta",
      },
      { label: "Haemorrhage into co-twin", value: "Haemorrhage into co-twin" },
      {
        label: "Haemorrhage into maternal circulation",
        value: "Haemorrhage into maternal circulation",
      },
      {
        label: "Fetal blood loss from cut end of co-twin cord",
        value: "Fetal blood loss from cut end of co-twin cord",
      },
      {
        label: "Other specified fetal blood loss",
        value: "Other specified fetal blood loss",
      },
      {
        label: "Fetal blood loss, unspecified",
        value: "Fetal blood loss, unspecified",
      },
      {
        label: "Umbilical haemorrhage of newborn",
        value: "Umbilical haemorrhage of newborn",
      },
      {
        label: "Intracranial nontraumatic haemorrhage of fetus or newborn",
        value: "Intracranial nontraumatic haemorrhage of fetus or newborn",
      },
      {
        label:
          "Intraventricular nontraumatic haemorrhage, grade 1, of fetus or newborn",
        value:
          "Intraventricular nontraumatic haemorrhage, grade 1, of fetus or newborn",
      },
      {
        label:
          "Intraventricular nontraumatic haemorrhage, grade 2, of fetus or newborn",
        value:
          "Intraventricular nontraumatic haemorrhage, grade 2, of fetus or newborn",
      },
      {
        label:
          "Intraventricular nontraumatic haemorrhage, grade 3, of fetus or newborn",
        value:
          "Intraventricular nontraumatic haemorrhage, grade 3, of fetus or newborn",
      },
      {
        label:
          "Intraventricular nontraumatic haemorrhage, grade 4, of fetus or newborn",
        value:
          "Intraventricular nontraumatic haemorrhage, grade 4, of fetus or newborn",
      },
      {
        label: "Intracerebral nontraumatic haemorrhage of fetus or newborn",
        value: "Intracerebral nontraumatic haemorrhage of fetus or newborn",
      },
      {
        label: "Subarachnoid nontraumatic haemorrhage of fetus or newborn",
        value: "Subarachnoid nontraumatic haemorrhage of fetus or newborn",
      },
      {
        label:
          "Cerebellar nontraumatic, hemispheres or vermis or posterior fossa haemorrhage of fetus or newborn",
        value:
          "Cerebellar nontraumatic, hemispheres or vermis or posterior fossa haemorrhage of fetus or newborn",
      },
      {
        label: "Subdural nontraumatic haemorrhage of fetus or newborn",
        value: "Subdural nontraumatic haemorrhage of fetus or newborn",
      },
      {
        label:
          "Intracranial nontraumatic haemorrhage of fetus or newborn, unspecified",
        value:
          "Intracranial nontraumatic haemorrhage of fetus or newborn, unspecified",
      },
      {
        label: "Certain specified neonatal haemorrhages",
        value: "Certain specified neonatal haemorrhages",
      },
      {
        label: "Neonatal bleeding originating in the mouth, nose or pharynx",
        value: "Neonatal bleeding originating in the mouth, nose or pharynx",
      },
      {
        label:
          "Neonatal bleeding originating in the oesophagus, stomach, small or large intestine",
        value:
          "Neonatal bleeding originating in the oesophagus, stomach, small or large intestine",
      },
      {
        label: "Neonatal rectal haemorrhage",
        value: "Neonatal rectal haemorrhage",
      },
      {
        label: "Neonatal hepatic haemorrhage",
        value: "Neonatal hepatic haemorrhage",
      },
      {
        label: "Neonatal haemorrhage originating in adrenal gland",
        value: "Neonatal haemorrhage originating in adrenal gland",
      },
      {
        label: "Neonatal haemorrhage originating in spleen",
        value: "Neonatal haemorrhage originating in spleen",
      },
      {
        label: "Neonatal haemorrhage originating in kidney or bladder",
        value: "Neonatal haemorrhage originating in kidney or bladder",
      },
      {
        label:
          "Neonatal haemorrhage originating in trachea or pulmonary parenchyma",
        value:
          "Neonatal haemorrhage originating in trachea or pulmonary parenchyma",
      },
      {
        label: "Neonatal cutaneous haemorrhage",
        value: "Neonatal cutaneous haemorrhage",
      },
      {
        label: "Neonatal vaginal or uterine haemorrhage",
        value: "Neonatal vaginal or uterine haemorrhage",
      },
      { label: "Neonatal epistaxis", value: "Neonatal epistaxis" },
      {
        label: "Haemolytic disease of fetus or newborn",
        value: "Haemolytic disease of fetus or newborn",
      },
      {
        label: "Rh isoimmunization of fetus or newborn",
        value: "Rh isoimmunization of fetus or newborn",
      },
      {
        label: "Isoimmunization due to other red cell factors",
        value: "Isoimmunization due to other red cell factors",
      },
      {
        label: "ABO isoimmunization of fetus or newborn",
        value: "ABO isoimmunization of fetus or newborn",
      },
      {
        label:
          "Haemolytic anaemia due to other unclassified antibodies of fetus or newborn",
        value:
          "Haemolytic anaemia due to other unclassified antibodies of fetus or newborn",
      },
      {
        label: "Haemolytic disease due to disease of other neonatal organs",
        value: "Haemolytic disease due to disease of other neonatal organs",
      },
      {
        label:
          "Neonatal haemolysis due to systemic bacterial infection with or without concomitant diffuse intravascular coagulation",
        value:
          "Neonatal haemolysis due to systemic bacterial infection with or without concomitant diffuse intravascular coagulation",
      },
      {
        label: "Haemolytic disease of fetus or newborn, unspecified",
        value: "Haemolytic disease of fetus or newborn, unspecified",
      },
      {
        label: "Hydrops fetalis due to haemolytic disease",
        value: "Hydrops fetalis due to haemolytic disease",
      },
      {
        label: "Hydrops fetalis due to isoimmunization",
        value: "Hydrops fetalis due to isoimmunization",
      },
      {
        label: "Other specified hydrops fetalis due to haemolytic disease",
        value: "Other specified hydrops fetalis due to haemolytic disease",
      },
      {
        label: "Hydrops fetalis due to haemolytic disease, unspecified",
        value: "Hydrops fetalis due to haemolytic disease, unspecified",
      },
      { label: "Neonatal kernicterus", value: "Neonatal kernicterus" },
      {
        label: "Neonatal hyperbilirubinaemia",
        value: "Neonatal hyperbilirubinaemia",
      },
      {
        label: "Neonatal hyperbilirubinaemia due to swallowed maternal blood",
        value: "Neonatal hyperbilirubinaemia due to swallowed maternal blood",
      },
      {
        label:
          "Neonatal hyperbilirubinaemia due to enzymatic defect in bilirubin degradation",
        value:
          "Neonatal hyperbilirubinaemia due to enzymatic defect in bilirubin degradation",
      },
      {
        label:
          "Neonatal hyperbilirubinaemia due to breast milk inhibitor of bilirubin conjugation",
        value:
          "Neonatal hyperbilirubinaemia due to breast milk inhibitor of bilirubin conjugation",
      },
      {
        label: "Neonatal hyperbilirubinaemia due to total parenteral nutrition",
        value: "Neonatal hyperbilirubinaemia due to total parenteral nutrition",
      },
      {
        label:
          "Neonatal hyperbilirubinaemia due to drugs or toxins transmitted from mother",
        value:
          "Neonatal hyperbilirubinaemia due to drugs or toxins transmitted from mother",
      },
      {
        label:
          "Neonatal hyperbilirubinaemia due to drugs or toxins given to newborn",
        value:
          "Neonatal hyperbilirubinaemia due to drugs or toxins given to newborn",
      },
      {
        label:
          "Neonatal hyperbilirubinaemia from other or unspecified hepatocellular damage",
        value:
          "Neonatal hyperbilirubinaemia from other or unspecified hepatocellular damage",
      },
      {
        label: "Other specified neonatal hyperbilirubinaemia",
        value: "Other specified neonatal hyperbilirubinaemia",
      },
      {
        label: "Neonatal hyperbilirubinaemia, unspecified",
        value: "Neonatal hyperbilirubinaemia, unspecified",
      },
      {
        label: "Disseminated intravascular coagulation of fetus or newborn",
        value: "Disseminated intravascular coagulation of fetus or newborn",
      },
      {
        label: "Transient neonatal thrombocytopaenia",
        value: "Transient neonatal thrombocytopaenia",
      },
      {
        label:
          "Thrombocytopaenia following systemic infection, including diffuse intravascular coagulation",
        value:
          "Thrombocytopaenia following systemic infection, including diffuse intravascular coagulation",
      },
      {
        label: "Other specified transient neonatal thrombocytopaenia",
        value: "Other specified transient neonatal thrombocytopaenia",
      },
      {
        label: "Transient neonatal thrombocytopaenia, unspecified",
        value: "Transient neonatal thrombocytopaenia, unspecified",
      },
      { label: "Polycythaemia neonatorum", value: "Polycythaemia neonatorum" },
      {
        label:
          "Polycythaemia neonatorum due to placental insufficiency or fetal intrauterine growth restriction",
        value:
          "Polycythaemia neonatorum due to placental insufficiency or fetal intrauterine growth restriction",
      },
      {
        label: "Polycythaemia neonatorum due to twin to twin transfusion",
        value: "Polycythaemia neonatorum due to twin to twin transfusion",
      },
      {
        label:
          "Polycythaemia neonatorum due to inherited disorder of erythropoietin production",
        value:
          "Polycythaemia neonatorum due to inherited disorder of erythropoietin production",
      },
      {
        label:
          "Polycythaemia neonatorum following umbilical cord transfusion or stripping at delivery",
        value:
          "Polycythaemia neonatorum following umbilical cord transfusion or stripping at delivery",
      },
      {
        label: "Polycythaemia neonatorum following blood transfusion",
        value: "Polycythaemia neonatorum following blood transfusion",
      },
      {
        label: "Other specified polycythaemia neonatorum",
        value: "Other specified polycythaemia neonatorum",
      },
      {
        label: "Polycythaemia neonatorum, unspecified",
        value: "Polycythaemia neonatorum, unspecified",
      },
      { label: "Anaemia of prematurity", value: "Anaemia of prematurity" },
      {
        label: "Congenital hypoplastic anaemia",
        value: "Congenital hypoplastic anaemia",
      },
      {
        label: "Transient neonatal neutropaenia",
        value: "Transient neonatal neutropaenia",
      },
      {
        label: "Alloimmune neonatal neutropaenia",
        value: "Alloimmune neonatal neutropaenia",
      },
      {
        label: "Neonatal vitamin K deficiency",
        value: "Neonatal vitamin K deficiency",
      },
      {
        label:
          "Diffuse bleeding diathesis due to vitamin K deficient haemorrhagic disease of fetus or newborn",
        value:
          "Diffuse bleeding diathesis due to vitamin K deficient haemorrhagic disease of fetus or newborn",
      },
      {
        label: "Other specified neonatal vitamin K deficiency",
        value: "Other specified neonatal vitamin K deficiency",
      },
      {
        label: "Neonatal vitamin K deficiency, unspecified",
        value: "Neonatal vitamin K deficiency, unspecified",
      },
      {
        label:
          "Other specified haemorrhagic or haematological disorders of fetus or newborn",
        value:
          "Other specified haemorrhagic or haematological disorders of fetus or newborn",
      },
      {
        label:
          "Haemorrhagic or haematological disorders of fetus or newborn, unspecified",
        value:
          "Haemorrhagic or haematological disorders of fetus or newborn, unspecified",
      },
      {
        label:
          "Neurological disorders specific to the perinatal or neonatal period",
        value:
          "Neurological disorders specific to the perinatal or neonatal period",
      },
      {
        label: "Neonatal cerebral ischaemia",
        value: "Neonatal cerebral ischaemia",
      },
      {
        label: "Perinatal arterial stroke",
        value: "Perinatal arterial stroke",
      },
      {
        label: "Neonatal cerebral sinovenous thrombosis",
        value: "Neonatal cerebral sinovenous thrombosis",
      },
      {
        label: "Other specified neonatal cerebral ischaemia",
        value: "Other specified neonatal cerebral ischaemia",
      },
      {
        label: "Neonatal cerebral ischaemia, unspecified",
        value: "Neonatal cerebral ischaemia, unspecified",
      },
      {
        label: "Periventricular cysts of newborn",
        value: "Periventricular cysts of newborn",
      },
      {
        label: "Neonatal cerebral leukomalacia",
        value: "Neonatal cerebral leukomalacia",
      },
      { label: "Neonatal encephalopathy", value: "Neonatal encephalopathy" },
      {
        label: "Hypoxic ischaemic encephalopathy of newborn",
        value: "Hypoxic ischaemic encephalopathy of newborn",
      },
      { label: "Neonatal hydrocephalus", value: "Neonatal hydrocephalus" },
      {
        label: "Neonatal obstructive hydrocephalus",
        value: "Neonatal obstructive hydrocephalus",
      },
      {
        label: "Other specified neonatal hydrocephalus",
        value: "Other specified neonatal hydrocephalus",
      },
      {
        label: "Neonatal hydrocephalus, unspecified",
        value: "Neonatal hydrocephalus, unspecified",
      },
      { label: "Neonatal seizures", value: "Neonatal seizures" },
      {
        label: "Compression of brain in neonate",
        value: "Compression of brain in neonate",
      },
      {
        label: "Disorders of muscle tone of newborn",
        value: "Disorders of muscle tone of newborn",
      },
      {
        label: "Transient neonatal myasthenia gravis",
        value: "Transient neonatal myasthenia gravis",
      },
      { label: "Congenital hypertonia", value: "Congenital hypertonia" },
      { label: "Congenital hypotonia", value: "Congenital hypotonia" },
      {
        label: "Other specified disorders of muscle tone of newborn",
        value: "Other specified disorders of muscle tone of newborn",
      },
      {
        label: "Disorders of muscle tone of newborn, unspecified",
        value: "Disorders of muscle tone of newborn, unspecified",
      },
      {
        label:
          "Other specified neurological disorders specific to the perinatal or neonatal period",
        value:
          "Other specified neurological disorders specific to the perinatal or neonatal period",
      },
      {
        label:
          "Neurological disorders specific to the perinatal or neonatal period, unspecified",
        value:
          "Neurological disorders specific to the perinatal or neonatal period, unspecified",
      },
      {
        label:
          "Respiratory disorders specific to the perinatal or neonatal period",
        value:
          "Respiratory disorders specific to the perinatal or neonatal period",
      },
      { label: "Intrauterine hypoxia", value: "Intrauterine hypoxia" },
      {
        label: "Intrauterine hypoxia first noted before onset of labour",
        value: "Intrauterine hypoxia first noted before onset of labour",
      },
      {
        label: "Intrauterine hypoxia first noted during labour or delivery",
        value: "Intrauterine hypoxia first noted during labour or delivery",
      },
      {
        label: "Intrauterine hypoxia, unspecified",
        value: "Intrauterine hypoxia, unspecified",
      },
      { label: "Birth asphyxia", value: "Birth asphyxia" },
      { label: "Severe birth asphyxia", value: "Severe birth asphyxia" },
      {
        label: "Mild and moderate birth asphyxia",
        value: "Mild and moderate birth asphyxia",
      },
      {
        label: "Other specified birth asphyxia",
        value: "Other specified birth asphyxia",
      },
      {
        label: "Metabolic acidaemia in newborn",
        value: "Metabolic acidaemia in newborn",
      },
      {
        label: "Respiratory distress of newborn",
        value: "Respiratory distress of newborn",
      },
      {
        label: "Respiratory distress syndrome of newborn",
        value: "Respiratory distress syndrome of newborn",
      },
      {
        label:
          "Respiratory distress syndrome of the newborn, altered by maternal corticosteroid therapy",
        value:
          "Respiratory distress syndrome of the newborn, altered by maternal corticosteroid therapy",
      },
      {
        label:
          "Respiratory distress syndrome of the newborn, altered by pulmonary surfactant replacement therapy",
        value:
          "Respiratory distress syndrome of the newborn, altered by pulmonary surfactant replacement therapy",
      },
      {
        label:
          "Respiratory distress syndrome of the newborn, altered by maternal corticosteroid therapy or pulmonary surfactant replacement therapy",
        value:
          "Respiratory distress syndrome of the newborn, altered by maternal corticosteroid therapy or pulmonary surfactant replacement therapy",
      },
      {
        label: "Other specified respiratory distress syndrome of newborn",
        value: "Other specified respiratory distress syndrome of newborn",
      },
      {
        label: "Respiratory distress syndrome of newborn, unspecified",
        value: "Respiratory distress syndrome of newborn, unspecified",
      },
      {
        label: "Transient tachypnoea of newborn",
        value: "Transient tachypnoea of newborn",
      },
      {
        label: "Respiratory instability of prematurity",
        value: "Respiratory instability of prematurity",
      },
      {
        label: "Other specified respiratory distress of newborn",
        value: "Other specified respiratory distress of newborn",
      },
      {
        label: "Respiratory distress of newborn, unspecified",
        value: "Respiratory distress of newborn, unspecified",
      },
      { label: "Congenital pneumonia", value: "Congenital pneumonia" },
      { label: "Neonatal tracheitis", value: "Neonatal tracheitis" },
      {
        label: "Neonatal aspiration syndromes",
        value: "Neonatal aspiration syndromes",
      },
      {
        label: "Neonatal aspiration of meconium",
        value: "Neonatal aspiration of meconium",
      },
      {
        label: "Neonatal aspiration of amniotic fluid or mucus",
        value: "Neonatal aspiration of amniotic fluid or mucus",
      },
      {
        label: "Neonatal aspiration of blood",
        value: "Neonatal aspiration of blood",
      },
      {
        label: "Neonatal aspiration of milk or regurgitated food",
        value: "Neonatal aspiration of milk or regurgitated food",
      },
      {
        label: "Other specified neonatal aspiration syndromes",
        value: "Other specified neonatal aspiration syndromes",
      },
      {
        label: "Neonatal aspiration syndromes, unspecified",
        value: "Neonatal aspiration syndromes, unspecified",
      },
      {
        label:
          "Pulmonary air leak or related conditions originating in the perinatal period",
        value:
          "Pulmonary air leak or related conditions originating in the perinatal period",
      },
      {
        label: "Interstitial emphysema originating in the perinatal period",
        value: "Interstitial emphysema originating in the perinatal period",
      },
      {
        label: "Pneumothorax originating in the perinatal period",
        value: "Pneumothorax originating in the perinatal period",
      },
      {
        label: "Pneumomediastinum originating in the perinatal period",
        value: "Pneumomediastinum originating in the perinatal period",
      },
      {
        label: "Pneumopericardium originating in the perinatal period",
        value: "Pneumopericardium originating in the perinatal period",
      },
      {
        label:
          "Pneumoperitoneum, originating in the perinatal period, due to primary pulmonary air leak syndromes",
        value:
          "Pneumoperitoneum, originating in the perinatal period, due to primary pulmonary air leak syndromes",
      },
      {
        label:
          "Other specified pulmonary air leak or related conditions originating in the perinatal period",
        value:
          "Other specified pulmonary air leak or related conditions originating in the perinatal period",
      },
      {
        label:
          "Pulmonary air leak or related conditions originating in the perinatal period, unspecified",
        value:
          "Pulmonary air leak or related conditions originating in the perinatal period, unspecified",
      },
      {
        label: "Pulmonary haemorrhage originating in the perinatal period",
        value: "Pulmonary haemorrhage originating in the perinatal period",
      },
      {
        label:
          "Tracheobronchial haemorrhage originating in the perinatal period",
        value:
          "Tracheobronchial haemorrhage originating in the perinatal period",
      },
      {
        label:
          "Traumatic pulmonary haemorrhage originating in the perinatal period",
        value:
          "Traumatic pulmonary haemorrhage originating in the perinatal period",
      },
      {
        label:
          "Other specified pulmonary haemorrhage originating in the perinatal period",
        value:
          "Other specified pulmonary haemorrhage originating in the perinatal period",
      },
      {
        label:
          "Pulmonary haemorrhage originating in the perinatal period, unspecified",
        value:
          "Pulmonary haemorrhage originating in the perinatal period, unspecified",
      },
      {
        label:
          "Chronic respiratory disease originating in the perinatal period",
        value:
          "Chronic respiratory disease originating in the perinatal period",
      },
      {
        label: "Bronchopulmonary dysplasia originating in the perinatal period",
        value: "Bronchopulmonary dysplasia originating in the perinatal period",
      },
      {
        label:
          "Other specified chronic respiratory disease originating in the perinatal period",
        value:
          "Other specified chronic respiratory disease originating in the perinatal period",
      },
      {
        label:
          "Chronic respiratory disease originating in the perinatal period, unspecified",
        value:
          "Chronic respiratory disease originating in the perinatal period, unspecified",
      },
      { label: "Apnoea of newborn", value: "Apnoea of newborn" },
      { label: "Central neonatal apnoea", value: "Central neonatal apnoea" },
      {
        label: "Obstructive neonatal apnoea",
        value: "Obstructive neonatal apnoea",
      },
      { label: "Mixed neonatal apnoea", value: "Mixed neonatal apnoea" },
      {
        label: "Apnoea of newborn, due to neurologic injury",
        value: "Apnoea of newborn, due to neurologic injury",
      },
      {
        label: "Other specified apnoea of newborn",
        value: "Other specified apnoea of newborn",
      },
      {
        label: "Apnoea of newborn, unspecified",
        value: "Apnoea of newborn, unspecified",
      },
      {
        label: "Primary atelectasis of newborn",
        value: "Primary atelectasis of newborn",
      },
      {
        label: "Cyanotic attacks of newborn",
        value: "Cyanotic attacks of newborn",
      },
      {
        label: "Respiratory failure of newborn",
        value: "Respiratory failure of newborn",
      },
      {
        label: "Respiratory arrest of newborn",
        value: "Respiratory arrest of newborn",
      },
      {
        label: "Congenital lung or lobar atelectasis",
        value: "Congenital lung or lobar atelectasis",
      },
      {
        label: "Tracheal haemorrhage of newborn due to airway trauma",
        value: "Tracheal haemorrhage of newborn due to airway trauma",
      },
      {
        label: "Acquired vocal cord paralysis in newborn",
        value: "Acquired vocal cord paralysis in newborn",
      },
      {
        label: "Airway obstruction in the neonate due to airway abnormality",
        value: "Airway obstruction in the neonate due to airway abnormality",
      },
      {
        label: "Hypotonia of hypopharynx in neonate",
        value: "Hypotonia of hypopharynx in neonate",
      },
      {
        label: "Hypopharyngeal mass in neonate",
        value: "Hypopharyngeal mass in neonate",
      },
      {
        label: "Tracheo-bronchial malacia in neonate",
        value: "Tracheo-bronchial malacia in neonate",
      },
      {
        label:
          "Other specified airway obstruction in the neonate due to airway abnormality",
        value:
          "Other specified airway obstruction in the neonate due to airway abnormality",
      },
      {
        label:
          "Airway obstruction in the neonate due to airway abnormality, unspecified",
        value:
          "Airway obstruction in the neonate due to airway abnormality, unspecified",
      },
      {
        label: "Pulmonary cysts in newborn",
        value: "Pulmonary cysts in newborn",
      },
      {
        label: "Acquired pulmonary cysts in newborn",
        value: "Acquired pulmonary cysts in newborn",
      },
      {
        label: "Pulmonary cysts in newborn, unspecified",
        value: "Pulmonary cysts in newborn, unspecified",
      },
      {
        label:
          "Other specified respiratory disorders specific to the perinatal or neonatal period",
        value:
          "Other specified respiratory disorders specific to the perinatal or neonatal period",
      },
      {
        label:
          "Respiratory disorders specific to the perinatal or neonatal period, unspecified",
        value:
          "Respiratory disorders specific to the perinatal or neonatal period, unspecified",
      },
      {
        label:
          "Cardiovascular disorders present in the perinatal or neonatal period",
        value:
          "Cardiovascular disorders present in the perinatal or neonatal period",
      },
      { label: "Neonatal cardiac failure", value: "Neonatal cardiac failure" },
      {
        label: "Neonatal cardiac failure due to pulmonary overperfusion",
        value: "Neonatal cardiac failure due to pulmonary overperfusion",
      },
      {
        label:
          "Neonatal cardiac failure due to decreased left ventricular output",
        value:
          "Neonatal cardiac failure due to decreased left ventricular output",
      },
      {
        label: "Other specified neonatal cardiac failure",
        value: "Other specified neonatal cardiac failure",
      },
      {
        label: "Neonatal cardiac failure, unspecified",
        value: "Neonatal cardiac failure, unspecified",
      },
      {
        label: "Cardiac arrhythmias in the neonate",
        value: "Cardiac arrhythmias in the neonate",
      },
      {
        label: "Persistent pulmonary hypertension of the newborn",
        value: "Persistent pulmonary hypertension of the newborn",
      },
      {
        label: "Delayed closure of ductus arteriosus",
        value: "Delayed closure of ductus arteriosus",
      },
      {
        label: "Transient myocardial ischaemia of newborn",
        value: "Transient myocardial ischaemia of newborn",
      },
      { label: "Neonatal hypertension", value: "Neonatal hypertension" },
      { label: "Neonatal hypotension", value: "Neonatal hypotension" },
      {
        label: "Benign or innocent cardiac murmurs in newborn",
        value: "Benign or innocent cardiac murmurs in newborn",
      },
      {
        label:
          "Other specified cardiovascular disorders present in the perinatal or neonatal period",
        value:
          "Other specified cardiovascular disorders present in the perinatal or neonatal period",
      },
      {
        label:
          "Cardiovascular disorders present in the perinatal or neonatal period, unspecified",
        value:
          "Cardiovascular disorders present in the perinatal or neonatal period, unspecified",
      },
      {
        label:
          "Transitory endocrine or metabolic disorders specific to fetus or newborn",
        value:
          "Transitory endocrine or metabolic disorders specific to fetus or newborn",
      },
      {
        label:
          "Transitory disorders of carbohydrate metabolism specific to fetus or newborn",
        value:
          "Transitory disorders of carbohydrate metabolism specific to fetus or newborn",
      },
      {
        label: "Syndrome of infant of mother with gestational diabetes",
        value: "Syndrome of infant of mother with gestational diabetes",
      },
      {
        label:
          "Syndrome of infant of a diabetic mother, type 1 or 2, nongestational, insulin dependent",
        value:
          "Syndrome of infant of a diabetic mother, type 1 or 2, nongestational, insulin dependent",
      },
      {
        label: "Neonatal diabetes mellitus",
        value: "Neonatal diabetes mellitus",
      },
      {
        label: "Transient neonatal diabetes mellitus",
        value: "Transient neonatal diabetes mellitus",
      },
      {
        label: "Other specified neonatal diabetes mellitus",
        value: "Other specified neonatal diabetes mellitus",
      },
      {
        label: "Neonatal diabetes mellitus, unspecified",
        value: "Neonatal diabetes mellitus, unspecified",
      },
      { label: "Neonatal hyperglycaemia", value: "Neonatal hyperglycaemia" },
      {
        label: "Neonatal hyperglycaemia due to insulin deficiency",
        value: "Neonatal hyperglycaemia due to insulin deficiency",
      },
      {
        label: "Neonatal hyperglycaemia due to iatrogenic intravenous therapy",
        value: "Neonatal hyperglycaemia due to iatrogenic intravenous therapy",
      },
      {
        label: "Other specified neonatal hyperglycaemia",
        value: "Other specified neonatal hyperglycaemia",
      },
      {
        label: "Neonatal hyperglycaemia, unspecified",
        value: "Neonatal hyperglycaemia, unspecified",
      },
      { label: "Neonatal hypoglycaemia", value: "Neonatal hypoglycaemia" },
      {
        label: "Transient hyperinsulinaemic neonatal hypoglycaemia",
        value: "Transient hyperinsulinaemic neonatal hypoglycaemia",
      },
      {
        label: "Transitory iatrogenic neonatal hypoglycaemia",
        value: "Transitory iatrogenic neonatal hypoglycaemia",
      },
      {
        label: "Other transitory neonatal hypoglycaemia",
        value: "Other transitory neonatal hypoglycaemia",
      },
      {
        label: "Other specified neonatal hypoglycaemia",
        value: "Other specified neonatal hypoglycaemia",
      },
      {
        label: "Neonatal hypoglycaemia, unspecified",
        value: "Neonatal hypoglycaemia, unspecified",
      },
      {
        label:
          "Other specified transitory disorders of carbohydrate metabolism specific to fetus or newborn",
        value:
          "Other specified transitory disorders of carbohydrate metabolism specific to fetus or newborn",
      },
      {
        label:
          "Transitory disorders of carbohydrate metabolism specific to fetus or newborn, unspecified",
        value:
          "Transitory disorders of carbohydrate metabolism specific to fetus or newborn, unspecified",
      },
      {
        label:
          "Transitory neonatal disorders of calcium or magnesium metabolism",
        value:
          "Transitory neonatal disorders of calcium or magnesium metabolism",
      },
      { label: "Neonatal hypomagnesaemia", value: "Neonatal hypomagnesaemia" },
      {
        label: "Neonatal tetany without calcium or magnesium deficiency",
        value: "Neonatal tetany without calcium or magnesium deficiency",
      },
      { label: "Neonatal hypocalcaemia", value: "Neonatal hypocalcaemia" },
      { label: "Neonatal osteopenia", value: "Neonatal osteopenia" },
      {
        label:
          "Other specified transitory neonatal disorders of calcium or magnesium metabolism",
        value:
          "Other specified transitory neonatal disorders of calcium or magnesium metabolism",
      },
      {
        label:
          "Transitory neonatal disorders of calcium or magnesium metabolism, unspecified",
        value:
          "Transitory neonatal disorders of calcium or magnesium metabolism, unspecified",
      },
      {
        label: "Transitory neonatal disorders of thyroid function",
        value: "Transitory neonatal disorders of thyroid function",
      },
      {
        label: "Transitory neonatal hyperthyroidism",
        value: "Transitory neonatal hyperthyroidism",
      },
      {
        label:
          "Other transitory neonatal disorders of thyroid function, not elsewhere classified",
        value:
          "Other transitory neonatal disorders of thyroid function, not elsewhere classified",
      },
      {
        label: "Transient hyperthyrotropinaemia",
        value: "Transient hyperthyrotropinaemia",
      },
      {
        label: "Transient hypothyroxinaemia",
        value: "Transient hypothyroxinaemia",
      },
      {
        label:
          "Other specified transitory neonatal disorders of thyroid function",
        value:
          "Other specified transitory neonatal disorders of thyroid function",
      },
      {
        label: "Transitory neonatal disorders of thyroid function, unspecified",
        value: "Transitory neonatal disorders of thyroid function, unspecified",
      },
      {
        label:
          "Certain specified transitory neonatal electrolyte or metabolic disturbances",
        value:
          "Certain specified transitory neonatal electrolyte or metabolic disturbances",
      },
      {
        label: "Late metabolic acidosis of newborn",
        value: "Late metabolic acidosis of newborn",
      },
      { label: "Dehydration of newborn", value: "Dehydration of newborn" },
      {
        label: "Disturbances of sodium balance of newborn",
        value: "Disturbances of sodium balance of newborn",
      },
      { label: "Hyponatremia of newborn", value: "Hyponatremia of newborn" },
      { label: "Hypernatremia of newborn", value: "Hypernatremia of newborn" },
      {
        label: "Other specified disturbances of sodium balance of newborn",
        value: "Other specified disturbances of sodium balance of newborn",
      },
      {
        label: "Disturbances of sodium balance of newborn, unspecified",
        value: "Disturbances of sodium balance of newborn, unspecified",
      },
      {
        label: "Disturbances of potassium balance of newborn",
        value: "Disturbances of potassium balance of newborn",
      },
      { label: "Hypokalaemia of newborn", value: "Hypokalaemia of newborn" },
      { label: "Hyperkalaemia of newborn", value: "Hyperkalaemia of newborn" },
      {
        label: "Other specified disturbances of potassium balance of newborn",
        value: "Other specified disturbances of potassium balance of newborn",
      },
      {
        label: "Disturbances of potassium balance of newborn, unspecified",
        value: "Disturbances of potassium balance of newborn, unspecified",
      },
      {
        label: "Transitory tyrosinaemia of newborn",
        value: "Transitory tyrosinaemia of newborn",
      },
      {
        label: "Metabolic bone disease of prematurity",
        value: "Metabolic bone disease of prematurity",
      },
      {
        label: "Transitory neonatal hypoparathyroidism",
        value: "Transitory neonatal hypoparathyroidism",
      },
      {
        label:
          "Transitory endocrine or metabolic disorders specific to fetus or newborn, unspecified",
        value:
          "Transitory endocrine or metabolic disorders specific to fetus or newborn, unspecified",
      },
      {
        label: "Digestive system disorders of fetus or newborn",
        value: "Digestive system disorders of fetus or newborn",
      },
      {
        label: "Gastro-oesophageal reflux disease in newborn",
        value: "Gastro-oesophageal reflux disease in newborn",
      },
      { label: "Oesophagitis in newborn", value: "Oesophagitis in newborn" },
      {
        label: "Neonatal eosinophilic oesophagitis",
        value: "Neonatal eosinophilic oesophagitis",
      },
      {
        label: "Other specified oesophagitis in newborn",
        value: "Other specified oesophagitis in newborn",
      },
      {
        label: "Prenatal gastric perforation",
        value: "Prenatal gastric perforation",
      },
      {
        label: "Postnatal gastric perforation",
        value: "Postnatal gastric perforation",
      },
      {
        label: "Postnatal isolated ileal perforation",
        value: "Postnatal isolated ileal perforation",
      },
      {
        label: "Prenatal intrauterine intestinal perforation",
        value: "Prenatal intrauterine intestinal perforation",
      },
      {
        label:
          "Prenatal intrauterine intestinal perforation due to in utero volvulus",
        value:
          "Prenatal intrauterine intestinal perforation due to in utero volvulus",
      },
      {
        label:
          "Prenatal intrauterine intestinal perforation due to intestinal atresia or stenosis",
        value:
          "Prenatal intrauterine intestinal perforation due to intestinal atresia or stenosis",
      },
      {
        label:
          "Prenatal intrauterine intestinal perforation due to intraluminal obstruction",
        value:
          "Prenatal intrauterine intestinal perforation due to intraluminal obstruction",
      },
      {
        label: "Other specified prenatal intrauterine intestinal perforation",
        value: "Other specified prenatal intrauterine intestinal perforation",
      },
      {
        label: "Prenatal intrauterine intestinal perforation, unspecified",
        value: "Prenatal intrauterine intestinal perforation, unspecified",
      },
      {
        label: "Postnatal intestinal perforation",
        value: "Postnatal intestinal perforation",
      },
      {
        label: "Postnatal intestinal perforation due to drugs",
        value: "Postnatal intestinal perforation due to drugs",
      },
      {
        label: "Postnatal intestinal perforation due to in utero volvulus",
        value: "Postnatal intestinal perforation due to in utero volvulus",
      },
      {
        label:
          "Postnatal intestinal perforation due to intestinal atresia or stenosis",
        value:
          "Postnatal intestinal perforation due to intestinal atresia or stenosis",
      },
      {
        label:
          "Postnatal intestinal perforation due to intraluminal obstruction",
        value:
          "Postnatal intestinal perforation due to intraluminal obstruction",
      },
      {
        label: "Other specified postnatal intestinal perforation",
        value: "Other specified postnatal intestinal perforation",
      },
      {
        label: "Postnatal intestinal perforation, unspecified",
        value: "Postnatal intestinal perforation, unspecified",
      },
      {
        label: "Intestinal obstruction of newborn",
        value: "Intestinal obstruction of newborn",
      },
      {
        label: "Intestinal obstruction due to inspissated milk",
        value: "Intestinal obstruction due to inspissated milk",
      },
      {
        label: "Meconium plug without ileus",
        value: "Meconium plug without ileus",
      },
      {
        label: "Meconium ileus without perforation",
        value: "Meconium ileus without perforation",
      },
      {
        label: "Transitory ileus of newborn",
        value: "Transitory ileus of newborn",
      },
      {
        label: "Meconium ileus with perforation",
        value: "Meconium ileus with perforation",
      },
      {
        label: "Other specified intestinal obstruction of newborn",
        value: "Other specified intestinal obstruction of newborn",
      },
      {
        label: "Intestinal obstruction of newborn, unspecified",
        value: "Intestinal obstruction of newborn, unspecified",
      },
      {
        label: "Necrotising enterocolitis of newborn",
        value: "Necrotising enterocolitis of newborn",
      },
      {
        label: "Necrotising enterocolitis of newborn, Stage 1A & B",
        value: "Necrotising enterocolitis of newborn, Stage 1A & B",
      },
      {
        label: "Necrotising enterocolitis of newborn, Stage 2A & B",
        value: "Necrotising enterocolitis of newborn, Stage 2A & B",
      },
      {
        label: "Necrotising enterocolitis of newborn, Stage 3A",
        value: "Necrotising enterocolitis of newborn, Stage 3A",
      },
      {
        label: "Necrotising enterocolitis of newborn, Stage 3B",
        value: "Necrotising enterocolitis of newborn, Stage 3B",
      },
      {
        label: "Other specified necrotising enterocolitis of newborn",
        value: "Other specified necrotising enterocolitis of newborn",
      },
      {
        label: "Necrotising enterocolitis of newborn, unspecified",
        value: "Necrotising enterocolitis of newborn, unspecified",
      },
      {
        label: "Neonatal malabsorption syndromes",
        value: "Neonatal malabsorption syndromes",
      },
      {
        label: "Neonatal malabsorption due to endocrine secreting tumour",
        value: "Neonatal malabsorption due to endocrine secreting tumour",
      },
      { label: "Short bowel syndrome", value: "Short bowel syndrome" },
      {
        label: "Other specified neonatal malabsorption syndromes",
        value: "Other specified neonatal malabsorption syndromes",
      },
      {
        label: "Neonatal malabsorption syndromes, unspecified",
        value: "Neonatal malabsorption syndromes, unspecified",
      },
      {
        label:
          "Neonatal haematemesis or melaena due to swallowed maternal blood",
        value:
          "Neonatal haematemesis or melaena due to swallowed maternal blood",
      },
      { label: "Neonatal peritonitis", value: "Neonatal peritonitis" },
      {
        label: "Noninfectious neonatal diarrhoea",
        value: "Noninfectious neonatal diarrhoea",
      },
      {
        label: "Other specified digestive system disorders of fetus or newborn",
        value: "Other specified digestive system disorders of fetus or newborn",
      },
      {
        label: "Digestive system disorders of fetus or newborn, unspecified",
        value: "Digestive system disorders of fetus or newborn, unspecified",
      },
      {
        label:
          "Genitourinary system disorders specific to the perinatal or neonatal period",
        value:
          "Genitourinary system disorders specific to the perinatal or neonatal period",
      },
      { label: "Congenital hydrocele", value: "Congenital hydrocele" },
      { label: "Congenital renal failure", value: "Congenital renal failure" },
      {
        label:
          "Other specified genitourinary system disorders specific to the perinatal or neonatal period",
        value:
          "Other specified genitourinary system disorders specific to the perinatal or neonatal period",
      },
      {
        label:
          "Genitourinary system disorders specific to the perinatal or neonatal period, unspecified",
        value:
          "Genitourinary system disorders specific to the perinatal or neonatal period, unspecified",
      },
      {
        label: "Disorders involving the integument of fetus or newborn",
        value: "Disorders involving the integument of fetus or newborn",
      },
      {
        label: "Conditions involving the umbilical cord",
        value: "Conditions involving the umbilical cord",
      },
      {
        label: "Delayed separation of umbilical cord",
        value: "Delayed separation of umbilical cord",
      },
      {
        label: "Umbilical cutis or polyp of newborn",
        value: "Umbilical cutis or polyp of newborn",
      },
      {
        label: "Umbilical granuloma of newborn",
        value: "Umbilical granuloma of newborn",
      },
      {
        label: "Other specified conditions involving the umbilical cord",
        value: "Other specified conditions involving the umbilical cord",
      },
      {
        label: "Conditions involving the umbilical cord, unspecified",
        value: "Conditions involving the umbilical cord, unspecified",
      },
      {
        label: "Inflammatory dermatoses of the newborn",
        value: "Inflammatory dermatoses of the newborn",
      },
      { label: "Neonatal acne", value: "Neonatal acne" },
      { label: "Neonatal toxic erythema", value: "Neonatal toxic erythema" },
      {
        label: "Perianal dermatitis of the newborn",
        value: "Perianal dermatitis of the newborn",
      },
      {
        label: "Other specified inflammatory dermatoses of the newborn",
        value: "Other specified inflammatory dermatoses of the newborn",
      },
      {
        label: "Neonatal disorders of subcutaneous fat",
        value: "Neonatal disorders of subcutaneous fat",
      },
      {
        label: "Subcutaneous fat necrosis of the newborn",
        value: "Subcutaneous fat necrosis of the newborn",
      },
      {
        label: "Cold panniculitis of the newborn",
        value: "Cold panniculitis of the newborn",
      },
      { label: "Sclerema neonatorum", value: "Sclerema neonatorum" },
      {
        label: "Other specified neonatal disorders of subcutaneous fat",
        value: "Other specified neonatal disorders of subcutaneous fat",
      },
      {
        label: "Neonatal disorders of the oral mucosa",
        value: "Neonatal disorders of the oral mucosa",
      },
      {
        label: "Neonatal nutritional disorders affecting the skin",
        value: "Neonatal nutritional disorders affecting the skin",
      },
      {
        label: "Skin disorders associated with prematurity",
        value: "Skin disorders associated with prematurity",
      },
      {
        label: "Skin fragility of prematurity",
        value: "Skin fragility of prematurity",
      },
      {
        label:
          "Congenital erosive or vesicular dermatosis healing with reticulated supple scarring",
        value:
          "Congenital erosive or vesicular dermatosis healing with reticulated supple scarring",
      },
      {
        label: "Other specified skin disorders associated with prematurity",
        value: "Other specified skin disorders associated with prematurity",
      },
      {
        label: "Miscellaneous skin disorders in the neonate",
        value: "Miscellaneous skin disorders in the neonate",
      },
      {
        label: "Congenital sucking blisters",
        value: "Congenital sucking blisters",
      },
      { label: "Neonatal milia", value: "Neonatal milia" },
      {
        label: "Other specified skin disorders in the neonate",
        value: "Other specified skin disorders in the neonate",
      },
      {
        label:
          "Miscellaneous specified conditions of integument specific to fetus or newborn",
        value:
          "Miscellaneous specified conditions of integument specific to fetus or newborn",
      },
      {
        label: "Breast engorgement of newborn",
        value: "Breast engorgement of newborn",
      },
      {
        label: "Hydrops fetalis not due to haemolytic disease",
        value: "Hydrops fetalis not due to haemolytic disease",
      },
      {
        label:
          "Other specified conditions of integument specific to fetus and newborn",
        value:
          "Other specified conditions of integument specific to fetus and newborn",
      },
      {
        label: "Iatrogenic injuries involving the skin of the neonate",
        value: "Iatrogenic injuries involving the skin of the neonate",
      },
      {
        label: "Postnatal iatrogenic skin injury",
        value: "Postnatal iatrogenic skin injury",
      },
      {
        label: "Neonatal phototherapy burn",
        value: "Neonatal phototherapy burn",
      },
      {
        label: "Other specified postnatal iatrogenic skin injury",
        value: "Other specified postnatal iatrogenic skin injury",
      },
      {
        label: "Postnatal iatrogenic skin injury, unspecified",
        value: "Postnatal iatrogenic skin injury, unspecified",
      },
      {
        label:
          "Other specified iatrogenic injuries involving the skin of the neonate",
        value:
          "Other specified iatrogenic injuries involving the skin of the neonate",
      },
      {
        label:
          "Disorders involving the integument of fetus or newborn, unspecified",
        value:
          "Disorders involving the integument of fetus or newborn, unspecified",
      },
      {
        label: "Disturbances of temperature regulation of newborn",
        value: "Disturbances of temperature regulation of newborn",
      },
      {
        label: "Environmental hyperthermia of newborn",
        value: "Environmental hyperthermia of newborn",
      },
      { label: "Fever of newborn", value: "Fever of newborn" },
      { label: "Hypothermia of newborn", value: "Hypothermia of newborn" },
      {
        label: "Neonatal cold injury syndrome",
        value: "Neonatal cold injury syndrome",
      },
      {
        label: "Other specified hypothermia of newborn",
        value: "Other specified hypothermia of newborn",
      },
      {
        label: "Hypothermia of newborn, unspecified",
        value: "Hypothermia of newborn, unspecified",
      },
      {
        label:
          "Other specified disturbances of temperature regulation of newborn",
        value:
          "Other specified disturbances of temperature regulation of newborn",
      },
      {
        label: "Disturbances of temperature regulation of newborn, unspecified",
        value: "Disturbances of temperature regulation of newborn, unspecified",
      },
      {
        label: "Certain disorders originating in the perinatal period",
        value: "Certain disorders originating in the perinatal period",
      },
      { label: "Birth depression", value: "Birth depression" },
      {
        label: "Birth depression with 5 minute Apgar score 0-3",
        value: "Birth depression with 5 minute Apgar score 0-3",
      },
      {
        label: "Birth depression with 5 minute Apgar score 4-6",
        value: "Birth depression with 5 minute Apgar score 4-6",
      },
      {
        label:
          "Birth depression with associated metabolic acidaemia of cord blood",
        value:
          "Birth depression with associated metabolic acidaemia of cord blood",
      },
      {
        label: "Birth depression, unspecified",
        value: "Birth depression, unspecified",
      },
      {
        label: "Wide cranial sutures of newborn",
        value: "Wide cranial sutures of newborn",
      },
      {
        label: "Feeding problems of newborn",
        value: "Feeding problems of newborn",
      },
      { label: "Slow feeding of newborn", value: "Slow feeding of newborn" },
      { label: "Underfeeding of newborn", value: "Underfeeding of newborn" },
      { label: "Overfeeding of newborn", value: "Overfeeding of newborn" },
      {
        label: "Neonatal difficulty in feeding at breast",
        value: "Neonatal difficulty in feeding at breast",
      },
      {
        label: "Failure to thrive in newborn",
        value: "Failure to thrive in newborn",
      },
      {
        label: "Other specified feeding problems of newborn",
        value: "Other specified feeding problems of newborn",
      },
      {
        label: "Feeding problems of newborn, unspecified",
        value: "Feeding problems of newborn, unspecified",
      },
      {
        label: "Jittery baby, not elsewhere classified",
        value: "Jittery baby, not elsewhere classified",
      },
      {
        label:
          "Reactions or intoxications due to drugs administered to fetus or newborn",
        value:
          "Reactions or intoxications due to drugs administered to fetus or newborn",
      },
      {
        label:
          "Neonatal withdrawal syndrome from maternal use of drugs of addiction",
        value:
          "Neonatal withdrawal syndrome from maternal use of drugs of addiction",
      },
      {
        label: "Withdrawal symptoms from therapeutic use of drugs in newborn",
        value: "Withdrawal symptoms from therapeutic use of drugs in newborn",
      },
      {
        label: "Exposure to tobacco smoke in the perinatal period",
        value: "Exposure to tobacco smoke in the perinatal period",
      },
      { label: "Meconium staining", value: "Meconium staining" },
      {
        label:
          "Complications of intrauterine procedures, not elsewhere classified",
        value:
          "Complications of intrauterine procedures, not elsewhere classified",
      },
      {
        label: "Fetus or newborn affected by amniocentesis",
        value: "Fetus or newborn affected by amniocentesis",
      },
      {
        label: "Fetus or newborn affected by chorionic villous sampling",
        value: "Fetus or newborn affected by chorionic villous sampling",
      },
      {
        label: "Fetus or newborn affected by fetal blood sampling",
        value: "Fetus or newborn affected by fetal blood sampling",
      },
      {
        label: "Fetus or newborn affected by complications of fetal surgery",
        value: "Fetus or newborn affected by complications of fetal surgery",
      },
      {
        label:
          "Fetus or newborn affected by complications of intrauterine fetal surgery",
        value:
          "Fetus or newborn affected by complications of intrauterine fetal surgery",
      },
      {
        label:
          "Other specified complications of intrauterine procedures, not elsewhere classified",
        value:
          "Other specified complications of intrauterine procedures, not elsewhere classified",
      },
      {
        label:
          "Complications of intrauterine procedures, not elsewhere classified, unspecified",
        value:
          "Complications of intrauterine procedures, not elsewhere classified, unspecified",
      },
      {
        label: "Termination of pregnancy, affecting surviving fetus or newborn",
        value: "Termination of pregnancy, affecting surviving fetus or newborn",
      },
      {
        label: "Fetal death, cause not specified",
        value: "Fetal death, cause not specified",
      },
      { label: "Antepartum fetal death", value: "Antepartum fetal death" },
      { label: "Intrapartum fetal death", value: "Intrapartum fetal death" },
      {
        label: "Unspecified time of fetal death, cause not specified",
        value: "Unspecified time of fetal death, cause not specified",
      },
      { label: "Vomiting in newborn", value: "Vomiting in newborn" },
      {
        label: "Bilious vomiting of newborn",
        value: "Bilious vomiting of newborn",
      },
      {
        label: "Other specified vomiting in newborn",
        value: "Other specified vomiting in newborn",
      },
      {
        label: "Vomiting in newborn, unspecified",
        value: "Vomiting in newborn, unspecified",
      },
      {
        label: "Other specified disorders originating in the perinatal period",
        value: "Other specified disorders originating in the perinatal period",
      },
      {
        label:
          "Conditions originating in the perinatal or neonatal period, unspecified",
        value:
          "Conditions originating in the perinatal or neonatal period, unspecified",
      },
      { label: "Developmental anomalies", value: "Developmental anomalies" },
      {
        label:
          "Structural developmental anomalies primarily affecting one body system",
        value:
          "Structural developmental anomalies primarily affecting one body system",
      },
      {
        label: "Structural developmental anomalies of the nervous system",
        value: "Structural developmental anomalies of the nervous system",
      },
      {
        label: "Anencephaly or similar anomalies",
        value: "Anencephaly or similar anomalies",
      },
      { label: "Anencephaly", value: "Anencephaly" },
      { label: "Craniorachischisis", value: "Craniorachischisis" },
      {
        label: "Other specified anencephaly",
        value: "Other specified anencephaly",
      },
      { label: "Anencephaly, unspecified", value: "Anencephaly, unspecified" },
      { label: "Iniencephaly", value: "Iniencephaly" },
      { label: "Acephaly", value: "Acephaly" },
      { label: "Amyelencephaly", value: "Amyelencephaly" },
      {
        label: "Other specified anencephaly or similar anomalies",
        value: "Other specified anencephaly or similar anomalies",
      },
      {
        label: "Anencephaly or similar anomalies, unspecified",
        value: "Anencephaly or similar anomalies, unspecified",
      },
      { label: "Cephalocele", value: "Cephalocele" },
      { label: "Spina bifida", value: "Spina bifida" },
      { label: "Spina bifida cystica", value: "Spina bifida cystica" },
      {
        label: "Myelomeningocele with hydrocephalus",
        value: "Myelomeningocele with hydrocephalus",
      },
      {
        label: "Myelomeningocele without hydrocephalus",
        value: "Myelomeningocele without hydrocephalus",
      },
      { label: "Myelocystocele", value: "Myelocystocele" },
      {
        label: "Other specified spina bifida cystica",
        value: "Other specified spina bifida cystica",
      },
      {
        label: "Spina bifida cystica, unspecified",
        value: "Spina bifida cystica, unspecified",
      },
      { label: "Spina bifida aperta", value: "Spina bifida aperta" },
      {
        label: "Other specified spina bifida",
        value: "Other specified spina bifida",
      },
      {
        label: "Spina bifida, unspecified",
        value: "Spina bifida, unspecified",
      },
      {
        label: "Arnold-Chiari malformation type II",
        value: "Arnold-Chiari malformation type II",
      },
      { label: "Congenital hydrocephalus", value: "Congenital hydrocephalus" },
      {
        label: "Hydrocephalus with stenosis of the aqueduct of Sylvius",
        value: "Hydrocephalus with stenosis of the aqueduct of Sylvius",
      },
      {
        label: "Other specified congenital hydrocephalus",
        value: "Other specified congenital hydrocephalus",
      },
      {
        label: "Congenital hydrocephalus, unspecified",
        value: "Congenital hydrocephalus, unspecified",
      },
      {
        label: "Cerebral structural developmental anomalies",
        value: "Cerebral structural developmental anomalies",
      },
      { label: "Microcephaly", value: "Microcephaly" },
      { label: "Megalencephaly", value: "Megalencephaly" },
      { label: "Holoprosencephaly", value: "Holoprosencephaly" },
      { label: "Corpus callosum agenesis", value: "Corpus callosum agenesis" },
      { label: "Arrhinencephaly", value: "Arrhinencephaly" },
      {
        label: "Abnormal neuronal migration",
        value: "Abnormal neuronal migration",
      },
      { label: "Polymicrogyria", value: "Polymicrogyria" },
      { label: "Cortical dysplasia", value: "Cortical dysplasia" },
      {
        label: "Other specified abnormal neuronal migration",
        value: "Other specified abnormal neuronal migration",
      },
      {
        label: "Abnormal neuronal migration, unspecified",
        value: "Abnormal neuronal migration, unspecified",
      },
      {
        label: "Encephaloclastic disorders",
        value: "Encephaloclastic disorders",
      },
      { label: "Porencephaly", value: "Porencephaly" },
      { label: "Schizencephaly", value: "Schizencephaly" },
      { label: "Hydranencephaly", value: "Hydranencephaly" },
      {
        label: "Other specified encephaloclastic disorders",
        value: "Other specified encephaloclastic disorders",
      },
      {
        label: "Encephaloclastic disorders, unspecified",
        value: "Encephaloclastic disorders, unspecified",
      },
      {
        label: "Brain cystic malformations",
        value: "Brain cystic malformations",
      },
      { label: "Colpocephaly", value: "Colpocephaly" },
      {
        label: "Other specified cerebral structural developmental anomalies",
        value: "Other specified cerebral structural developmental anomalies",
      },
      {
        label: "Cerebral structural developmental anomalies, unspecified",
        value: "Cerebral structural developmental anomalies, unspecified",
      },
      {
        label: "Cerebellar structural developmental anomalies",
        value: "Cerebellar structural developmental anomalies",
      },
      {
        label: "Dandy-Walker malformation",
        value: "Dandy-Walker malformation",
      },
      {
        label: "Hypoplasia or agenesis of cerebellar hemispheres",
        value: "Hypoplasia or agenesis of cerebellar hemispheres",
      },
      {
        label: "Focal cerebellar dysplasia",
        value: "Focal cerebellar dysplasia",
      },
      {
        label: "Other specified cerebellar structural developmental anomalies",
        value: "Other specified cerebellar structural developmental anomalies",
      },
      {
        label: "Cerebellar structural developmental anomalies, unspecified",
        value: "Cerebellar structural developmental anomalies, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column",
        value:
          "Structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column",
      },
      {
        label: "Primary tethered cord syndrome",
        value: "Primary tethered cord syndrome",
      },
      { label: "Diastematomyelia", value: "Diastematomyelia" },
      { label: "Amyelia", value: "Amyelia" },
      {
        label: "Primary syringomyelia or hydromyelia",
        value: "Primary syringomyelia or hydromyelia",
      },
      {
        label: "Arnold-Chiari malformation type I",
        value: "Arnold-Chiari malformation type I",
      },
      {
        label:
          "Other specified structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column",
        value:
          "Other specified structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column",
      },
      {
        label:
          "Structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column, unspecified",
        value:
          "Structural developmental anomalies of the neurenteric canal, spinal cord or vertebral column, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the nervous system",
        value:
          "Other specified structural developmental anomalies of the nervous system",
      },
      {
        label:
          "Structural developmental anomalies of the nervous system, unspecified",
        value:
          "Structural developmental anomalies of the nervous system, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the eye, eyelid or lacrimal apparatus",
        value:
          "Structural developmental anomalies of the eye, eyelid or lacrimal apparatus",
      },
      {
        label: "Structural developmental anomalies of ocular globes",
        value: "Structural developmental anomalies of ocular globes",
      },
      { label: "Microphthalmos", value: "Microphthalmos" },
      { label: "Clinical anophthalmos", value: "Clinical anophthalmos" },
      { label: "Buphthalmos", value: "Buphthalmos" },
      {
        label: "Congenital macrophthalmos",
        value: "Congenital macrophthalmos",
      },
      {
        label:
          "Other specified structural developmental anomalies of ocular globes",
        value:
          "Other specified structural developmental anomalies of ocular globes",
      },
      {
        label:
          "Structural developmental anomalies of ocular globes, unspecified",
        value:
          "Structural developmental anomalies of ocular globes, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the anterior segment of eye",
        value:
          "Structural developmental anomalies of the anterior segment of eye",
      },
      { label: "Blue sclera", value: "Blue sclera" },
      {
        label: "Structural developmental anomalies of cornea",
        value: "Structural developmental anomalies of cornea",
      },
      {
        label: "Anterior segment dysgenesis",
        value: "Anterior segment dysgenesis",
      },
      { label: "Aniridia", value: "Aniridia" },
      { label: "Coloboma of iris", value: "Coloboma of iris" },
      {
        label: "Congenital corneal opacity",
        value: "Congenital corneal opacity",
      },
      {
        label: "Structural disorders of the pupil",
        value: "Structural disorders of the pupil",
      },
      {
        label: "Irregular pupil of the eye",
        value: "Irregular pupil of the eye",
      },
      { label: "Iridoschisis", value: "Iridoschisis" },
      {
        label: "Anomalies of pupillary function",
        value: "Anomalies of pupillary function",
      },
      {
        label: "Other specified structural disorders of the pupil",
        value: "Other specified structural disorders of the pupil",
      },
      {
        label: "Structural disorders of the pupil, unspecified",
        value: "Structural disorders of the pupil, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the anterior segment of eye",
        value:
          "Other specified structural developmental anomalies of the anterior segment of eye",
      },
      {
        label:
          "Structural developmental anomalies of the anterior segment of eye, unspecified",
        value:
          "Structural developmental anomalies of the anterior segment of eye, unspecified",
      },
      {
        label: "Structural developmental anomalies of lens or zonula",
        value: "Structural developmental anomalies of lens or zonula",
      },
      { label: "Coloboma of lens", value: "Coloboma of lens" },
      { label: "Congenital cataract", value: "Congenital cataract" },
      { label: "Congenital aphakia", value: "Congenital aphakia" },
      { label: "Spherophakia", value: "Spherophakia" },
      {
        label:
          "Other specified structural developmental anomalies of lens or zonula",
        value:
          "Other specified structural developmental anomalies of lens or zonula",
      },
      {
        label:
          "Structural developmental anomalies of lens or zonula, unspecified",
        value:
          "Structural developmental anomalies of lens or zonula, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the posterior segment of eye",
        value:
          "Structural developmental anomalies of the posterior segment of eye",
      },
      {
        label: "Congenital anomalies of the vitreous",
        value: "Congenital anomalies of the vitreous",
      },
      {
        label: "Coloboma of choroid or retina",
        value: "Coloboma of choroid or retina",
      },
      { label: "Coloboma of macula", value: "Coloboma of macula" },
      {
        label: "Congenital vitreoretinal dysplasia",
        value: "Congenital vitreoretinal dysplasia",
      },
      {
        label: "Congenital retinal aneurysm",
        value: "Congenital retinal aneurysm",
      },
      {
        label: "Congenital malformations of choroid",
        value: "Congenital malformations of choroid",
      },
      {
        label: "Congenital malformation of optic disc",
        value: "Congenital malformation of optic disc",
      },
      {
        label: "Isolated optic nerve hypoplasia",
        value: "Isolated optic nerve hypoplasia",
      },
      { label: "Optic nerve aplasia", value: "Optic nerve aplasia" },
      {
        label: "Congenitally elevated optic disc",
        value: "Congenitally elevated optic disc",
      },
      { label: "Optic disc dysplasia", value: "Optic disc dysplasia" },
      { label: "Megalopapilla", value: "Megalopapilla" },
      { label: "Coloboma of optic disc", value: "Coloboma of optic disc" },
      {
        label: "Other specified congenital malformation of optic disc",
        value: "Other specified congenital malformation of optic disc",
      },
      {
        label: "Congenital malformation of optic disc, unspecified",
        value: "Congenital malformation of optic disc, unspecified",
      },
      {
        label: "Certain congenital malformations of posterior segment of eye",
        value: "Certain congenital malformations of posterior segment of eye",
      },
      {
        label: "Anastomosis of retinal or choroidal vessels",
        value: "Anastomosis of retinal or choroidal vessels",
      },
      {
        label:
          "Other specified structural developmental anomalies of the posterior segment of eye",
        value:
          "Other specified structural developmental anomalies of the posterior segment of eye",
      },
      {
        label:
          "Structural developmental anomalies of the posterior segment of eye, unspecified",
        value:
          "Structural developmental anomalies of the posterior segment of eye, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of eyelid, lacrimal apparatus or orbit",
        value:
          "Structural developmental anomalies of eyelid, lacrimal apparatus or orbit",
      },
      {
        label: "Structural developmental anomalies of eyelids",
        value: "Structural developmental anomalies of eyelids",
      },
      {
        label: "Palpebral cleft or coloboma",
        value: "Palpebral cleft or coloboma",
      },
      { label: "Cryptophthalmia", value: "Cryptophthalmia" },
      { label: "Congenital entropion", value: "Congenital entropion" },
      { label: "Congenital ectropion", value: "Congenital ectropion" },
      { label: "Congenital ptosis", value: "Congenital ptosis" },
      {
        label: "Congenital eyelid retraction",
        value: "Congenital eyelid retraction",
      },
      { label: "Epibulbar choristoma", value: "Epibulbar choristoma" },
      {
        label: "Ankyloblepharon filiforme adnatum",
        value: "Ankyloblepharon filiforme adnatum",
      },
      {
        label: "Other specified structural developmental anomalies of eyelids",
        value: "Other specified structural developmental anomalies of eyelids",
      },
      {
        label: "Structural developmental anomalies of lacrimal apparatus",
        value: "Structural developmental anomalies of lacrimal apparatus",
      },
      {
        label: "Aplasia of lacrimal or salivary glands",
        value: "Aplasia of lacrimal or salivary glands",
      },
      {
        label: "Agenesis of lacrimal ducts",
        value: "Agenesis of lacrimal ducts",
      },
      { label: "Congenital dacryocele", value: "Congenital dacryocele" },
      {
        label: "Congenital agenesis of lacrimal punctum",
        value: "Congenital agenesis of lacrimal punctum",
      },
      {
        label: "Congenital stenosis or stricture of lacrimal duct",
        value: "Congenital stenosis or stricture of lacrimal duct",
      },
      {
        label:
          "Other specified structural developmental anomalies of lacrimal apparatus",
        value:
          "Other specified structural developmental anomalies of lacrimal apparatus",
      },
      {
        label:
          "Structural developmental anomalies of lacrimal apparatus, unspecified",
        value:
          "Structural developmental anomalies of lacrimal apparatus, unspecified",
      },
      {
        label: "Structural developmental anomalies of orbit",
        value: "Structural developmental anomalies of orbit",
      },
      {
        label:
          "Other specified structural developmental anomalies of eyelid, lacrimal apparatus or orbit",
        value:
          "Other specified structural developmental anomalies of eyelid, lacrimal apparatus or orbit",
      },
      {
        label:
          "Structural developmental anomalies of eyelid, lacrimal apparatus or orbit, unspecified",
        value:
          "Structural developmental anomalies of eyelid, lacrimal apparatus or orbit, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the eye, eyelid or lacrimal apparatus",
        value:
          "Other specified structural developmental anomalies of the eye, eyelid or lacrimal apparatus",
      },
      {
        label:
          "Structural developmental anomalies of the eye, eyelid or lacrimal apparatus, unspecified",
        value:
          "Structural developmental anomalies of the eye, eyelid or lacrimal apparatus, unspecified",
      },
      {
        label: "Structural developmental anomalies of the ear",
        value: "Structural developmental anomalies of the ear",
      },
      {
        label: "Structural anomaly of eustachian apparatus",
        value: "Structural anomaly of eustachian apparatus",
      },
      {
        label: "Minor anomalies of pinnae",
        value: "Minor anomalies of pinnae",
      },
      { label: "Macrotia", value: "Macrotia" },
      { label: "Protruding ear", value: "Protruding ear" },
      { label: "Low-set ear", value: "Low-set ear" },
      { label: "Misshapen ear", value: "Misshapen ear" },
      {
        label: "Other specified minor anomalies of pinnae",
        value: "Other specified minor anomalies of pinnae",
      },
      {
        label:
          "Structural developmental anomalies of ear causing hearing impairment",
        value:
          "Structural developmental anomalies of ear causing hearing impairment",
      },
      { label: "Microtia", value: "Microtia" },
      { label: "Anotia", value: "Anotia" },
      {
        label: "Aplasia or hypoplasia of external auditory canal",
        value: "Aplasia or hypoplasia of external auditory canal",
      },
      {
        label: "Structural developmental anomalies of ear ossicles",
        value: "Structural developmental anomalies of ear ossicles",
      },
      {
        label: "Structural developmental anomalies of inner ear",
        value: "Structural developmental anomalies of inner ear",
      },
      {
        label:
          "Other specified structural developmental anomalies of ear causing hearing impairment",
        value:
          "Other specified structural developmental anomalies of ear causing hearing impairment",
      },
      {
        label:
          "Structural developmental anomalies of ear causing hearing impairment, unspecified",
        value:
          "Structural developmental anomalies of ear causing hearing impairment, unspecified",
      },
      { label: "Otocephaly", value: "Otocephaly" },
      { label: "Accessory auricle", value: "Accessory auricle" },
      {
        label: "Other specified structural developmental anomalies of the ear",
        value: "Other specified structural developmental anomalies of the ear",
      },
      {
        label: "Structural developmental anomalies of the ear, unspecified",
        value: "Structural developmental anomalies of the ear, unspecified",
      },
      {
        label: "Structural developmental anomalies of the face, mouth or teeth",
        value: "Structural developmental anomalies of the face, mouth or teeth",
      },
      {
        label:
          "Structural developmental anomalies of teeth and periodontal tissues",
        value:
          "Structural developmental anomalies of teeth and periodontal tissues",
      },
      { label: "Anodontia", value: "Anodontia" },
      { label: "Hypodontia", value: "Hypodontia" },
      { label: "Oligodontia", value: "Oligodontia" },
      { label: "Hyperdontia", value: "Hyperdontia" },
      {
        label: "Abnormalities of size or form of teeth",
        value: "Abnormalities of size or form of teeth",
      },
      {
        label: "Anomalies in tooth resorption or loss",
        value: "Anomalies in tooth resorption or loss",
      },
      {
        label: "Early exfoliation of teeth",
        value: "Early exfoliation of teeth",
      },
      {
        label: "Late exfoliation of teeth",
        value: "Late exfoliation of teeth",
      },
      {
        label: "Other specified anomalies in tooth resorption or loss",
        value: "Other specified anomalies in tooth resorption or loss",
      },
      {
        label: "Anomalies in tooth resorption or loss, unspecified",
        value: "Anomalies in tooth resorption or loss, unspecified",
      },
      { label: "Amelogenesis imperfecta", value: "Amelogenesis imperfecta" },
      { label: "Dentine dysplasia", value: "Dentine dysplasia" },
      {
        label: "Dentinogenesis imperfecta",
        value: "Dentinogenesis imperfecta",
      },
      { label: "Odontogenesis imperfecta", value: "Odontogenesis imperfecta" },
      {
        label:
          "Other specified structural developmental anomalies of teeth and periodontal tissues",
        value:
          "Other specified structural developmental anomalies of teeth and periodontal tissues",
      },
      {
        label:
          "Structural developmental anomalies of teeth and periodontal tissues, unspecified",
        value:
          "Structural developmental anomalies of teeth and periodontal tissues, unspecified",
      },
      {
        label: "Structural developmental anomalies of mouth or tongue",
        value: "Structural developmental anomalies of mouth or tongue",
      },
      { label: "Congenital macroglossia", value: "Congenital macroglossia" },
      { label: "Hypoglossia or aglossia", value: "Hypoglossia or aglossia" },
      { label: "Ankyloglossia", value: "Ankyloglossia" },
      { label: "Macrostomia", value: "Macrostomia" },
      { label: "Microstomia", value: "Microstomia" },
      {
        label:
          "Other specified structural developmental anomalies of mouth or tongue",
        value:
          "Other specified structural developmental anomalies of mouth or tongue",
      },
      {
        label: "Clefts of lip, alveolus or palate",
        value: "Clefts of lip, alveolus or palate",
      },
      { label: "Cleft lip", value: "Cleft lip" },
      { label: "Cleft lip, unilateral", value: "Cleft lip, unilateral" },
      { label: "Cleft lip, bilateral", value: "Cleft lip, bilateral" },
      { label: "Cleft lip, median", value: "Cleft lip, median" },
      { label: "Cleft lip and alveolus", value: "Cleft lip and alveolus" },
      {
        label: "Cleft lip and alveolus, unilateral",
        value: "Cleft lip and alveolus, unilateral",
      },
      {
        label: "Cleft lip and alveolus, bilateral",
        value: "Cleft lip and alveolus, bilateral",
      },
      { label: "Cleft palate", value: "Cleft palate" },
      { label: "Cleft hard palate", value: "Cleft hard palate" },
      { label: "Cleft soft palate", value: "Cleft soft palate" },
      { label: "Cleft uvula", value: "Cleft uvula" },
      {
        label: "Other specified clefts of lip, alveolus or palate",
        value: "Other specified clefts of lip, alveolus or palate",
      },
      {
        label: "Clefts of lip, alveolus or palate, unspecified",
        value: "Clefts of lip, alveolus or palate, unspecified",
      },
      {
        label: "Congenital velopharyngeal incompetence",
        value: "Congenital velopharyngeal incompetence",
      },
      { label: "Facial clefts", value: "Facial clefts" },
      { label: "Facial asymmetry", value: "Facial asymmetry" },
      { label: "Macrocheilia", value: "Macrocheilia" },
      { label: "Microcheilia", value: "Microcheilia" },
      { label: "Compression facies", value: "Compression facies" },
      { label: "Pierre Robin syndrome", value: "Pierre Robin syndrome" },
      {
        label:
          "Other specified structural developmental anomalies of the face, mouth or teeth",
        value:
          "Other specified structural developmental anomalies of the face, mouth or teeth",
      },
      {
        label:
          "Structural developmental anomalies of the face, mouth or teeth, unspecified",
        value:
          "Structural developmental anomalies of the face, mouth or teeth, unspecified",
      },
      {
        label: "Structural developmental anomalies of the neck",
        value: "Structural developmental anomalies of the neck",
      },
      { label: "Webbed neck", value: "Webbed neck" },
      {
        label: "Congenital sternomastoid tumour",
        value: "Congenital sternomastoid tumour",
      },
      { label: "Congenital torticollis", value: "Congenital torticollis" },
      {
        label: "Other specified structural developmental anomalies of the neck",
        value: "Other specified structural developmental anomalies of the neck",
      },
      {
        label: "Structural developmental anomalies of the neck, unspecified",
        value: "Structural developmental anomalies of the neck, unspecified",
      },
      {
        label: "Structural developmental anomalies of the respiratory system",
        value: "Structural developmental anomalies of the respiratory system",
      },
      {
        label: "Structural developmental anomalies of the nose or cavum",
        value: "Structural developmental anomalies of the nose or cavum",
      },
      { label: "Arrhinia", value: "Arrhinia" },
      { label: "Bifid nose", value: "Bifid nose" },
      { label: "Choanal atresia", value: "Choanal atresia" },
      {
        label: "Congenital perforated nasal septum",
        value: "Congenital perforated nasal septum",
      },
      {
        label:
          "Other specified structural developmental anomalies of the nose or cavum",
        value:
          "Other specified structural developmental anomalies of the nose or cavum",
      },
      {
        label:
          "Structural developmental anomalies of the nose or cavum, unspecified",
        value:
          "Structural developmental anomalies of the nose or cavum, unspecified",
      },
      {
        label: "Structural developmental anomalies of larynx",
        value: "Structural developmental anomalies of larynx",
      },
      {
        label: "Congenital laryngomalacia",
        value: "Congenital laryngomalacia",
      },
      { label: "Laryngocele", value: "Laryngocele" },
      { label: "Laryngeal hypoplasia", value: "Laryngeal hypoplasia" },
      {
        label: "Congenital subglottic stenosis",
        value: "Congenital subglottic stenosis",
      },
      {
        label: "Other specified structural developmental anomalies of larynx",
        value: "Other specified structural developmental anomalies of larynx",
      },
      {
        label: "Structural developmental anomalies of larynx, unspecified",
        value: "Structural developmental anomalies of larynx, unspecified",
      },
      {
        label: "Laryngotracheooesophageal cleft",
        value: "Laryngotracheooesophageal cleft",
      },
      {
        label: "Structural developmental anomalies of trachea",
        value: "Structural developmental anomalies of trachea",
      },
      {
        label: "Congenital stenosis of trachea",
        value: "Congenital stenosis of trachea",
      },
      {
        label: "Congenital tracheomalacia",
        value: "Congenital tracheomalacia",
      },
      {
        label: "Other specified structural developmental anomalies of trachea",
        value: "Other specified structural developmental anomalies of trachea",
      },
      {
        label: "Structural developmental anomalies of trachea, unspecified",
        value: "Structural developmental anomalies of trachea, unspecified",
      },
      {
        label: "Structural developmental anomalies of bronchi",
        value: "Structural developmental anomalies of bronchi",
      },
      {
        label: "Congenital stenosis or atresia of bronchus",
        value: "Congenital stenosis or atresia of bronchus",
      },
      {
        label: "Congenital bronchomalacia",
        value: "Congenital bronchomalacia",
      },
      {
        label: "Other specified structural developmental anomalies of bronchi",
        value: "Other specified structural developmental anomalies of bronchi",
      },
      {
        label: "Structural developmental anomalies of bronchi, unspecified",
        value: "Structural developmental anomalies of bronchi, unspecified",
      },
      {
        label: "Structural developmental anomalies of lungs",
        value: "Structural developmental anomalies of lungs",
      },
      { label: "Accessory lobe of lung", value: "Accessory lobe of lung" },
      { label: "Agenesis of lung", value: "Agenesis of lung" },
      {
        label: "Congenital hypoplasia of lung",
        value: "Congenital hypoplasia of lung",
      },
      {
        label: "Congenital hyperplasia of lung",
        value: "Congenital hyperplasia of lung",
      },
      {
        label: "Congenital pulmonary airway malformations",
        value: "Congenital pulmonary airway malformations",
      },
      {
        label: "Congenital lobar emphysema",
        value: "Congenital lobar emphysema",
      },
      {
        label: "Congenital sequestration of lung",
        value: "Congenital sequestration of lung",
      },
      {
        label: "Other specified structural developmental anomalies of lungs",
        value: "Other specified structural developmental anomalies of lungs",
      },
      {
        label: "Structural developmental anomalies of lungs, unspecified",
        value: "Structural developmental anomalies of lungs, unspecified",
      },
      {
        label: "Structural developmental anomalies of pleura",
        value: "Structural developmental anomalies of pleura",
      },
      {
        label: "Congenital cyst of mediastinum",
        value: "Congenital cyst of mediastinum",
      },
      {
        label:
          "Other specified structural developmental anomalies of the respiratory system",
        value:
          "Other specified structural developmental anomalies of the respiratory system",
      },
      {
        label:
          "Structural developmental anomalies of the respiratory system, unspecified",
        value:
          "Structural developmental anomalies of the respiratory system, unspecified",
      },
      {
        label: "Structural developmental anomalies of the circulatory system",
        value: "Structural developmental anomalies of the circulatory system",
      },
      {
        label: "Structural developmental anomaly of heart or great vessels",
        value: "Structural developmental anomaly of heart or great vessels",
      },
      {
        label: "Anomalous position-orientation of heart",
        value: "Anomalous position-orientation of heart",
      },
      { label: "Laevocardia", value: "Laevocardia" },
      { label: "Dextrocardia", value: "Dextrocardia" },
      { label: "Mesocardia", value: "Mesocardia" },
      { label: "Extrathoracic heart", value: "Extrathoracic heart" },
      {
        label: "Other specified anomalous position-orientation of heart",
        value: "Other specified anomalous position-orientation of heart",
      },
      {
        label: "Anomalous position-orientation of heart, unspecified",
        value: "Anomalous position-orientation of heart, unspecified",
      },
      {
        label: "Abnormal ventricular relationships",
        value: "Abnormal ventricular relationships",
      },
      { label: "Total mirror imagery", value: "Total mirror imagery" },
      { label: "Right isomerism", value: "Right isomerism" },
      { label: "Left isomerism", value: "Left isomerism" },
      {
        label:
          "Congenital anomaly of an atrioventricular or ventriculo-arterial connection",
        value:
          "Congenital anomaly of an atrioventricular or ventriculo-arterial connection",
      },
      {
        label: "Discordant atrioventricular connections",
        value: "Discordant atrioventricular connections",
      },
      {
        label: "Congenitally corrected transposition of great arteries",
        value: "Congenitally corrected transposition of great arteries",
      },
      {
        label: "Other specified discordant atrioventricular connections",
        value: "Other specified discordant atrioventricular connections",
      },
      {
        label: "Discordant atrioventricular connections, unspecified",
        value: "Discordant atrioventricular connections, unspecified",
      },
      {
        label: "Transposition of the great arteries",
        value: "Transposition of the great arteries",
      },
      {
        label: "Double outlet right ventricle",
        value: "Double outlet right ventricle",
      },
      {
        label:
          "Double outlet right ventricle with subpulmonary ventricular septal defect, transposition type",
        value:
          "Double outlet right ventricle with subpulmonary ventricular septal defect, transposition type",
      },
      {
        label:
          "Double outlet right ventricle with non-committed ventricular septal defect",
        value:
          "Double outlet right ventricle with non-committed ventricular septal defect",
      },
      {
        label:
          "Double outlet right ventricle with subaortic or doubly committed ventricular septal defect without pulmonary stenosis, ventricular septal defect type",
        value:
          "Double outlet right ventricle with subaortic or doubly committed ventricular septal defect without pulmonary stenosis, ventricular septal defect type",
      },
      {
        label:
          "Double outlet right ventricle with subaortic or doubly committed ventricular septal defect and pulmonary stenosis, Fallot type",
        value:
          "Double outlet right ventricle with subaortic or doubly committed ventricular septal defect and pulmonary stenosis, Fallot type",
      },
      {
        label: "Other specified double outlet right ventricle",
        value: "Other specified double outlet right ventricle",
      },
      {
        label: "Double outlet right ventricle, unspecified",
        value: "Double outlet right ventricle, unspecified",
      },
      {
        label: "Double outlet left ventricle",
        value: "Double outlet left ventricle",
      },
      { label: "Common arterial trunk", value: "Common arterial trunk" },
      {
        label: "Common arterial trunk with aortic dominance",
        value: "Common arterial trunk with aortic dominance",
      },
      {
        label:
          "Common arterial trunk with pulmonary dominance and interrupted aortic arch",
        value:
          "Common arterial trunk with pulmonary dominance and interrupted aortic arch",
      },
      {
        label: "Other specified common arterial trunk",
        value: "Other specified common arterial trunk",
      },
      {
        label: "Common arterial trunk, unspecified",
        value: "Common arterial trunk, unspecified",
      },
      {
        label:
          "Other specified congenital anomaly of an atrioventricular or ventriculo-arterial connection",
        value:
          "Other specified congenital anomaly of an atrioventricular or ventriculo-arterial connection",
      },
      {
        label:
          "Congenital anomaly of an atrioventricular or ventriculo-arterial connection, unspecified",
        value:
          "Congenital anomaly of an atrioventricular or ventriculo-arterial connection, unspecified",
      },
      {
        label: "Congenital anomaly of mediastinal vein",
        value: "Congenital anomaly of mediastinal vein",
      },
      { label: "Left superior caval vein", value: "Left superior caval vein" },
      { label: "Unroofed coronary sinus", value: "Unroofed coronary sinus" },
      {
        label: "Anomalous pulmonary venous connection",
        value: "Anomalous pulmonary venous connection",
      },
      {
        label: "Total anomalous pulmonary venous connection",
        value: "Total anomalous pulmonary venous connection",
      },
      {
        label: "Partial anomalous pulmonary venous connection",
        value: "Partial anomalous pulmonary venous connection",
      },
      { label: "Scimitar syndrome", value: "Scimitar syndrome" },
      {
        label: "Other specified anomalous pulmonary venous connection",
        value: "Other specified anomalous pulmonary venous connection",
      },
      {
        label: "Anomalous pulmonary venous connection, unspecified",
        value: "Anomalous pulmonary venous connection, unspecified",
      },
      {
        label: "Congenital pulmonary venous stenosis or hypoplasia",
        value: "Congenital pulmonary venous stenosis or hypoplasia",
      },
      {
        label: "Other specified congenital anomaly of mediastinal vein",
        value: "Other specified congenital anomaly of mediastinal vein",
      },
      {
        label: "Congenital anomaly of mediastinal vein, unspecified",
        value: "Congenital anomaly of mediastinal vein, unspecified",
      },
      {
        label:
          "Congenital anomaly of an atrioventricular valve or atrioventricular septum",
        value:
          "Congenital anomaly of an atrioventricular valve or atrioventricular septum",
      },
      {
        label: "Congenital anomaly of tricuspid valve",
        value: "Congenital anomaly of tricuspid valve",
      },
      {
        label: "Congenital tricuspid regurgitation",
        value: "Congenital tricuspid regurgitation",
      },
      {
        label: "Congenital tricuspid valvar stenosis",
        value: "Congenital tricuspid valvar stenosis",
      },
      {
        label: "Dysplasia of tricuspid valve",
        value: "Dysplasia of tricuspid valve",
      },
      {
        label: "Ebstein malformation of tricuspid valve",
        value: "Ebstein malformation of tricuspid valve",
      },
      {
        label: "Other specified congenital anomaly of tricuspid valve",
        value: "Other specified congenital anomaly of tricuspid valve",
      },
      {
        label: "Congenital anomaly of tricuspid valve, unspecified",
        value: "Congenital anomaly of tricuspid valve, unspecified",
      },
      {
        label: "Congenital anomaly of mitral valve",
        value: "Congenital anomaly of mitral valve",
      },
      {
        label: "Congenital mitral regurgitation",
        value: "Congenital mitral regurgitation",
      },
      {
        label: "Congenital mitral valvar stenosis",
        value: "Congenital mitral valvar stenosis",
      },
      {
        label: "Dysplasia of mitral valve",
        value: "Dysplasia of mitral valve",
      },
      {
        label: "Congenital anomaly of mitral subvalvar apparatus",
        value: "Congenital anomaly of mitral subvalvar apparatus",
      },
      {
        label: "Other specified congenital anomaly of mitral valve",
        value: "Other specified congenital anomaly of mitral valve",
      },
      {
        label: "Congenital anomaly of mitral valve, unspecified",
        value: "Congenital anomaly of mitral valve, unspecified",
      },
      {
        label: "Common atrioventricular junction",
        value: "Common atrioventricular junction",
      },
      {
        label: "Atrioventricular septal defect",
        value: "Atrioventricular septal defect",
      },
      {
        label: "Other specified common atrioventricular junction",
        value: "Other specified common atrioventricular junction",
      },
      {
        label: "Common atrioventricular junction, unspecified",
        value: "Common atrioventricular junction, unspecified",
      },
      {
        label:
          "Other specified congenital anomaly of an atrioventricular valve or atrioventricular septum",
        value:
          "Other specified congenital anomaly of an atrioventricular valve or atrioventricular septum",
      },
      {
        label:
          "Congenital anomaly of an atrioventricular valve or atrioventricular septum, unspecified",
        value:
          "Congenital anomaly of an atrioventricular valve or atrioventricular septum, unspecified",
      },
      {
        label: "Congenital anomaly of a ventricle or the ventricular septum",
        value: "Congenital anomaly of a ventricle or the ventricular septum",
      },
      {
        label: "Congenital right ventricular outflow tract obstruction",
        value: "Congenital right ventricular outflow tract obstruction",
      },
      {
        label: "Double chambered right ventricle",
        value: "Double chambered right ventricle",
      },
      { label: "Tetralogy of Fallot", value: "Tetralogy of Fallot" },
      {
        label: "Tetralogy of Fallot with absent pulmonary valve syndrome",
        value: "Tetralogy of Fallot with absent pulmonary valve syndrome",
      },
      {
        label: "Tetralogy of Fallot with pulmonary atresia",
        value: "Tetralogy of Fallot with pulmonary atresia",
      },
      {
        label:
          "Tetralogy of Fallot with pulmonary atresia and systemic-to-pulmonary collateral artery",
        value:
          "Tetralogy of Fallot with pulmonary atresia and systemic-to-pulmonary collateral artery",
      },
      {
        label: "Other specified tetralogy of Fallot",
        value: "Other specified tetralogy of Fallot",
      },
      {
        label: "Tetralogy of Fallot, unspecified",
        value: "Tetralogy of Fallot, unspecified",
      },
      {
        label: "Congenital left ventricular outflow tract obstruction",
        value: "Congenital left ventricular outflow tract obstruction",
      },
      {
        label: "Ventricular septal defect",
        value: "Ventricular septal defect",
      },
      {
        label: "Trabecular muscular ventricular septal defect",
        value: "Trabecular muscular ventricular septal defect",
      },
      {
        label: "Perimembranous central ventricular septal defect",
        value: "Perimembranous central ventricular septal defect",
      },
      {
        label: "Ventricular septal defect haemodynamically insignificant",
        value: "Ventricular septal defect haemodynamically insignificant",
      },
      {
        label: "Other specified ventricular septal defect",
        value: "Other specified ventricular septal defect",
      },
      {
        label: "Ventricular septal defect, unspecified",
        value: "Ventricular septal defect, unspecified",
      },
      {
        label:
          "Other specified congenital anomaly of a ventricle or the ventricular septum",
        value:
          "Other specified congenital anomaly of a ventricle or the ventricular septum",
      },
      {
        label:
          "Congenital anomaly of a ventricle or the ventricular septum, unspecified",
        value:
          "Congenital anomaly of a ventricle or the ventricular septum, unspecified",
      },
      {
        label: "Functionally univentricular heart",
        value: "Functionally univentricular heart",
      },
      {
        label: "Double inlet atrioventricular connection",
        value: "Double inlet atrioventricular connection",
      },
      { label: "Tricuspid atresia", value: "Tricuspid atresia" },
      { label: "Mitral atresia", value: "Mitral atresia" },
      {
        label: "Hypoplastic left heart syndrome",
        value: "Hypoplastic left heart syndrome",
      },
      {
        label: "Other specified functionally univentricular heart",
        value: "Other specified functionally univentricular heart",
      },
      {
        label: "Functionally univentricular heart, unspecified",
        value: "Functionally univentricular heart, unspecified",
      },
      {
        label:
          "Congenital anomaly of a ventriculo-arterial valve or adjacent regions",
        value:
          "Congenital anomaly of a ventriculo-arterial valve or adjacent regions",
      },
      {
        label: "Congenital anomaly of pulmonary valve",
        value: "Congenital anomaly of pulmonary valve",
      },
      {
        label: "Congenital pulmonary valvar stenosis",
        value: "Congenital pulmonary valvar stenosis",
      },
      {
        label: "Congenital pulmonary regurgitation",
        value: "Congenital pulmonary regurgitation",
      },
      {
        label: "Other specified congenital anomaly of pulmonary valve",
        value: "Other specified congenital anomaly of pulmonary valve",
      },
      {
        label: "Congenital anomaly of pulmonary valve, unspecified",
        value: "Congenital anomaly of pulmonary valve, unspecified",
      },
      {
        label: "Congenital pulmonary atresia",
        value: "Congenital pulmonary atresia",
      },
      {
        label: "Pulmonary atresia with intact ventricular septum",
        value: "Pulmonary atresia with intact ventricular septum",
      },
      {
        label: "Other specified congenital pulmonary atresia",
        value: "Other specified congenital pulmonary atresia",
      },
      {
        label: "Congenital pulmonary atresia, unspecified",
        value: "Congenital pulmonary atresia, unspecified",
      },
      {
        label: "Congenital anomaly of aortic valve",
        value: "Congenital anomaly of aortic valve",
      },
      {
        label: "Congenital aortic valvar stenosis",
        value: "Congenital aortic valvar stenosis",
      },
      {
        label: "Congenital aortic regurgitation",
        value: "Congenital aortic regurgitation",
      },
      { label: "Bicuspid aortic valve", value: "Bicuspid aortic valve" },
      { label: "Aortic valvar atresia", value: "Aortic valvar atresia" },
      { label: "Unicuspid aortic valve", value: "Unicuspid aortic valve" },
      {
        label: "Other specified congenital anomaly of aortic valve",
        value: "Other specified congenital anomaly of aortic valve",
      },
      {
        label: "Congenital anomaly of aortic valve, unspecified",
        value: "Congenital anomaly of aortic valve, unspecified",
      },
      {
        label: "Congenital supravalvar aortic stenosis",
        value: "Congenital supravalvar aortic stenosis",
      },
      {
        label: "Aneurysm of aortic sinus of Valsalva",
        value: "Aneurysm of aortic sinus of Valsalva",
      },
      {
        label: "Congenital subaortic stenosis",
        value: "Congenital subaortic stenosis",
      },
      {
        label: "Congenital subpulmonary stenosis",
        value: "Congenital subpulmonary stenosis",
      },
      {
        label:
          "Other specified congenital anomaly of a ventriculo-arterial valve or adjacent regions",
        value:
          "Other specified congenital anomaly of a ventriculo-arterial valve or adjacent regions",
      },
      {
        label:
          "Congenital anomaly of a ventriculo-arterial valve or adjacent regions, unspecified",
        value:
          "Congenital anomaly of a ventriculo-arterial valve or adjacent regions, unspecified",
      },
      {
        label: "Congenital anomaly of great arteries including arterial duct",
        value: "Congenital anomaly of great arteries including arterial duct",
      },
      {
        label: "Congenital aortopulmonary window",
        value: "Congenital aortopulmonary window",
      },
      {
        label: "Congenital anomaly of pulmonary arterial tree",
        value: "Congenital anomaly of pulmonary arterial tree",
      },
      {
        label: "Congenital anomaly of aorta or its branches",
        value: "Congenital anomaly of aorta or its branches",
      },
      {
        label: "Aberrant origin of right subclavian artery",
        value: "Aberrant origin of right subclavian artery",
      },
      { label: "Coarctation of aorta", value: "Coarctation of aorta" },
      { label: "Interrupted aortic arch", value: "Interrupted aortic arch" },
      {
        label: "Other specified congenital anomaly of aorta or its branches",
        value: "Other specified congenital anomaly of aorta or its branches",
      },
      {
        label: "Congenital anomaly of aorta or its branches, unspecified",
        value: "Congenital anomaly of aorta or its branches, unspecified",
      },
      {
        label: "Tracheo-oesophageal compressive syndrome",
        value: "Tracheo-oesophageal compressive syndrome",
      },
      { label: "Patent arterial duct", value: "Patent arterial duct" },
      {
        label:
          "Other specified congenital anomaly of great arteries including arterial duct",
        value:
          "Other specified congenital anomaly of great arteries including arterial duct",
      },
      {
        label:
          "Congenital anomaly of great arteries including arterial duct, unspecified",
        value:
          "Congenital anomaly of great arteries including arterial duct, unspecified",
      },
      {
        label: "Congenital anomaly of coronary artery",
        value: "Congenital anomaly of coronary artery",
      },
      {
        label:
          "Anomalous origin of coronary artery from pulmonary arterial tree",
        value:
          "Anomalous origin of coronary artery from pulmonary arterial tree",
      },
      {
        label: "Anomalous aortic origin or course of coronary artery",
        value: "Anomalous aortic origin or course of coronary artery",
      },
      {
        label: "Congenital coronary arterial fistula",
        value: "Congenital coronary arterial fistula",
      },
      {
        label: "Other specified congenital anomaly of coronary artery",
        value: "Other specified congenital anomaly of coronary artery",
      },
      {
        label: "Congenital anomaly of coronary artery, unspecified",
        value: "Congenital anomaly of coronary artery, unspecified",
      },
      {
        label: "Congenital pericardial anomaly",
        value: "Congenital pericardial anomaly",
      },
      {
        label: "Congenital anomaly of atrial septum",
        value: "Congenital anomaly of atrial septum",
      },
      { label: "Patent oval foramen", value: "Patent oval foramen" },
      {
        label: "Atrial septal defect within oval fossa",
        value: "Atrial septal defect within oval fossa",
      },
      { label: "Sinus venosus defect", value: "Sinus venosus defect" },
      {
        label: "Interatrial communication through coronary sinus orifice",
        value: "Interatrial communication through coronary sinus orifice",
      },
      {
        label: "Other specified congenital anomaly of atrial septum",
        value: "Other specified congenital anomaly of atrial septum",
      },
      {
        label: "Congenital anomaly of atrial septum, unspecified",
        value: "Congenital anomaly of atrial septum, unspecified",
      },
      {
        label: "Congenital anomaly of right atrium",
        value: "Congenital anomaly of right atrium",
      },
      {
        label: "Congenital anomaly of left atrium",
        value: "Congenital anomaly of left atrium",
      },
      { label: "Divided left atrium", value: "Divided left atrium" },
      {
        label: "Other specified congenital anomaly of left atrium",
        value: "Other specified congenital anomaly of left atrium",
      },
      {
        label: "Congenital anomaly of left atrium, unspecified",
        value: "Congenital anomaly of left atrium, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomaly of heart or great vessels",
        value:
          "Other specified structural developmental anomaly of heart or great vessels",
      },
      {
        label:
          "Structural developmental anomaly of heart or great vessels, unspecified",
        value:
          "Structural developmental anomaly of heart or great vessels, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the peripheral vascular system",
        value:
          "Structural developmental anomalies of the peripheral vascular system",
      },
      { label: "Capillary malformations", value: "Capillary malformations" },
      {
        label: "Hereditary haemorrhagic telangiectasia",
        value: "Hereditary haemorrhagic telangiectasia",
      },
      {
        label: "Other specified capillary malformations",
        value: "Other specified capillary malformations",
      },
      {
        label: "Capillary malformations, unspecified",
        value: "Capillary malformations, unspecified",
      },
      { label: "Lymphatic malformations", value: "Lymphatic malformations" },
      {
        label: "Macrocystic lymphatic malformation",
        value: "Macrocystic lymphatic malformation",
      },
      {
        label: "Microcystic lymphatic malformation",
        value: "Microcystic lymphatic malformation",
      },
      {
        label: "Lymphatic malformations of certain specified sites",
        value: "Lymphatic malformations of certain specified sites",
      },
      { label: "Cystic hygroma in fetus", value: "Cystic hygroma in fetus" },
      {
        label: "Other specified lymphatic malformations",
        value: "Other specified lymphatic malformations",
      },
      {
        label: "Lymphatic malformations, unspecified",
        value: "Lymphatic malformations, unspecified",
      },
      {
        label: "Peripheral venous malformations",
        value: "Peripheral venous malformations",
      },
      { label: "Vein of Galen aneurysm", value: "Vein of Galen aneurysm" },
      {
        label: "Anomalous portal venous connection",
        value: "Anomalous portal venous connection",
      },
      {
        label: "Other specified peripheral venous malformations",
        value: "Other specified peripheral venous malformations",
      },
      {
        label: "Peripheral venous malformations, unspecified",
        value: "Peripheral venous malformations, unspecified",
      },
      {
        label: "Peripheral arteriovenous malformations",
        value: "Peripheral arteriovenous malformations",
      },
      {
        label: "Portal vein-hepatic artery fistula",
        value: "Portal vein-hepatic artery fistula",
      },
      {
        label: "Arteriovenous malformation of precerebral vessels",
        value: "Arteriovenous malformation of precerebral vessels",
      },
      {
        label: "Uterine arteriovenous malformations",
        value: "Uterine arteriovenous malformations",
      },
      {
        label: "Other specified peripheral arteriovenous malformations",
        value: "Other specified peripheral arteriovenous malformations",
      },
      {
        label: "Peripheral arteriovenous malformations, unspecified",
        value: "Peripheral arteriovenous malformations, unspecified",
      },
      {
        label: "Peripheral arterial malformations",
        value: "Peripheral arterial malformations",
      },
      {
        label: "Congenital renal artery stenosis",
        value: "Congenital renal artery stenosis",
      },
      {
        label: "Congenital precerebral nonruptured aneurysm",
        value: "Congenital precerebral nonruptured aneurysm",
      },
      {
        label: "Congenital cerebral nonruptured aneurysm",
        value: "Congenital cerebral nonruptured aneurysm",
      },
      {
        label: "Other specified peripheral arterial malformations",
        value: "Other specified peripheral arterial malformations",
      },
      {
        label: "Peripheral arterial malformations, unspecified",
        value: "Peripheral arterial malformations, unspecified",
      },
      {
        label: "Pulmonary arteriovenous fistula",
        value: "Pulmonary arteriovenous fistula",
      },
      {
        label:
          "Other specified structural developmental anomalies of the peripheral vascular system",
        value:
          "Other specified structural developmental anomalies of the peripheral vascular system",
      },
      {
        label:
          "Structural developmental anomalies of the peripheral vascular system, unspecified",
        value:
          "Structural developmental anomalies of the peripheral vascular system, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the circulatory system",
        value:
          "Other specified structural developmental anomalies of the circulatory system",
      },
      {
        label:
          "Structural developmental anomalies of the circulatory system, unspecified",
        value:
          "Structural developmental anomalies of the circulatory system, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord",
        value:
          "Structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord",
      },
      {
        label: "Structural developmental anomalies of diaphragm",
        value: "Structural developmental anomalies of diaphragm",
      },
      {
        label: "Congenital diaphragmatic hernia",
        value: "Congenital diaphragmatic hernia",
      },
      { label: "Absence of diaphragm", value: "Absence of diaphragm" },
      {
        label:
          "Other specified structural developmental anomalies of diaphragm",
        value:
          "Other specified structural developmental anomalies of diaphragm",
      },
      {
        label: "Structural developmental anomalies of diaphragm, unspecified",
        value: "Structural developmental anomalies of diaphragm, unspecified",
      },
      { label: "Omphalocele", value: "Omphalocele" },
      { label: "Gastroschisis", value: "Gastroschisis" },
      {
        label: "Structural developmental anomalies of umbilical cord",
        value: "Structural developmental anomalies of umbilical cord",
      },
      {
        label: "Allantoic duct remnants or cysts",
        value: "Allantoic duct remnants or cysts",
      },
      {
        label: "Single umbilical cord artery",
        value: "Single umbilical cord artery",
      },
      {
        label:
          "Other specified structural developmental anomalies of umbilical cord",
        value:
          "Other specified structural developmental anomalies of umbilical cord",
      },
      {
        label:
          "Structural developmental anomalies of umbilical cord, unspecified",
        value:
          "Structural developmental anomalies of umbilical cord, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord",
        value:
          "Other specified structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord",
      },
      {
        label:
          "Structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord, unspecified",
        value:
          "Structural developmental anomalies of the diaphragm, abdominal wall or umbilical cord, unspecified",
      },
      {
        label: "Structural developmental anomalies of the digestive tract",
        value: "Structural developmental anomalies of the digestive tract",
      },
      {
        label: "Structural developmental anomalies of salivary glands or ducts",
        value: "Structural developmental anomalies of salivary glands or ducts",
      },
      {
        label: "Congenital diverticulum of pharynx",
        value: "Congenital diverticulum of pharynx",
      },
      {
        label: "Structural developmental anomalies of oesophagus",
        value: "Structural developmental anomalies of oesophagus",
      },
      {
        label: "Congenital oesophageal web or ring",
        value: "Congenital oesophageal web or ring",
      },
      { label: "Atresia of oesophagus", value: "Atresia of oesophagus" },
      {
        label: "Atresia of oesophagus with oesophagobronchial fistula",
        value: "Atresia of oesophagus with oesophagobronchial fistula",
      },
      {
        label: "Other specified atresia of oesophagus",
        value: "Other specified atresia of oesophagus",
      },
      {
        label: "Oesophageal fistula without atresia",
        value: "Oesophageal fistula without atresia",
      },
      {
        label: "Congenital stenosis or stricture of oesophagus",
        value: "Congenital stenosis or stricture of oesophagus",
      },
      {
        label: "Congenital diverticulum of oesophagus",
        value: "Congenital diverticulum of oesophagus",
      },
      {
        label: "Congenital dilatation of oesophagus",
        value: "Congenital dilatation of oesophagus",
      },
      {
        label:
          "Other specified structural developmental anomalies of oesophagus",
        value:
          "Other specified structural developmental anomalies of oesophagus",
      },
      {
        label: "Structural developmental anomalies of oesophagus, unspecified",
        value: "Structural developmental anomalies of oesophagus, unspecified",
      },
      {
        label: "Structural developmental anomalies of stomach",
        value: "Structural developmental anomalies of stomach",
      },
      {
        label: "Congenital hypertrophic pyloric stenosis",
        value: "Congenital hypertrophic pyloric stenosis",
      },
      { label: "Congenital hiatus hernia", value: "Congenital hiatus hernia" },
      { label: "Congenital antral web", value: "Congenital antral web" },
      {
        label: "Other specified structural developmental anomalies of stomach",
        value: "Other specified structural developmental anomalies of stomach",
      },
      {
        label: "Structural developmental anomalies of stomach, unspecified",
        value: "Structural developmental anomalies of stomach, unspecified",
      },
      {
        label: "Structural developmental anomalies of duodenum",
        value: "Structural developmental anomalies of duodenum",
      },
      {
        label: "Structural developmental anomalies of small intestine",
        value: "Structural developmental anomalies of small intestine",
      },
      { label: "Meckel diverticulum", value: "Meckel diverticulum" },
      {
        label: "Atresia of small intestine",
        value: "Atresia of small intestine",
      },
      { label: "Congenital short bowel", value: "Congenital short bowel" },
      {
        label: "Congenital diverticulitis of small intestine",
        value: "Congenital diverticulitis of small intestine",
      },
      {
        label: "Congenital diverticulosis of small intestine",
        value: "Congenital diverticulosis of small intestine",
      },
      {
        label: "Congenital diverticulum of small intestine",
        value: "Congenital diverticulum of small intestine",
      },
      {
        label:
          "Other specified structural developmental anomalies of small intestine",
        value:
          "Other specified structural developmental anomalies of small intestine",
      },
      {
        label:
          "Structural developmental anomalies of small intestine, unspecified",
        value:
          "Structural developmental anomalies of small intestine, unspecified",
      },
      {
        label: "Structural developmental anomalies of large intestine",
        value: "Structural developmental anomalies of large intestine",
      },
      {
        label: "Congenital absence, atresia or stenosis of large intestine",
        value: "Congenital absence, atresia or stenosis of large intestine",
      },
      { label: "Hirschsprung disease", value: "Hirschsprung disease" },
      {
        label: "Immature ganglionosis of large intestine",
        value: "Immature ganglionosis of large intestine",
      },
      {
        label: "Congenital hypoganglionosis of large intestine",
        value: "Congenital hypoganglionosis of large intestine",
      },
      {
        label:
          "Other specified structural developmental anomalies of large intestine",
        value:
          "Other specified structural developmental anomalies of large intestine",
      },
      {
        label:
          "Structural developmental anomalies of large intestine, unspecified",
        value:
          "Structural developmental anomalies of large intestine, unspecified",
      },
      {
        label: "Structural developmental anomalies of anal canal",
        value: "Structural developmental anomalies of anal canal",
      },
      { label: "Anorectal malformations", value: "Anorectal malformations" },
      { label: "Ectopic anus", value: "Ectopic anus" },
      { label: "Persistent cloaca", value: "Persistent cloaca" },
      { label: "Cloacal exstrophy", value: "Cloacal exstrophy" },
      { label: "Perineal groove", value: "Perineal groove" },
      {
        label:
          "Other specified structural developmental anomalies of anal canal",
        value:
          "Other specified structural developmental anomalies of anal canal",
      },
      {
        label: "Structural developmental anomalies of anal canal, unspecified",
        value: "Structural developmental anomalies of anal canal, unspecified",
      },
      {
        label: "Congenital anomalies of intestinal fixation",
        value: "Congenital anomalies of intestinal fixation",
      },
      {
        label:
          "Other specified structural developmental anomalies of the digestive tract",
        value:
          "Other specified structural developmental anomalies of the digestive tract",
      },
      {
        label:
          "Structural developmental anomalies of the digestive tract, unspecified",
        value:
          "Structural developmental anomalies of the digestive tract, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the liver, biliary tract, pancreas or spleen",
        value:
          "Structural developmental anomalies of the liver, biliary tract, pancreas or spleen",
      },
      {
        label:
          "Structural developmental anomalies of gallbladder, bile ducts or liver",
        value:
          "Structural developmental anomalies of gallbladder, bile ducts or liver",
      },
      {
        label: "Structural developmental anomalies of liver",
        value: "Structural developmental anomalies of liver",
      },
      {
        label: "Fibropolycystic liver disease",
        value: "Fibropolycystic liver disease",
      },
      {
        label: "Other specified structural developmental anomalies of liver",
        value: "Other specified structural developmental anomalies of liver",
      },
      {
        label: "Structural developmental anomalies of liver, unspecified",
        value: "Structural developmental anomalies of liver, unspecified",
      },
      {
        label: "Structural developmental anomalies of gallbladder",
        value: "Structural developmental anomalies of gallbladder",
      },
      {
        label: "Agenesis, aplasia or hypoplasia of gallbladder",
        value: "Agenesis, aplasia or hypoplasia of gallbladder",
      },
      {
        label:
          "Other specified structural developmental anomalies of gallbladder",
        value:
          "Other specified structural developmental anomalies of gallbladder",
      },
      {
        label: "Structural developmental anomalies of gallbladder, unspecified",
        value: "Structural developmental anomalies of gallbladder, unspecified",
      },
      {
        label: "Structural developmental anomalies of bile ducts",
        value: "Structural developmental anomalies of bile ducts",
      },
      { label: "Choledochal cyst", value: "Choledochal cyst" },
      { label: "Biliary atresia", value: "Biliary atresia" },
      {
        label: "Congenital stenosis or stricture of bile ducts",
        value: "Congenital stenosis or stricture of bile ducts",
      },
      {
        label: "Structural developmental anomalies of cystic duct",
        value: "Structural developmental anomalies of cystic duct",
      },
      { label: "Accessory bile duct", value: "Accessory bile duct" },
      {
        label:
          "Other specified structural developmental anomalies of bile ducts",
        value:
          "Other specified structural developmental anomalies of bile ducts",
      },
      {
        label: "Structural developmental anomalies of bile ducts, unspecified",
        value: "Structural developmental anomalies of bile ducts, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of gallbladder, bile ducts or liver",
        value:
          "Other specified structural developmental anomalies of gallbladder, bile ducts or liver",
      },
      {
        label:
          "Structural developmental anomalies of gallbladder, bile ducts or liver, unspecified",
        value:
          "Structural developmental anomalies of gallbladder, bile ducts or liver, unspecified",
      },
      {
        label: "Structural developmental anomalies of pancreas",
        value: "Structural developmental anomalies of pancreas",
      },
      { label: "Annular pancreas", value: "Annular pancreas" },
      { label: "Pancreas divisum", value: "Pancreas divisum" },
      { label: "Accessory pancreas", value: "Accessory pancreas" },
      {
        label: "Agenesis-aplasia of pancreas",
        value: "Agenesis-aplasia of pancreas",
      },
      {
        label: "Partial agenesis of pancreas",
        value: "Partial agenesis of pancreas",
      },
      { label: "Hypoplasia of pancreas", value: "Hypoplasia of pancreas" },
      {
        label: "Other specified structural developmental anomalies of pancreas",
        value: "Other specified structural developmental anomalies of pancreas",
      },
      {
        label: "Structural developmental anomalies of pancreas, unspecified",
        value: "Structural developmental anomalies of pancreas, unspecified",
      },
      {
        label: "Structural developmental anomalies of spleen",
        value: "Structural developmental anomalies of spleen",
      },
      { label: "Congenital asplenia", value: "Congenital asplenia" },
      { label: "Polysplenia", value: "Polysplenia" },
      { label: "Ectopic spleen", value: "Ectopic spleen" },
      {
        label: "Other specified structural developmental anomalies of spleen",
        value: "Other specified structural developmental anomalies of spleen",
      },
      {
        label: "Structural developmental anomalies of spleen, unspecified",
        value: "Structural developmental anomalies of spleen, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the liver, biliary tract, pancreas or spleen",
        value:
          "Other specified structural developmental anomalies of the liver, biliary tract, pancreas or spleen",
      },
      {
        label:
          "Structural developmental anomalies of the liver, biliary tract, pancreas or spleen, unspecified",
        value:
          "Structural developmental anomalies of the liver, biliary tract, pancreas or spleen, unspecified",
      },
      {
        label: "Structural developmental anomalies of the urinary system",
        value: "Structural developmental anomalies of the urinary system",
      },
      {
        label: "Structural developmental anomalies of kidneys",
        value: "Structural developmental anomalies of kidneys",
      },
      {
        label: "Renal agenesis or other reduction defects of kidney",
        value: "Renal agenesis or other reduction defects of kidney",
      },
      { label: "Renal agenesis", value: "Renal agenesis" },
      {
        label:
          "Other specified renal agenesis or other reduction defects of kidney",
        value:
          "Other specified renal agenesis or other reduction defects of kidney",
      },
      {
        label:
          "Renal agenesis or other reduction defects of kidney, unspecified",
        value:
          "Renal agenesis or other reduction defects of kidney, unspecified",
      },
      { label: "Renal dysplasia", value: "Renal dysplasia" },
      {
        label: "Congenital single renal cyst",
        value: "Congenital single renal cyst",
      },
      { label: "Renal tubular dysgenesis", value: "Renal tubular dysgenesis" },
      { label: "Oligomeganephronia", value: "Oligomeganephronia" },
      { label: "Accessory kidney", value: "Accessory kidney" },
      {
        label: "Fusion anomaly of kidneys",
        value: "Fusion anomaly of kidneys",
      },
      { label: "Lobulated kidney", value: "Lobulated kidney" },
      { label: "Fused pelvic kidney", value: "Fused pelvic kidney" },
      { label: "Horseshoe kidney", value: "Horseshoe kidney" },
      {
        label: "Other specified fusion anomaly of kidneys",
        value: "Other specified fusion anomaly of kidneys",
      },
      {
        label: "Fusion anomaly of kidneys, unspecified",
        value: "Fusion anomaly of kidneys, unspecified",
      },
      { label: "Ectopic or pelvic kidney", value: "Ectopic or pelvic kidney" },
      { label: "Medullary sponge kidney", value: "Medullary sponge kidney" },
      {
        label: "Multicystic renal dysplasia",
        value: "Multicystic renal dysplasia",
      },
      {
        label: "Other specified structural developmental anomalies of kidneys",
        value: "Other specified structural developmental anomalies of kidneys",
      },
      {
        label: "Structural developmental anomalies of kidneys, unspecified",
        value: "Structural developmental anomalies of kidneys, unspecified",
      },
      {
        label: "Structural developmental anomalies of urinary tract",
        value: "Structural developmental anomalies of urinary tract",
      },
      {
        label: "Congenital hydronephrosis",
        value: "Congenital hydronephrosis",
      },
      {
        label: "Congenital primary megaureter",
        value: "Congenital primary megaureter",
      },
      {
        label: "Fetal lower urinary tract obstruction",
        value: "Fetal lower urinary tract obstruction",
      },
      {
        label: "Exstrophy of urinary bladder",
        value: "Exstrophy of urinary bladder",
      },
      {
        label: "Congenital diverticulum of urinary bladder",
        value: "Congenital diverticulum of urinary bladder",
      },
      { label: "Duplication of urethra", value: "Duplication of urethra" },
      { label: "Congenital megalourethra", value: "Congenital megalourethra" },
      { label: "Megacystis-megaureter", value: "Megacystis-megaureter" },
      {
        label: "Atresia or stenosis of ureter",
        value: "Atresia or stenosis of ureter",
      },
      { label: "Agenesis of ureter", value: "Agenesis of ureter" },
      { label: "Duplication of ureter", value: "Duplication of ureter" },
      { label: "Malposition of ureter", value: "Malposition of ureter" },
      {
        label: "Congenital absence of bladder or urethra",
        value: "Congenital absence of bladder or urethra",
      },
      {
        label: "Congenital vesico-uretero-renal reflux",
        value: "Congenital vesico-uretero-renal reflux",
      },
      {
        label:
          "Other specified structural developmental anomalies of urinary tract",
        value:
          "Other specified structural developmental anomalies of urinary tract",
      },
      {
        label:
          "Structural developmental anomalies of urinary tract, unspecified",
        value:
          "Structural developmental anomalies of urinary tract, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the urinary system",
        value:
          "Other specified structural developmental anomalies of the urinary system",
      },
      {
        label:
          "Structural developmental anomalies of the urinary system, unspecified",
        value:
          "Structural developmental anomalies of the urinary system, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of the female genital system",
        value:
          "Structural developmental anomalies of the female genital system",
      },
      {
        label: "Structural developmental anomalies of vulva",
        value: "Structural developmental anomalies of vulva",
      },
      { label: "Absence of vulva", value: "Absence of vulva" },
      { label: "Embryonic cyst of vulva", value: "Embryonic cyst of vulva" },
      { label: "Fusion of labia", value: "Fusion of labia" },
      {
        label: "Other specified structural developmental anomalies of vulva",
        value: "Other specified structural developmental anomalies of vulva",
      },
      {
        label: "Structural developmental anomalies of vulva, unspecified",
        value: "Structural developmental anomalies of vulva, unspecified",
      },
      {
        label: "Structural developmental anomalies of clitoris",
        value: "Structural developmental anomalies of clitoris",
      },
      { label: "Agenesis of clitoris", value: "Agenesis of clitoris" },
      { label: "Duplication of clitoris", value: "Duplication of clitoris" },
      { label: "Clitoromegaly", value: "Clitoromegaly" },
      {
        label: "Other specified structural developmental anomalies of clitoris",
        value: "Other specified structural developmental anomalies of clitoris",
      },
      {
        label: "Structural developmental anomalies of clitoris, unspecified",
        value: "Structural developmental anomalies of clitoris, unspecified",
      },
      {
        label: "Structural developmental anomalies of vagina",
        value: "Structural developmental anomalies of vagina",
      },
      { label: "Absence of vagina", value: "Absence of vagina" },
      { label: "Septate vagina", value: "Septate vagina" },
      {
        label: "Congenital rectovaginal fistula",
        value: "Congenital rectovaginal fistula",
      },
      { label: "Tight hymenal ring", value: "Tight hymenal ring" },
      { label: "Imperforate hymen", value: "Imperforate hymen" },
      {
        label: "Stricture or atresia of vagina",
        value: "Stricture or atresia of vagina",
      },
      {
        label: "Other specified structural developmental anomalies of vagina",
        value: "Other specified structural developmental anomalies of vagina",
      },
      {
        label: "Structural developmental anomalies of vagina, unspecified",
        value: "Structural developmental anomalies of vagina, unspecified",
      },
      {
        label: "Structural developmental anomalies of cervix uteri",
        value: "Structural developmental anomalies of cervix uteri",
      },
      { label: "Embryonic cyst of cervix", value: "Embryonic cyst of cervix" },
      {
        label: "Agenesis or aplasia of cervix",
        value: "Agenesis or aplasia of cervix",
      },
      {
        label:
          "Other specified structural developmental anomalies of cervix uteri",
        value:
          "Other specified structural developmental anomalies of cervix uteri",
      },
      {
        label:
          "Structural developmental anomalies of cervix uteri, unspecified",
        value:
          "Structural developmental anomalies of cervix uteri, unspecified",
      },
      {
        label: "Structural developmental anomalies of uterus, except cervix",
        value: "Structural developmental anomalies of uterus, except cervix",
      },
      {
        label: "Agenesis or aplasia of uterine body",
        value: "Agenesis or aplasia of uterine body",
      },
      { label: "Hypoplasia of uterus", value: "Hypoplasia of uterus" },
      { label: "Unicornuate uterus", value: "Unicornuate uterus" },
      { label: "Bicornuate uterus", value: "Bicornuate uterus" },
      { label: "Septate uterus", value: "Septate uterus" },
      {
        label:
          "Congenital fistulae between uterus and digestive and urinary tracts",
        value:
          "Congenital fistulae between uterus and digestive and urinary tracts",
      },
      {
        label: "Uterovaginal malformation due to diethylstilbestrol syndrome",
        value: "Uterovaginal malformation due to diethylstilbestrol syndrome",
      },
      {
        label:
          "Other specified structural developmental anomalies of uterus, except cervix",
        value:
          "Other specified structural developmental anomalies of uterus, except cervix",
      },
      {
        label:
          "Structural developmental anomalies of uterus, except cervix, unspecified",
        value:
          "Structural developmental anomalies of uterus, except cervix, unspecified",
      },
      {
        label:
          "Structural developmental anomalies of ovaries, fallopian tubes or broad ligaments",
        value:
          "Structural developmental anomalies of ovaries, fallopian tubes or broad ligaments",
      },
      {
        label: "Congenital absence of ovary",
        value: "Congenital absence of ovary",
      },
      { label: "46,XX gonadal dysgenesis", value: "46,XX gonadal dysgenesis" },
      {
        label: "Developmental ovarian cyst",
        value: "Developmental ovarian cyst",
      },
      {
        label: "Congenital torsion of ovary",
        value: "Congenital torsion of ovary",
      },
      { label: "Accessory ovary", value: "Accessory ovary" },
      {
        label: "Congenital absence of fallopian tube",
        value: "Congenital absence of fallopian tube",
      },
      {
        label: "Atresia of fallopian tube",
        value: "Atresia of fallopian tube",
      },
      { label: "Accessory fallopian tube", value: "Accessory fallopian tube" },
      {
        label: "Embryonic cyst of fallopian tube",
        value: "Embryonic cyst of fallopian tube",
      },
      {
        label: "Embryonic cyst of broad ligament",
        value: "Embryonic cyst of broad ligament",
      },
      {
        label:
          "Other specified structural developmental anomalies of ovaries, fallopian tubes or broad ligaments",
        value:
          "Other specified structural developmental anomalies of ovaries, fallopian tubes or broad ligaments",
      },
      {
        label:
          "Structural developmental anomalies of ovaries, fallopian tubes or broad ligaments, unspecified",
        value:
          "Structural developmental anomalies of ovaries, fallopian tubes or broad ligaments, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of the female genital system",
        value:
          "Other specified structural developmental anomalies of the female genital system",
      },
      {
        label:
          "Structural developmental anomalies of the female genital system, unspecified",
        value:
          "Structural developmental anomalies of the female genital system, unspecified",
      },
      {
        label: "Structural developmental anomalies of the male genital system",
        value: "Structural developmental anomalies of the male genital system",
      },
      {
        label: "Micropenis or penis agenesis",
        value: "Micropenis or penis agenesis",
      },
      {
        label: "Anorchia or microorchidia",
        value: "Anorchia or microorchidia",
      },
      { label: "Cryptorchidism", value: "Cryptorchidism" },
      { label: "Ectopic testis", value: "Ectopic testis" },
      {
        label: "Undescended testicle, unilateral",
        value: "Undescended testicle, unilateral",
      },
      {
        label: "Undescended testicle, bilateral",
        value: "Undescended testicle, bilateral",
      },
      {
        label: "Other specified cryptorchidism",
        value: "Other specified cryptorchidism",
      },
      {
        label: "Cryptorchidism, unspecified",
        value: "Cryptorchidism, unspecified",
      },
      { label: "Hypospadias", value: "Hypospadias" },
      { label: "Hypospadias, balanic", value: "Hypospadias, balanic" },
      { label: "Hypospadias, coronal", value: "Hypospadias, coronal" },
      { label: "Hypospadias, glandular", value: "Hypospadias, glandular" },
      {
        label: "Other specified hypospadias, balanic",
        value: "Other specified hypospadias, balanic",
      },
      {
        label: "Hypospadias, balanic, unspecified",
        value: "Hypospadias, balanic, unspecified",
      },
      { label: "Hypospadias, penile", value: "Hypospadias, penile" },
      { label: "Hypospadias, penoscrotal", value: "Hypospadias, penoscrotal" },
      { label: "Hypospadias, scrotal", value: "Hypospadias, scrotal" },
      { label: "Hypospadias, perineal", value: "Hypospadias, perineal" },
      {
        label: "Other specified hypospadias",
        value: "Other specified hypospadias",
      },
      { label: "Hypospadias, unspecified", value: "Hypospadias, unspecified" },
      { label: "Congenital chordee", value: "Congenital chordee" },
      { label: "Epispadias", value: "Epispadias" },
      { label: "Bifid scrotum", value: "Bifid scrotum" },
      { label: "Agenesis of vas deferens", value: "Agenesis of vas deferens" },
      { label: "Polyorchidism", value: "Polyorchidism" },
      {
        label: "Hypoplasia of testis or scrotum",
        value: "Hypoplasia of testis or scrotum",
      },
      {
        label:
          "Other specified structural developmental anomalies of the male genital system",
        value:
          "Other specified structural developmental anomalies of the male genital system",
      },
      {
        label:
          "Structural developmental anomalies of the male genital system, unspecified",
        value:
          "Structural developmental anomalies of the male genital system, unspecified",
      },
      {
        label: "Structural developmental anomalies of the breast",
        value: "Structural developmental anomalies of the breast",
      },
      { label: "Breast aplasia", value: "Breast aplasia" },
      { label: "Absent nipple", value: "Absent nipple" },
      { label: "Supernumerary breasts", value: "Supernumerary breasts" },
      { label: "Accessory nipple", value: "Accessory nipple" },
      {
        label:
          "Other specified structural developmental anomalies of the breast",
        value:
          "Other specified structural developmental anomalies of the breast",
      },
      {
        label: "Structural developmental anomalies of the breast, unspecified",
        value: "Structural developmental anomalies of the breast, unspecified",
      },
      {
        label: "Structural developmental anomalies of the skeleton",
        value: "Structural developmental anomalies of the skeleton",
      },
      {
        label: "Structural developmental anomalies of cranium",
        value: "Structural developmental anomalies of cranium",
      },
      { label: "Craniosynostosis", value: "Craniosynostosis" },
      { label: "Plagiocephaly", value: "Plagiocephaly" },
      {
        label: "Other specified craniosynostosis",
        value: "Other specified craniosynostosis",
      },
      {
        label: "Craniosynostosis, unspecified",
        value: "Craniosynostosis, unspecified",
      },
      { label: "Wormian bones", value: "Wormian bones" },
      { label: "J-shaped sella turcica", value: "J-shaped sella turcica" },
      { label: "Macrocephaly", value: "Macrocephaly" },
      {
        label: "Other specified structural developmental anomalies of cranium",
        value: "Other specified structural developmental anomalies of cranium",
      },
      {
        label: "Structural developmental anomalies of cranium, unspecified",
        value: "Structural developmental anomalies of cranium, unspecified",
      },
      {
        label: "Structural developmental anomalies of facial bones",
        value: "Structural developmental anomalies of facial bones",
      },
      { label: "Hypotelorism", value: "Hypotelorism" },
      { label: "Hypertelorism", value: "Hypertelorism" },
      {
        label:
          "Other specified structural developmental anomalies of facial bones",
        value:
          "Other specified structural developmental anomalies of facial bones",
      },
      {
        label:
          "Structural developmental anomalies of facial bones, unspecified",
        value:
          "Structural developmental anomalies of facial bones, unspecified",
      },
      {
        label: "Structural developmental anomalies of shoulder girdle",
        value: "Structural developmental anomalies of shoulder girdle",
      },
      { label: "Cervical rib", value: "Cervical rib" },
      { label: "Sprengel deformity", value: "Sprengel deformity" },
      { label: "Deformation of scapula", value: "Deformation of scapula" },
      {
        label:
          "Other specified structural developmental anomalies of shoulder girdle",
        value:
          "Other specified structural developmental anomalies of shoulder girdle",
      },
      {
        label:
          "Structural developmental anomalies of shoulder girdle, unspecified",
        value:
          "Structural developmental anomalies of shoulder girdle, unspecified",
      },
      {
        label: "Structural developmental anomalies of spine or bony thorax",
        value: "Structural developmental anomalies of spine or bony thorax",
      },
      { label: "Occult spinal dysraphism", value: "Occult spinal dysraphism" },
      {
        label: "Structural developmental anomalies of chest wall",
        value: "Structural developmental anomalies of chest wall",
      },
      { label: "Poland syndrome", value: "Poland syndrome" },
      { label: "Bifid rib", value: "Bifid rib" },
      { label: "Accessory rib", value: "Accessory rib" },
      {
        label: "Structural developmental anomalies of sternum",
        value: "Structural developmental anomalies of sternum",
      },
      {
        label:
          "Other specified structural developmental anomalies of chest wall",
        value:
          "Other specified structural developmental anomalies of chest wall",
      },
      {
        label: "Structural developmental anomalies of chest wall, unspecified",
        value: "Structural developmental anomalies of chest wall, unspecified",
      },
      {
        label: "Structural developmental anomalies of spine",
        value: "Structural developmental anomalies of spine",
      },
      { label: "Klippel-Feil anomaly", value: "Klippel-Feil anomaly" },
      {
        label: "Occipitalisation of atlas",
        value: "Occipitalisation of atlas",
      },
      {
        label: "Atlanto-axial instability or subluxation",
        value: "Atlanto-axial instability or subluxation",
      },
      {
        label: "Aplasia or hypoplasia of the odontoid process of axis",
        value: "Aplasia or hypoplasia of the odontoid process of axis",
      },
      {
        label: "Segmentation anomalies of vertebrae",
        value: "Segmentation anomalies of vertebrae",
      },
      {
        label: "Congenital scoliosis due to congenital bony malformation",
        value: "Congenital scoliosis due to congenital bony malformation",
      },
      {
        label: "Sacralization of the last lumbar vertebra",
        value: "Sacralization of the last lumbar vertebra",
      },
      {
        label: "Lumbarisation of the first sacral vertebra",
        value: "Lumbarisation of the first sacral vertebra",
      },
      {
        label: "Sacrum agenesis or hypoplasia",
        value: "Sacrum agenesis or hypoplasia",
      },
      { label: "Caudal appendage", value: "Caudal appendage" },
      {
        label: "Congenital spondylolisthesis",
        value: "Congenital spondylolisthesis",
      },
      {
        label: "Other specified structural developmental anomalies of spine",
        value: "Other specified structural developmental anomalies of spine",
      },
      {
        label: "Structural developmental anomalies of spine, unspecified",
        value: "Structural developmental anomalies of spine, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies of spine or bony thorax",
        value:
          "Other specified structural developmental anomalies of spine or bony thorax",
      },
      {
        label:
          "Structural developmental anomalies of spine or bony thorax, unspecified",
        value:
          "Structural developmental anomalies of spine or bony thorax, unspecified",
      },
      {
        label: "Structural developmental anomalies of pelvic girdle",
        value: "Structural developmental anomalies of pelvic girdle",
      },
      {
        label: "Developmental dysplasia of hip",
        value: "Developmental dysplasia of hip",
      },
      {
        label: "Congenital subluxation of hip",
        value: "Congenital subluxation of hip",
      },
      { label: "Unstable hip", value: "Unstable hip" },
      { label: "Congenital coxa vara", value: "Congenital coxa vara" },
      { label: "Congenital coxa valga", value: "Congenital coxa valga" },
      { label: "Wide symphysis pubis", value: "Wide symphysis pubis" },
      {
        label:
          "Other specified structural developmental anomalies of pelvic girdle",
        value:
          "Other specified structural developmental anomalies of pelvic girdle",
      },
      {
        label:
          "Structural developmental anomalies of pelvic girdle, unspecified",
        value:
          "Structural developmental anomalies of pelvic girdle, unspecified",
      },
      { label: "Brachydactyly", value: "Brachydactyly" },
      { label: "Brachydactyly of fingers", value: "Brachydactyly of fingers" },
      { label: "Brachydactyly of toes", value: "Brachydactyly of toes" },
      {
        label: "Symbrachydactyly of hands or feet",
        value: "Symbrachydactyly of hands or feet",
      },
      {
        label: "Other specified brachydactyly",
        value: "Other specified brachydactyly",
      },
      {
        label: "Brachydactyly, unspecified",
        value: "Brachydactyly, unspecified",
      },
      { label: "Triphalangeal thumb", value: "Triphalangeal thumb" },
      { label: "Hyperphalangy", value: "Hyperphalangy" },
      { label: "Polydactyly", value: "Polydactyly" },
      { label: "Polydactyly of the thumb", value: "Polydactyly of the thumb" },
      { label: "Polysyndactyly", value: "Polysyndactyly" },
      {
        label: "Postaxial polydactyly of fingers",
        value: "Postaxial polydactyly of fingers",
      },
      { label: "Polydactyly of toes", value: "Polydactyly of toes" },
      {
        label: "Other specified polydactyly",
        value: "Other specified polydactyly",
      },
      { label: "Polydactyly, unspecified", value: "Polydactyly, unspecified" },
      { label: "Syndactyly", value: "Syndactyly" },
      { label: "Fused fingers", value: "Fused fingers" },
      { label: "Webbed fingers", value: "Webbed fingers" },
      { label: "Fused toes", value: "Fused toes" },
      { label: "Webbed toes", value: "Webbed toes" },
      {
        label: "Other specified syndactyly",
        value: "Other specified syndactyly",
      },
      { label: "Syndactyly, unspecified", value: "Syndactyly, unspecified" },
      {
        label: "Congenital deformities of fingers or toes",
        value: "Congenital deformities of fingers or toes",
      },
      {
        label: "Congenital deformities of fingers",
        value: "Congenital deformities of fingers",
      },
      { label: "Clinodactyly of fingers", value: "Clinodactyly of fingers" },
      { label: "Congenital club finger", value: "Congenital club finger" },
      {
        label: "Radial deviation of fingers",
        value: "Radial deviation of fingers",
      },
      {
        label: "Other specified congenital deformities of fingers",
        value: "Other specified congenital deformities of fingers",
      },
      {
        label: "Congenital deformities of toes",
        value: "Congenital deformities of toes",
      },
      { label: "Clinodactyly of toes", value: "Clinodactyly of toes" },
      {
        label: "Other specified congenital deformities of toes",
        value: "Other specified congenital deformities of toes",
      },
      {
        label: "Congenital deformities of fingers or toes, unspecified",
        value: "Congenital deformities of fingers or toes, unspecified",
      },
      { label: "Joint formation defects", value: "Joint formation defects" },
      {
        label: "Humero-radio-ulnar synostosis",
        value: "Humero-radio-ulnar synostosis",
      },
      { label: "Humero-radial synostosis", value: "Humero-radial synostosis" },
      { label: "Humero-ulnar synostosis", value: "Humero-ulnar synostosis" },
      { label: "Radio-ulnar synostosis", value: "Radio-ulnar synostosis" },
      { label: "Madelung deformity", value: "Madelung deformity" },
      {
        label: "Congenital digital clubbing",
        value: "Congenital digital clubbing",
      },
      { label: "Tibio-fibular synostosis", value: "Tibio-fibular synostosis" },
      { label: "Cubitus valgus", value: "Cubitus valgus" },
      { label: "Cubitus varus", value: "Cubitus varus" },
      {
        label: "Other specified joint formation defects",
        value: "Other specified joint formation defects",
      },
      {
        label: "Joint formation defects, unspecified",
        value: "Joint formation defects, unspecified",
      },
      {
        label: "Congenital shoulder dislocation",
        value: "Congenital shoulder dislocation",
      },
      {
        label: "Congenital elbow dislocation",
        value: "Congenital elbow dislocation",
      },
      {
        label: "Congenital knee dislocation",
        value: "Congenital knee dislocation",
      },
      {
        label: "Congenital genu recurvatum",
        value: "Congenital genu recurvatum",
      },
      { label: "Congenital genu flexum", value: "Congenital genu flexum" },
      {
        label: "Other specified congenital knee dislocation",
        value: "Other specified congenital knee dislocation",
      },
      {
        label: "Congenital knee dislocation, unspecified",
        value: "Congenital knee dislocation, unspecified",
      },
      {
        label: "Congenital patella dislocation",
        value: "Congenital patella dislocation",
      },
      {
        label: "Patella aplasia or hypoplasia",
        value: "Patella aplasia or hypoplasia",
      },
      {
        label: "Congenital bowing of long bones",
        value: "Congenital bowing of long bones",
      },
      {
        label: "Congenital bowing of femur",
        value: "Congenital bowing of femur",
      },
      {
        label: "Congenital bowing of tibia",
        value: "Congenital bowing of tibia",
      },
      {
        label: "Other specified congenital bowing of long bones",
        value: "Other specified congenital bowing of long bones",
      },
      {
        label: "Congenital bowing of long bones, unspecified",
        value: "Congenital bowing of long bones, unspecified",
      },
      { label: "Limb overgrowth", value: "Limb overgrowth" },
      { label: "Macrodactyly of fingers", value: "Macrodactyly of fingers" },
      { label: "Macrodactyly of toes", value: "Macrodactyly of toes" },
      { label: "Upper limb hypertrophy", value: "Upper limb hypertrophy" },
      { label: "Lower limb hypertrophy", value: "Lower limb hypertrophy" },
      {
        label: "Other specified limb overgrowth",
        value: "Other specified limb overgrowth",
      },
      {
        label: "Limb overgrowth, unspecified",
        value: "Limb overgrowth, unspecified",
      },
      {
        label: "Congenital deformities of feet",
        value: "Congenital deformities of feet",
      },
      {
        label: "Congenital varus deformities of feet",
        value: "Congenital varus deformities of feet",
      },
      { label: "Talipes equinovarus", value: "Talipes equinovarus" },
      { label: "Talipes calcaneovarus", value: "Talipes calcaneovarus" },
      { label: "Metatarsus varus", value: "Metatarsus varus" },
      {
        label: "Other specified congenital varus deformities of feet",
        value: "Other specified congenital varus deformities of feet",
      },
      {
        label: "Congenital varus deformities of feet, unspecified",
        value: "Congenital varus deformities of feet, unspecified",
      },
      { label: "Congenital pes planus", value: "Congenital pes planus" },
      {
        label: "Congenital valgus deformities of feet",
        value: "Congenital valgus deformities of feet",
      },
      { label: "Congenital hallux valgus", value: "Congenital hallux valgus" },
      { label: "Metatarsus valgus", value: "Metatarsus valgus" },
      { label: "Talipes calcaneovalgus", value: "Talipes calcaneovalgus" },
      {
        label: "Other specified congenital valgus deformities of feet",
        value: "Other specified congenital valgus deformities of feet",
      },
      {
        label: "Congenital valgus deformities of feet, unspecified",
        value: "Congenital valgus deformities of feet, unspecified",
      },
      { label: "Congenital pes cavus", value: "Congenital pes cavus" },
      {
        label: "Congenital vertical talus",
        value: "Congenital vertical talus",
      },
      { label: "Congenital hammer toe", value: "Congenital hammer toe" },
      {
        label: "Other specified congenital deformities of feet",
        value: "Other specified congenital deformities of feet",
      },
      {
        label: "Congenital deformities of feet, unspecified",
        value: "Congenital deformities of feet, unspecified",
      },
      {
        label: "Reduction defects of upper limb",
        value: "Reduction defects of upper limb",
      },
      { label: "Amelia of upper limb", value: "Amelia of upper limb" },
      {
        label: "Humeral agenesis or hypoplasia",
        value: "Humeral agenesis or hypoplasia",
      },
      { label: "Radial hemimelia", value: "Radial hemimelia" },
      { label: "Ulnar hemimelia", value: "Ulnar hemimelia" },
      {
        label: "Congenital absence of upper arm or forearm with hand present",
        value: "Congenital absence of upper arm or forearm with hand present",
      },
      {
        label: "Congenital absence of both forearm and hand",
        value: "Congenital absence of both forearm and hand",
      },
      { label: "Acheiria", value: "Acheiria" },
      { label: "Adactyly of hands", value: "Adactyly of hands" },
      { label: "Split hand", value: "Split hand" },
      {
        label: "Other specified reduction defects of upper limb",
        value: "Other specified reduction defects of upper limb",
      },
      {
        label: "Reduction defects of upper limb, unspecified",
        value: "Reduction defects of upper limb, unspecified",
      },
      {
        label: "Reduction defects of lower limb",
        value: "Reduction defects of lower limb",
      },
      { label: "Amelia of lower limb", value: "Amelia of lower limb" },
      { label: "Tibial hemimelia", value: "Tibial hemimelia" },
      { label: "Fibular hemimelia", value: "Fibular hemimelia" },
      {
        label: "Congenital absence of thigh or lower leg with foot present",
        value: "Congenital absence of thigh or lower leg with foot present",
      },
      { label: "Apodia", value: "Apodia" },
      { label: "Adactyly of feet", value: "Adactyly of feet" },
      { label: "Split foot", value: "Split foot" },
      {
        label: "Congenital absence of both lower leg and foot",
        value: "Congenital absence of both lower leg and foot",
      },
      {
        label: "Femoral agenesis or hypoplasia",
        value: "Femoral agenesis or hypoplasia",
      },
      {
        label: "Other specified reduction defects of lower limb",
        value: "Other specified reduction defects of lower limb",
      },
      {
        label: "Reduction defects of lower limb, unspecified",
        value: "Reduction defects of lower limb, unspecified",
      },
      {
        label: "Reduction defects of upper and lower limbs",
        value: "Reduction defects of upper and lower limbs",
      },
      {
        label:
          "Other specified structural developmental anomalies of the skeleton",
        value:
          "Other specified structural developmental anomalies of the skeleton",
      },
      {
        label:
          "Structural developmental anomalies of the skeleton, unspecified",
        value:
          "Structural developmental anomalies of the skeleton, unspecified",
      },
      {
        label: "Structural developmental anomalies of the skin",
        value: "Structural developmental anomalies of the skin",
      },
      {
        label:
          "Developmental hamartomata of the epidermis and epidermal appendages",
        value:
          "Developmental hamartomata of the epidermis and epidermal appendages",
      },
      {
        label: "Keratinocytic epidermal hamartoma",
        value: "Keratinocytic epidermal hamartoma",
      },
      { label: "Epidermal naevus", value: "Epidermal naevus" },
      {
        label: "Other specified keratinocytic epidermal hamartoma",
        value: "Other specified keratinocytic epidermal hamartoma",
      },
      { label: "Pilosebaceous hamartoma", value: "Pilosebaceous hamartoma" },
      {
        label: "Complex epidermal hamartoma",
        value: "Complex epidermal hamartoma",
      },
      {
        label:
          "Other specified developmental hamartomata of the epidermis and epidermal appendages",
        value:
          "Other specified developmental hamartomata of the epidermis and epidermal appendages",
      },
      {
        label: "Developmental anomalies of skin pigmentation",
        value: "Developmental anomalies of skin pigmentation",
      },
      { label: "Dermal melanocytosis", value: "Dermal melanocytosis" },
      {
        label: "Other specified developmental anomalies of skin pigmentation",
        value: "Other specified developmental anomalies of skin pigmentation",
      },
      {
        label: "Hamartomata derived from dermal connective tissue",
        value: "Hamartomata derived from dermal connective tissue",
      },
      {
        label: "Connective tissue hamartoma",
        value: "Connective tissue hamartoma",
      },
      {
        label:
          "Other specified hamartomata derived from dermal connective tissue",
        value:
          "Other specified hamartomata derived from dermal connective tissue",
      },
      {
        label: "Developmental defects of hair or nails",
        value: "Developmental defects of hair or nails",
      },
      {
        label: "Developmental defects of hair or hair growth",
        value: "Developmental defects of hair or hair growth",
      },
      {
        label: "Developmental defects of the nail apparatus",
        value: "Developmental defects of the nail apparatus",
      },
      { label: "Dermoid cyst", value: "Dermoid cyst" },
      {
        label: "Developmental anomalies of cutaneous vasculature",
        value: "Developmental anomalies of cutaneous vasculature",
      },
      {
        label: "Developmental capillary vascular malformations of the skin",
        value: "Developmental capillary vascular malformations of the skin",
      },
      { label: "Salmon patch", value: "Salmon patch" },
      { label: "Port-wine stain", value: "Port-wine stain" },
      {
        label: "Other specified cutaneous capillary vascular malformation",
        value: "Other specified cutaneous capillary vascular malformation",
      },
      {
        label: "Developmental venous malformations involving the skin",
        value: "Developmental venous malformations involving the skin",
      },
      {
        label:
          "Complex or combined developmental vascular malformations involving the skin",
        value:
          "Complex or combined developmental vascular malformations involving the skin",
      },
      {
        label:
          "Other specified developmental anomalies of cutaneous vasculature",
        value:
          "Other specified developmental anomalies of cutaneous vasculature",
      },
      {
        label: "Developmental anomalies of cutaneous vasculature, unspecified",
        value: "Developmental anomalies of cutaneous vasculature, unspecified",
      },
      {
        label: "Congenital anomalies of skin development",
        value: "Congenital anomalies of skin development",
      },
      { label: "Aplasia cutis congenita", value: "Aplasia cutis congenita" },
      {
        label: "Other specified structural developmental anomalies of the skin",
        value: "Other specified structural developmental anomalies of the skin",
      },
      {
        label: "Structural developmental anomalies of the skin, unspecified",
        value: "Structural developmental anomalies of the skin, unspecified",
      },
      {
        label: "Structural developmental anomalies of the adrenal glands",
        value: "Structural developmental anomalies of the adrenal glands",
      },
      {
        label: "Congenital adrenal hypoplasia",
        value: "Congenital adrenal hypoplasia",
      },
      {
        label:
          "Other specified structural developmental anomalies of the adrenal glands",
        value:
          "Other specified structural developmental anomalies of the adrenal glands",
      },
      {
        label:
          "Structural developmental anomalies of the adrenal glands, unspecified",
        value:
          "Structural developmental anomalies of the adrenal glands, unspecified",
      },
      {
        label:
          "Other specified structural developmental anomalies primarily affecting one body system",
        value:
          "Other specified structural developmental anomalies primarily affecting one body system",
      },
      {
        label:
          "Structural developmental anomalies primarily affecting one body system, unspecified",
        value:
          "Structural developmental anomalies primarily affecting one body system, unspecified",
      },
      {
        label: "Multiple developmental anomalies or syndromes",
        value: "Multiple developmental anomalies or syndromes",
      },
      {
        label:
          "Syndromes with central nervous system anomalies as a major feature",
        value:
          "Syndromes with central nervous system anomalies as a major feature",
      },
      {
        label: "Syndromes with cerebellar anomalies as a major feature",
        value: "Syndromes with cerebellar anomalies as a major feature",
      },
      { label: "Joubert syndrome", value: "Joubert syndrome" },
      {
        label: "Pontocerebellar hypoplasia",
        value: "Pontocerebellar hypoplasia",
      },
      {
        label:
          "Other specified syndromes with cerebellar anomalies as a major feature",
        value:
          "Other specified syndromes with cerebellar anomalies as a major feature",
      },
      {
        label:
          "Syndromes with cerebellar anomalies as a major feature, unspecified",
        value:
          "Syndromes with cerebellar anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with lissencephaly as a major feature",
        value: "Syndromes with lissencephaly as a major feature",
      },
      {
        label: "Syndromes with microcephaly as a major feature",
        value: "Syndromes with microcephaly as a major feature",
      },
      {
        label: "Syndromes with holoprosencephaly as a major feature",
        value: "Syndromes with holoprosencephaly as a major feature",
      },
      {
        label: "Syndromes with brain calcifications as a major feature",
        value: "Syndromes with brain calcifications as a major feature",
      },
      {
        label:
          "Other specified syndromes with central nervous system anomalies as a major feature",
        value:
          "Other specified syndromes with central nervous system anomalies as a major feature",
      },
      {
        label:
          "Syndromes with central nervous system anomalies as a major feature, unspecified",
        value:
          "Syndromes with central nervous system anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with eye anomalies as a major feature",
        value: "Syndromes with eye anomalies as a major feature",
      },
      {
        label: "Syndromes with microphthalmia as a major feature",
        value: "Syndromes with microphthalmia as a major feature",
      },
      {
        label:
          "Other specified syndromes with eye anomalies as a major feature",
        value:
          "Other specified syndromes with eye anomalies as a major feature",
      },
      {
        label: "Syndromes with eye anomalies as a major feature, unspecified",
        value: "Syndromes with eye anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with dental anomalies as a major feature",
        value: "Syndromes with dental anomalies as a major feature",
      },
      {
        label: "Syndromes with vascular anomalies as a major feature",
        value: "Syndromes with vascular anomalies as a major feature",
      },
      {
        label: "Syndromes with skeletal anomalies as a major feature",
        value: "Syndromes with skeletal anomalies as a major feature",
      },
      {
        label: "Syndromes with micromelia",
        value: "Syndromes with micromelia",
      },
      { label: "Achondroplasia", value: "Achondroplasia" },
      { label: "Hypochondroplasia", value: "Hypochondroplasia" },
      { label: "Thanatophoric dysplasia", value: "Thanatophoric dysplasia" },
      { label: "Diastrophic dysplasia", value: "Diastrophic dysplasia" },
      {
        label: "Chondrodysplasia punctata",
        value: "Chondrodysplasia punctata",
      },
      {
        label: "Other specified syndromes with micromelia",
        value: "Other specified syndromes with micromelia",
      },
      {
        label: "Syndromes with micromelia, unspecified",
        value: "Syndromes with micromelia, unspecified",
      },
      {
        label: "Bone diseases with increased bone density",
        value: "Bone diseases with increased bone density",
      },
      { label: "Osteopetrosis", value: "Osteopetrosis" },
      { label: "Osteopoikilosis", value: "Osteopoikilosis" },
      {
        label: "Other specified bone diseases with increased bone density",
        value: "Other specified bone diseases with increased bone density",
      },
      {
        label: "Bone diseases with increased bone density, unspecified",
        value: "Bone diseases with increased bone density, unspecified",
      },
      {
        label:
          "Bone diseases with disorganised development of skeletal components",
        value:
          "Bone diseases with disorganised development of skeletal components",
      },
      { label: "Multiple osteochondromas", value: "Multiple osteochondromas" },
      {
        label: "Exostoses with anetodermia and brachydactyly type E",
        value: "Exostoses with anetodermia and brachydactyly type E",
      },
      { label: "Cherubism", value: "Cherubism" },
      { label: "Yunis-Varon disease", value: "Yunis-Varon disease" },
      {
        label:
          "Other specified bone diseases with disorganised development of skeletal components",
        value:
          "Other specified bone diseases with disorganised development of skeletal components",
      },
      {
        label:
          "Bone diseases with disorganised development of skeletal components, unspecified",
        value:
          "Bone diseases with disorganised development of skeletal components, unspecified",
      },
      {
        label: "Spondyloepiphyseal or spondyloepimetaphyseal dysplasias",
        value: "Spondyloepiphyseal or spondyloepimetaphyseal dysplasias",
      },
      {
        label: "Spondylometaphyseal dysplasias",
        value: "Spondylometaphyseal dysplasias",
      },
      {
        label: "Spondylodysplastic dysplasias",
        value: "Spondylodysplastic dysplasias",
      },
      { label: "Achondrogenesis", value: "Achondrogenesis" },
      { label: "Hypochondrogenesis", value: "Hypochondrogenesis" },
      {
        label: "Other specified spondylodysplastic dysplasias",
        value: "Other specified spondylodysplastic dysplasias",
      },
      {
        label: "Spondylodysplastic dysplasias, unspecified",
        value: "Spondylodysplastic dysplasias, unspecified",
      },
      {
        label: "Multiple epiphyseal dysplasia or pseudoachondroplasia",
        value: "Multiple epiphyseal dysplasia or pseudoachondroplasia",
      },
      { label: "Pseudoachondroplasia", value: "Pseudoachondroplasia" },
      {
        label: "Multiple epiphyseal dysplasias",
        value: "Multiple epiphyseal dysplasias",
      },
      {
        label:
          "Other specified multiple epiphyseal dysplasia or pseudoachondroplasia",
        value:
          "Other specified multiple epiphyseal dysplasia or pseudoachondroplasia",
      },
      {
        label:
          "Multiple epiphyseal dysplasia or pseudoachondroplasia, unspecified",
        value:
          "Multiple epiphyseal dysplasia or pseudoachondroplasia, unspecified",
      },
      {
        label: "Multiple metaphyseal dysplasias",
        value: "Multiple metaphyseal dysplasias",
      },
      { label: "Acromelic dysplasias", value: "Acromelic dysplasias" },
      { label: "Langer-Giedion syndrome", value: "Langer-Giedion syndrome" },
      {
        label: "Other specified acromelic dysplasias",
        value: "Other specified acromelic dysplasias",
      },
      {
        label: "Acromelic dysplasias, unspecified",
        value: "Acromelic dysplasias, unspecified",
      },
      { label: "Acromesomelic dysplasias", value: "Acromesomelic dysplasias" },
      {
        label: "Mesomelic or rhizomesomelic dysplasias",
        value: "Mesomelic or rhizomesomelic dysplasias",
      },
      { label: "Short rib syndromes", value: "Short rib syndromes" },
      {
        label: "Short rib-polydactyly syndrome",
        value: "Short rib-polydactyly syndrome",
      },
      {
        label: "Asphyxiating thoracic dystrophy",
        value: "Asphyxiating thoracic dystrophy",
      },
      {
        label: "Other specified short rib syndromes",
        value: "Other specified short rib syndromes",
      },
      {
        label: "Short rib syndromes, unspecified",
        value: "Short rib syndromes, unspecified",
      },
      { label: "Bent bone dysplasias", value: "Bent bone dysplasias" },
      { label: "Slender bone dysplasias", value: "Slender bone dysplasias" },
      {
        label: "Bone dysplasias with multiple joint dislocations",
        value: "Bone dysplasias with multiple joint dislocations",
      },
      {
        label:
          "Progressive ossification of skin, skeletal muscle, fascia, tendons or ligaments",
        value:
          "Progressive ossification of skin, skeletal muscle, fascia, tendons or ligaments",
      },
      {
        label: "Syndromic craniosynostoses",
        value: "Syndromic craniosynostoses",
      },
      { label: "Pfeiffer syndrome", value: "Pfeiffer syndrome" },
      { label: "Crouzon disease", value: "Crouzon disease" },
      { label: "Apert syndrome", value: "Apert syndrome" },
      {
        label: "Other specified syndromic craniosynostoses",
        value: "Other specified syndromic craniosynostoses",
      },
      {
        label: "Syndromic craniosynostoses, unspecified",
        value: "Syndromic craniosynostoses, unspecified",
      },
      {
        label: "Dysostoses with predominant vertebral and costal involvement",
        value: "Dysostoses with predominant vertebral and costal involvement",
      },
      { label: "Patellar dysostoses", value: "Patellar dysostoses" },
      { label: "Nail-patella syndrome", value: "Nail-patella syndrome" },
      {
        label: "Other specified patellar dysostoses",
        value: "Other specified patellar dysostoses",
      },
      {
        label: "Patellar dysostoses, unspecified",
        value: "Patellar dysostoses, unspecified",
      },
      {
        label: "Genetic bone diseases with decreased bone density",
        value: "Genetic bone diseases with decreased bone density",
      },
      { label: "Osteogenesis imperfecta", value: "Osteogenesis imperfecta" },
      {
        label:
          "Other specified genetic bone diseases with decreased bone density",
        value:
          "Other specified genetic bone diseases with decreased bone density",
      },
      {
        label: "Genetic bone diseases with decreased bone density, unspecified",
        value: "Genetic bone diseases with decreased bone density, unspecified",
      },
      {
        label:
          "Other specified syndromes with skeletal anomalies as a major feature",
        value:
          "Other specified syndromes with skeletal anomalies as a major feature",
      },
      {
        label:
          "Syndromes with skeletal anomalies as a major feature, unspecified",
        value:
          "Syndromes with skeletal anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with face or limb anomalies as a major feature",
        value: "Syndromes with face or limb anomalies as a major feature",
      },
      {
        label: "Oromandibular-limb anomaly syndrome",
        value: "Oromandibular-limb anomaly syndrome",
      },
      {
        label: "Oral-facial-digital syndrome",
        value: "Oral-facial-digital syndrome",
      },
      {
        label: "Other specified oromandibular-limb anomaly syndrome",
        value: "Other specified oromandibular-limb anomaly syndrome",
      },
      {
        label: "Oromandibular-limb anomaly syndrome, unspecified",
        value: "Oromandibular-limb anomaly syndrome, unspecified",
      },
      {
        label: "Fronto-otopalatodigital syndromes",
        value: "Fronto-otopalatodigital syndromes",
      },
      { label: "Acrofacial dysostoses", value: "Acrofacial dysostoses" },
      { label: "Craniofacial dysostoses", value: "Craniofacial dysostoses" },
      {
        label:
          "Other specified syndromes with face or limb anomalies as a major feature",
        value:
          "Other specified syndromes with face or limb anomalies as a major feature",
      },
      {
        label:
          "Syndromes with face or limb anomalies as a major feature, unspecified",
        value:
          "Syndromes with face or limb anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with limb anomalies as a major feature",
        value: "Syndromes with limb anomalies as a major feature",
      },
      {
        label: "Combined reduction defects of upper and lower limbs",
        value: "Combined reduction defects of upper and lower limbs",
      },
      { label: "Complex brachydactylies", value: "Complex brachydactylies" },
      {
        label:
          "Syndromes with limb duplication, polydactyly, syndactyly or triphalangism",
        value:
          "Syndromes with limb duplication, polydactyly, syndactyly or triphalangism",
      },
      {
        label: "Syndromes with synostoses of limbs",
        value: "Syndromes with synostoses of limbs",
      },
      { label: "Arthrogryposis syndromes", value: "Arthrogryposis syndromes" },
      {
        label: "Multiple pterygium syndrome",
        value: "Multiple pterygium syndrome",
      },
      {
        label: "Arthrogryposis multiplex congenita",
        value: "Arthrogryposis multiplex congenita",
      },
      {
        label: "Other specified arthrogryposis syndromes",
        value: "Other specified arthrogryposis syndromes",
      },
      {
        label: "Arthrogryposis syndromes, unspecified",
        value: "Arthrogryposis syndromes, unspecified",
      },
      { label: "Constriction rings", value: "Constriction rings" },
      {
        label: "Congenital vascular bone syndromes",
        value: "Congenital vascular bone syndromes",
      },
      {
        label: "Angio-osteohypertrophic syndrome",
        value: "Angio-osteohypertrophic syndrome",
      },
      {
        label: "Other specified congenital vascular bone syndromes",
        value: "Other specified congenital vascular bone syndromes",
      },
      {
        label: "Congenital vascular bone syndromes, unspecified",
        value: "Congenital vascular bone syndromes, unspecified",
      },
      {
        label:
          "Other specified syndromes with limb anomalies as a major feature",
        value:
          "Other specified syndromes with limb anomalies as a major feature",
      },
      {
        label: "Syndromes with limb anomalies as a major feature, unspecified",
        value: "Syndromes with limb anomalies as a major feature, unspecified",
      },
      {
        label: "Syndromes with skin or mucosal anomalies as a major feature",
        value: "Syndromes with skin or mucosal anomalies as a major feature",
      },
      {
        label: "Ectodermal dysplasia syndromes",
        value: "Ectodermal dysplasia syndromes",
      },
      { label: "Incontinentia pigmenti", value: "Incontinentia pigmenti" },
      {
        label: "Cronkhite-Canada syndrome",
        value: "Cronkhite-Canada syndrome",
      },
      {
        label: "Hypohidrotic ectodermal dysplasia",
        value: "Hypohidrotic ectodermal dysplasia",
      },
      {
        label: "Hidrotic ectodermal dysplasia, Clouston type",
        value: "Hidrotic ectodermal dysplasia, Clouston type",
      },
      {
        label: "Other specified ectodermal dysplasia syndromes",
        value: "Other specified ectodermal dysplasia syndromes",
      },
      { label: "Xeroderma pigmentosum", value: "Xeroderma pigmentosum" },
      { label: "Syndromic ichthyosis", value: "Syndromic ichthyosis" },
      {
        label: "Genetic syndromes with hypertrichosis",
        value: "Genetic syndromes with hypertrichosis",
      },
      {
        label: "Genetic syndromes affecting nails",
        value: "Genetic syndromes affecting nails",
      },
      {
        label: "Genetic hamartoneoplastic syndromes affecting the skin",
        value: "Genetic hamartoneoplastic syndromes affecting the skin",
      },
      { label: "Genetic lipodystrophy", value: "Genetic lipodystrophy" },
      {
        label: "Congenital generalised lipodystrophy",
        value: "Congenital generalised lipodystrophy",
      },
      {
        label: "Genetic lipodystrophy, unspecified",
        value: "Genetic lipodystrophy, unspecified",
      },
      {
        label:
          "Other specified syndromes with skin or mucosal anomalies as a major feature",
        value:
          "Other specified syndromes with skin or mucosal anomalies as a major feature",
      },
      {
        label:
          "Syndromes with skin or mucosal anomalies as a major feature, unspecified",
        value:
          "Syndromes with skin or mucosal anomalies as a major feature, unspecified",
      },
      {
        label:
          "Syndromes with connective tissue involvement as a major feature",
        value:
          "Syndromes with connective tissue involvement as a major feature",
      },
      {
        label: "Marfan syndrome or Marfan-related disorders",
        value: "Marfan syndrome or Marfan-related disorders",
      },
      {
        label: "Congenital contractural arachnodactyly",
        value: "Congenital contractural arachnodactyly",
      },
      { label: "Marfan syndrome", value: "Marfan syndrome" },
      {
        label: "Other specified Marfan syndrome or Marfan-related disorders",
        value: "Other specified Marfan syndrome or Marfan-related disorders",
      },
      {
        label: "Marfan syndrome or Marfan-related disorders, unspecified",
        value: "Marfan syndrome or Marfan-related disorders, unspecified",
      },
      { label: "Ehlers-Danlos syndrome", value: "Ehlers-Danlos syndrome" },
      {
        label: "Ehlers-Danlos syndrome, classical type",
        value: "Ehlers-Danlos syndrome, classical type",
      },
      {
        label: "Other specified types of Ehlers-Danlos syndrome",
        value: "Other specified types of Ehlers-Danlos syndrome",
      },
      {
        label: "Genetically-determined cutis laxa",
        value: "Genetically-determined cutis laxa",
      },
      {
        label:
          "Other specified syndromes with connective tissue involvement as a major feature",
        value:
          "Other specified syndromes with connective tissue involvement as a major feature",
      },
      {
        label:
          "Syndromes with connective tissue involvement as a major feature, unspecified",
        value:
          "Syndromes with connective tissue involvement as a major feature, unspecified",
      },
      {
        label: "Syndromes with obesity as a major feature",
        value: "Syndromes with obesity as a major feature",
      },
      {
        label: "Malformative disorders of sex development",
        value: "Malformative disorders of sex development",
      },
      {
        label: "Ovotesticular disorder of sex development",
        value: "Ovotesticular disorder of sex development",
      },
      { label: "46,XY gonadal dysgenesis", value: "46,XY gonadal dysgenesis" },
      { label: "Testicular agenesis", value: "Testicular agenesis" },
      {
        label:
          "46,XY disorder of sex development due to a defect in testosterone metabolism",
        value:
          "46,XY disorder of sex development due to a defect in testosterone metabolism",
      },
      {
        label: "46,XY disorder of sex development due to androgen resistance",
        value: "46,XY disorder of sex development due to androgen resistance",
      },
      {
        label: "Other specified malformative disorders of sex development",
        value: "Other specified malformative disorders of sex development",
      },
      {
        label: "Malformative disorders of sex development, unspecified",
        value: "Malformative disorders of sex development, unspecified",
      },
      {
        label: "Syndromes with premature ageing appearance as a major feature",
        value: "Syndromes with premature ageing appearance as a major feature",
      },
      { label: "Overgrowth syndromes", value: "Overgrowth syndromes" },
      {
        label: "Phakomatoses or hamartoneoplastic syndromes",
        value: "Phakomatoses or hamartoneoplastic syndromes",
      },
      { label: "Peutz-Jeghers syndrome", value: "Peutz-Jeghers syndrome" },
      { label: "Neurofibromatoses", value: "Neurofibromatoses" },
      { label: "Neurofibromatosis type 1", value: "Neurofibromatosis type 1" },
      { label: "Neurofibromatosis type 2", value: "Neurofibromatosis type 2" },
      { label: "Neurofibromatosis type 3", value: "Neurofibromatosis type 3" },
      {
        label: "Other specified neurofibromatoses",
        value: "Other specified neurofibromatoses",
      },
      {
        label: "Neurofibromatosis, unspecified",
        value: "Neurofibromatosis, unspecified",
      },
      { label: "Tuberous sclerosis", value: "Tuberous sclerosis" },
      { label: "Gardner syndrome", value: "Gardner syndrome" },
      { label: "Gorlin syndrome", value: "Gorlin syndrome" },
      {
        label: "Other specified phakomatoses or hamartoneoplastic syndromes",
        value: "Other specified phakomatoses or hamartoneoplastic syndromes",
      },
      {
        label: "Phakomatoses or hamartoneoplastic syndromes, unspecified",
        value: "Phakomatoses or hamartoneoplastic syndromes, unspecified",
      },
      {
        label:
          "Syndromes with structural anomalies due to inborn errors of metabolism",
        value:
          "Syndromes with structural anomalies due to inborn errors of metabolism",
      },
      {
        label:
          "Syndromes with multiple structural anomalies, without predominant body system involvement",
        value:
          "Syndromes with multiple structural anomalies, without predominant body system involvement",
      },
      {
        label: "Toxic or drug-related embryofetopathies",
        value: "Toxic or drug-related embryofetopathies",
      },
      { label: "Fetal alcohol syndrome", value: "Fetal alcohol syndrome" },
      { label: "Fetal hydantoin syndrome", value: "Fetal hydantoin syndrome" },
      {
        label: "Embryofetopathy due to oral anticoagulant therapy",
        value: "Embryofetopathy due to oral anticoagulant therapy",
      },
      {
        label: "Fetal Valproate Spectrum Disorder",
        value: "Fetal Valproate Spectrum Disorder",
      },
      {
        label: "Other specified toxic or drug-related embryofetopathies",
        value: "Other specified toxic or drug-related embryofetopathies",
      },
      {
        label: "Toxic or drug-related embryofetopathies, unspecified",
        value: "Toxic or drug-related embryofetopathies, unspecified",
      },
      {
        label:
          "Syndromes with multiple structural anomalies, not of environmental origin",
        value:
          "Syndromes with multiple structural anomalies, not of environmental origin",
      },
      { label: "Prune belly syndrome", value: "Prune belly syndrome" },
      { label: "VATER association", value: "VATER association" },
      { label: "Sirenomelia", value: "Sirenomelia" },
      { label: "Meckel-Gruber syndrome", value: "Meckel-Gruber syndrome" },
      { label: "MURCS association", value: "MURCS association" },
      { label: "Noonan syndrome", value: "Noonan syndrome" },
      { label: "Otomandibular dysplasia", value: "Otomandibular dysplasia" },
      {
        label:
          "Other specified syndromes with multiple structural anomalies, not of environmental origin",
        value:
          "Other specified syndromes with multiple structural anomalies, not of environmental origin",
      },
      {
        label:
          "Syndromes with multiple structural anomalies, not of environmental origin, unspecified",
        value:
          "Syndromes with multiple structural anomalies, not of environmental origin, unspecified",
      },
      {
        label:
          "Other specified syndromes with multiple structural anomalies, without predominant body system involvement",
        value:
          "Other specified syndromes with multiple structural anomalies, without predominant body system involvement",
      },
      {
        label:
          "Syndromes with multiple structural anomalies, without predominant body system involvement, unspecified",
        value:
          "Syndromes with multiple structural anomalies, without predominant body system involvement, unspecified",
      },
      { label: "Conjoined twins", value: "Conjoined twins" },
      {
        label: "Syndromic genetic deafness",
        value: "Syndromic genetic deafness",
      },
      { label: "Fraser syndrome", value: "Fraser syndrome" },
      {
        label: "Neuropathy with hearing impairment",
        value: "Neuropathy with hearing impairment",
      },
      {
        label: "Progressive deafness with stapes fixation",
        value: "Progressive deafness with stapes fixation",
      },
      {
        label: "Waardenburg-Shah syndrome",
        value: "Waardenburg-Shah syndrome",
      },
      { label: "Usher syndrome", value: "Usher syndrome" },
      {
        label: "Other specified syndromic genetic deafness",
        value: "Other specified syndromic genetic deafness",
      },
      {
        label: "Syndromic genetic deafness, unspecified",
        value: "Syndromic genetic deafness, unspecified",
      },
      {
        label: "Other specified multiple developmental anomalies or syndromes",
        value: "Other specified multiple developmental anomalies or syndromes",
      },
      {
        label: "Multiple developmental anomalies or syndromes, unspecified",
        value: "Multiple developmental anomalies or syndromes, unspecified",
      },
      {
        label: "Chromosomal anomalies, excluding gene mutations",
        value: "Chromosomal anomalies, excluding gene mutations",
      },
      {
        label: "Complete trisomies of the autosomes",
        value: "Complete trisomies of the autosomes",
      },
      { label: "Complete trisomy 21", value: "Complete trisomy 21" },
      { label: "Complete trisomy 13", value: "Complete trisomy 13" },
      { label: "Complete trisomy 18", value: "Complete trisomy 18" },
      {
        label: "Other specified complete trisomies of the autosomes",
        value: "Other specified complete trisomies of the autosomes",
      },
      {
        label: "Complete trisomies of the autosomes, unspecified",
        value: "Complete trisomies of the autosomes, unspecified",
      },
      {
        label: "Duplications of the autosomes",
        value: "Duplications of the autosomes",
      },
      {
        label: "Duplications of chromosome 1",
        value: "Duplications of chromosome 1",
      },
      {
        label: "Duplications of the long arm of chromosome 1",
        value: "Duplications of the long arm of chromosome 1",
      },
      {
        label: "Duplications of the short arm of chromosome 1",
        value: "Duplications of the short arm of chromosome 1",
      },
      {
        label: "Other specified duplications of chromosome 1",
        value: "Other specified duplications of chromosome 1",
      },
      {
        label: "Duplications of chromosome 1, unspecified",
        value: "Duplications of chromosome 1, unspecified",
      },
      {
        label: "Duplications of chromosome 2",
        value: "Duplications of chromosome 2",
      },
      {
        label: "Duplications of the long arm of chromosome 2",
        value: "Duplications of the long arm of chromosome 2",
      },
      {
        label: "Duplications of the short arm of chromosome 2",
        value: "Duplications of the short arm of chromosome 2",
      },
      {
        label: "Other specified duplications of chromosome 2",
        value: "Other specified duplications of chromosome 2",
      },
      {
        label: "Duplications of chromosome 2, unspecified",
        value: "Duplications of chromosome 2, unspecified",
      },
      {
        label: "Duplications of chromosome 3",
        value: "Duplications of chromosome 3",
      },
      {
        label: "Duplications of the long arm of chromosome 3",
        value: "Duplications of the long arm of chromosome 3",
      },
      {
        label: "Duplications of the short arm of chromosome 3",
        value: "Duplications of the short arm of chromosome 3",
      },
      {
        label: "Other specified duplications of chromosome 3",
        value: "Other specified duplications of chromosome 3",
      },
      {
        label: "Duplications of chromosome 3, unspecified",
        value: "Duplications of chromosome 3, unspecified",
      },
      {
        label: "Duplications of chromosome 4",
        value: "Duplications of chromosome 4",
      },
      {
        label: "Duplications of the long arm of chromosome 4",
        value: "Duplications of the long arm of chromosome 4",
      },
      {
        label: "Duplications of the short arm of chromosome 4",
        value: "Duplications of the short arm of chromosome 4",
      },
      {
        label: "Other specified duplications of chromosome 4",
        value: "Other specified duplications of chromosome 4",
      },
      {
        label: "Duplications of chromosome 4, unspecified",
        value: "Duplications of chromosome 4, unspecified",
      },
      {
        label: "Duplications of chromosome 5",
        value: "Duplications of chromosome 5",
      },
      {
        label: "Duplications of the long arm of chromosome 5",
        value: "Duplications of the long arm of chromosome 5",
      },
      {
        label: "Duplications of the short arm of chromosome 5",
        value: "Duplications of the short arm of chromosome 5",
      },
      {
        label: "Other specified duplications of chromosome 5",
        value: "Other specified duplications of chromosome 5",
      },
      {
        label: "Duplications of chromosome 5, unspecified",
        value: "Duplications of chromosome 5, unspecified",
      },
      {
        label: "Duplications of chromosome 6",
        value: "Duplications of chromosome 6",
      },
      {
        label: "Duplications of the long arm of chromosome 6",
        value: "Duplications of the long arm of chromosome 6",
      },
      {
        label: "Duplications of the short arm of chromosome 6",
        value: "Duplications of the short arm of chromosome 6",
      },
      {
        label: "Other specified duplications of chromosome 6",
        value: "Other specified duplications of chromosome 6",
      },
      {
        label: "Duplications of chromosome 6, unspecified",
        value: "Duplications of chromosome 6, unspecified",
      },
      {
        label: "Duplications of chromosome 7",
        value: "Duplications of chromosome 7",
      },
      {
        label: "Duplications of the long arm of chromosome 7",
        value: "Duplications of the long arm of chromosome 7",
      },
      {
        label: "Duplications of the short arm of chromosome 7",
        value: "Duplications of the short arm of chromosome 7",
      },
      {
        label: "Other specified duplications of chromosome 7",
        value: "Other specified duplications of chromosome 7",
      },
      {
        label: "Duplications of chromosome 7, unspecified",
        value: "Duplications of chromosome 7, unspecified",
      },
      {
        label: "Duplications of chromosome 8",
        value: "Duplications of chromosome 8",
      },
      {
        label: "Duplications of the long arm of chromosome 8",
        value: "Duplications of the long arm of chromosome 8",
      },
      {
        label: "Duplications of the short arm of chromosome 8",
        value: "Duplications of the short arm of chromosome 8",
      },
      {
        label: "Other specified duplications of chromosome 8",
        value: "Other specified duplications of chromosome 8",
      },
      {
        label: "Duplications of chromosome 8, unspecified",
        value: "Duplications of chromosome 8, unspecified",
      },
      {
        label: "Duplications of chromosome 9",
        value: "Duplications of chromosome 9",
      },
      {
        label: "Duplications of the long arm of chromosome 9",
        value: "Duplications of the long arm of chromosome 9",
      },
      {
        label: "Duplications of the short arm of chromosome 9",
        value: "Duplications of the short arm of chromosome 9",
      },
      {
        label: "Other specified duplications of chromosome 9",
        value: "Other specified duplications of chromosome 9",
      },
      {
        label: "Duplications of chromosome 9, unspecified",
        value: "Duplications of chromosome 9, unspecified",
      },
      {
        label: "Duplications of chromosome 10",
        value: "Duplications of chromosome 10",
      },
      {
        label: "Duplications of the long arm of chromosome 10",
        value: "Duplications of the long arm of chromosome 10",
      },
      {
        label: "Duplications of the short arm of chromosome 10",
        value: "Duplications of the short arm of chromosome 10",
      },
      {
        label: "Other specified duplications of chromosome 10",
        value: "Other specified duplications of chromosome 10",
      },
      {
        label: "Duplications of chromosome 10, unspecified",
        value: "Duplications of chromosome 10, unspecified",
      },
      {
        label: "Duplications of chromosome 11",
        value: "Duplications of chromosome 11",
      },
      {
        label: "Duplications of chromosome 12",
        value: "Duplications of chromosome 12",
      },
      {
        label: "Duplications of the long arm of chromosome 12",
        value: "Duplications of the long arm of chromosome 12",
      },
      {
        label: "Duplications of the short arm of chromosome 12",
        value: "Duplications of the short arm of chromosome 12",
      },
      {
        label: "Other specified duplications of chromosome 12",
        value: "Other specified duplications of chromosome 12",
      },
      {
        label: "Duplications of chromosome 12, unspecified",
        value: "Duplications of chromosome 12, unspecified",
      },
      {
        label: "Duplications of chromosome 13",
        value: "Duplications of chromosome 13",
      },
      {
        label: "Duplications of chromosome 14",
        value: "Duplications of chromosome 14",
      },
      {
        label: "Duplications of chromosome 15",
        value: "Duplications of chromosome 15",
      },
      {
        label: "Duplications of chromosome 16",
        value: "Duplications of chromosome 16",
      },
      {
        label: "Duplications of the long arm of chromosome 16",
        value: "Duplications of the long arm of chromosome 16",
      },
      {
        label: "Duplications of the short arm of chromosome 16",
        value: "Duplications of the short arm of chromosome 16",
      },
      {
        label: "Other specified duplications of chromosome 16",
        value: "Other specified duplications of chromosome 16",
      },
      {
        label: "Duplications of chromosome 16, unspecified",
        value: "Duplications of chromosome 16, unspecified",
      },
      {
        label: "Duplications of chromosome 17",
        value: "Duplications of chromosome 17",
      },
      {
        label: "Duplications of the long arm of chromosome 17",
        value: "Duplications of the long arm of chromosome 17",
      },
      {
        label: "Duplications of the short arm of chromosome 17",
        value: "Duplications of the short arm of chromosome 17",
      },
      {
        label: "Other specified duplications of chromosome 17",
        value: "Other specified duplications of chromosome 17",
      },
      {
        label: "Duplications of chromosome 17, unspecified",
        value: "Duplications of chromosome 17, unspecified",
      },
      {
        label: "Duplications of chromosome 18",
        value: "Duplications of chromosome 18",
      },
      {
        label: "Duplications of the long arm of chromosome 18",
        value: "Duplications of the long arm of chromosome 18",
      },
      {
        label: "Duplications of the short arm of chromosome 18",
        value: "Duplications of the short arm of chromosome 18",
      },
      {
        label: "Other specified duplications of chromosome 18",
        value: "Other specified duplications of chromosome 18",
      },
      {
        label: "Duplications of chromosome 18, unspecified",
        value: "Duplications of chromosome 18, unspecified",
      },
      {
        label: "Duplications of chromosome 19",
        value: "Duplications of chromosome 19",
      },
      {
        label: "Duplications of the long arm of chromosome 19",
        value: "Duplications of the long arm of chromosome 19",
      },
      {
        label: "Duplications of the short arm of chromosome 19",
        value: "Duplications of the short arm of chromosome 19",
      },
      {
        label: "Other specified duplications of chromosome 19",
        value: "Other specified duplications of chromosome 19",
      },
      {
        label: "Duplications of chromosome 19, unspecified",
        value: "Duplications of chromosome 19, unspecified",
      },
      {
        label: "Duplications of chromosome 20",
        value: "Duplications of chromosome 20",
      },
      {
        label: "Duplications of the long arm of chromosome 20",
        value: "Duplications of the long arm of chromosome 20",
      },
      {
        label: "Duplications of the short arm of chromosome 20",
        value: "Duplications of the short arm of chromosome 20",
      },
      {
        label: "Other specified duplications of chromosome 20",
        value: "Other specified duplications of chromosome 20",
      },
      {
        label: "Duplications of chromosome 20, unspecified",
        value: "Duplications of chromosome 20, unspecified",
      },
      {
        label: "Duplications of chromosome 21",
        value: "Duplications of chromosome 21",
      },
      {
        label: "Duplications of chromosome 22",
        value: "Duplications of chromosome 22",
      },
      {
        label: "Extra ring or dicentric chromosomes",
        value: "Extra ring or dicentric chromosomes",
      },
      {
        label: "Duplications with other complex rearrangements",
        value: "Duplications with other complex rearrangements",
      },
      { label: "Extra marker chromosomes", value: "Extra marker chromosomes" },
      {
        label: "Other specified duplications of the autosomes",
        value: "Other specified duplications of the autosomes",
      },
      {
        label: "Duplications of the autosomes, unspecified",
        value: "Duplications of the autosomes, unspecified",
      },
      { label: "Polyploidies", value: "Polyploidies" },
      { label: "Triploidy", value: "Triploidy" },
      { label: "Tetraploidy", value: "Tetraploidy" },
      {
        label: "Other specified polyploidies",
        value: "Other specified polyploidies",
      },
      {
        label: "Polyploidies, unspecified",
        value: "Polyploidies, unspecified",
      },
      {
        label: "Complete monosomies of the autosomes",
        value: "Complete monosomies of the autosomes",
      },
      {
        label: "Complete monosomy of autosome",
        value: "Complete monosomy of autosome",
      },
      {
        label: "Mosaic monosomy of autosome",
        value: "Mosaic monosomy of autosome",
      },
      {
        label: "Other specified complete monosomies of the autosomes",
        value: "Other specified complete monosomies of the autosomes",
      },
      {
        label: "Complete monosomies of the autosomes, unspecified",
        value: "Complete monosomies of the autosomes, unspecified",
      },
      {
        label: "Deletions of the autosomes",
        value: "Deletions of the autosomes",
      },
      {
        label:
          "Chromosome replaced with ring or dicentric with normal number of chromosomes",
        value:
          "Chromosome replaced with ring or dicentric with normal number of chromosomes",
      },
      {
        label: "Deletions of chromosome 1",
        value: "Deletions of chromosome 1",
      },
      {
        label: "Deletions of the long arm of chromosome 1",
        value: "Deletions of the long arm of chromosome 1",
      },
      {
        label: "Deletions of the short arm of chromosome 1",
        value: "Deletions of the short arm of chromosome 1",
      },
      {
        label: "Other specified deletions of chromosome 1",
        value: "Other specified deletions of chromosome 1",
      },
      {
        label: "Deletions of chromosome 1, unspecified",
        value: "Deletions of chromosome 1, unspecified",
      },
      {
        label: "Deletions of chromosome 2",
        value: "Deletions of chromosome 2",
      },
      {
        label: "Deletions of the long arm of chromosome 2",
        value: "Deletions of the long arm of chromosome 2",
      },
      {
        label: "Deletions of the short arm of chromosome 2",
        value: "Deletions of the short arm of chromosome 2",
      },
      {
        label: "Other specified deletions of chromosome 2",
        value: "Other specified deletions of chromosome 2",
      },
      {
        label: "Deletions of chromosome 2, unspecified",
        value: "Deletions of chromosome 2, unspecified",
      },
      {
        label: "Deletions of chromosome 3",
        value: "Deletions of chromosome 3",
      },
      {
        label: "Deletions of the long arm of chromosome 3",
        value: "Deletions of the long arm of chromosome 3",
      },
      {
        label: "Deletions of the short arm of chromosome 3",
        value: "Deletions of the short arm of chromosome 3",
      },
      {
        label: "Other specified deletions of chromosome 3",
        value: "Other specified deletions of chromosome 3",
      },
      {
        label: "Deletions of chromosome 3, unspecified",
        value: "Deletions of chromosome 3, unspecified",
      },
      {
        label: "Deletions of chromosome 4",
        value: "Deletions of chromosome 4",
      },
      {
        label: "Deletions of the long arm of chromosome 4",
        value: "Deletions of the long arm of chromosome 4",
      },
      {
        label: "Deletions of the short arm of chromosome 4",
        value: "Deletions of the short arm of chromosome 4",
      },
      {
        label: "Other specified deletions of chromosome 4",
        value: "Other specified deletions of chromosome 4",
      },
      {
        label: "Deletions of chromosome 4, unspecified",
        value: "Deletions of chromosome 4, unspecified",
      },
      {
        label: "Deletions of chromosome 5",
        value: "Deletions of chromosome 5",
      },
      {
        label: "Deletions of the long arm of chromosome 5",
        value: "Deletions of the long arm of chromosome 5",
      },
      {
        label: "Deletions of the short arm of chromosome 5",
        value: "Deletions of the short arm of chromosome 5",
      },
      {
        label: "Other specified deletions of chromosome 5",
        value: "Other specified deletions of chromosome 5",
      },
      {
        label: "Deletions of chromosome 5, unspecified",
        value: "Deletions of chromosome 5, unspecified",
      },
      {
        label: "Deletions of chromosome 6",
        value: "Deletions of chromosome 6",
      },
      {
        label: "Deletions of the long arm of chromosome 6",
        value: "Deletions of the long arm of chromosome 6",
      },
      {
        label: "Deletions of the short arm of chromosome 6",
        value: "Deletions of the short arm of chromosome 6",
      },
      {
        label: "Other specified deletions of chromosome 6",
        value: "Other specified deletions of chromosome 6",
      },
      {
        label: "Deletions of chromosome 6, unspecified",
        value: "Deletions of chromosome 6, unspecified",
      },
      {
        label: "Deletions of chromosome 7",
        value: "Deletions of chromosome 7",
      },
      {
        label: "Deletions of the long arm of chromosome 7",
        value: "Deletions of the long arm of chromosome 7",
      },
      {
        label: "Deletions of the short arm of chromosome 7",
        value: "Deletions of the short arm of chromosome 7",
      },
      {
        label: "Other specified deletions of chromosome 7",
        value: "Other specified deletions of chromosome 7",
      },
      {
        label: "Deletions of chromosome 7, unspecified",
        value: "Deletions of chromosome 7, unspecified",
      },
      {
        label: "Deletions of chromosome 8",
        value: "Deletions of chromosome 8",
      },
      {
        label: "Deletions of the long arm of chromosome 8",
        value: "Deletions of the long arm of chromosome 8",
      },
      {
        label: "Deletions of the short arm of chromosome 8",
        value: "Deletions of the short arm of chromosome 8",
      },
      {
        label: "Other specified deletions of chromosome 8",
        value: "Other specified deletions of chromosome 8",
      },
      {
        label: "Deletions of chromosome 8, unspecified",
        value: "Deletions of chromosome 8, unspecified",
      },
      {
        label: "Deletions of chromosome 9",
        value: "Deletions of chromosome 9",
      },
      {
        label: "Deletions of the long arm of chromosome 9",
        value: "Deletions of the long arm of chromosome 9",
      },
      {
        label: "Deletions of the short arm of chromosome 9",
        value: "Deletions of the short arm of chromosome 9",
      },
      {
        label: "Other specified deletions of chromosome 9",
        value: "Other specified deletions of chromosome 9",
      },
      {
        label: "Deletions of chromosome 9, unspecified",
        value: "Deletions of chromosome 9, unspecified",
      },
      {
        label: "Deletions of chromosome 10",
        value: "Deletions of chromosome 10",
      },
      {
        label: "Deletions of the long arm of chromosome 10",
        value: "Deletions of the long arm of chromosome 10",
      },
      {
        label: "Deletions of the short arm of chromosome 10",
        value: "Deletions of the short arm of chromosome 10",
      },
      {
        label: "Other specified deletions of chromosome 10",
        value: "Other specified deletions of chromosome 10",
      },
      {
        label: "Deletions of chromosome 10, unspecified",
        value: "Deletions of chromosome 10, unspecified",
      },
      {
        label: "Deletions of chromosome 11",
        value: "Deletions of chromosome 11",
      },
      {
        label: "Deletions of the long arm of chromosome 11",
        value: "Deletions of the long arm of chromosome 11",
      },
      {
        label: "Deletions of the short arm of chromosome 11",
        value: "Deletions of the short arm of chromosome 11",
      },
      {
        label: "Other specified deletions of chromosome 11",
        value: "Other specified deletions of chromosome 11",
      },
      {
        label: "Deletions of chromosome 11, unspecified",
        value: "Deletions of chromosome 11, unspecified",
      },
      {
        label: "Deletions of chromosome 12",
        value: "Deletions of chromosome 12",
      },
      {
        label: "Deletions of the long arm of chromosome 12",
        value: "Deletions of the long arm of chromosome 12",
      },
      {
        label: "Deletions of the short arm of chromosome 12",
        value: "Deletions of the short arm of chromosome 12",
      },
      {
        label: "Other specified deletions of chromosome 12",
        value: "Other specified deletions of chromosome 12",
      },
      {
        label: "Deletions of chromosome 12, unspecified",
        value: "Deletions of chromosome 12, unspecified",
      },
      {
        label: "Deletions of chromosome 13",
        value: "Deletions of chromosome 13",
      },
      {
        label: "Deletions of chromosome 14",
        value: "Deletions of chromosome 14",
      },
      {
        label: "Deletions of chromosome 15",
        value: "Deletions of chromosome 15",
      },
      {
        label: "Deletions of chromosome 16",
        value: "Deletions of chromosome 16",
      },
      {
        label: "Deletions of the long arm of chromosome 16",
        value: "Deletions of the long arm of chromosome 16",
      },
      {
        label: "Deletions of the short arm of chromosome 16",
        value: "Deletions of the short arm of chromosome 16",
      },
      {
        label: "Other specified deletions of chromosome 16",
        value: "Other specified deletions of chromosome 16",
      },
      {
        label: "Deletions of chromosome 16, unspecified",
        value: "Deletions of chromosome 16, unspecified",
      },
      {
        label: "Deletions of chromosome 17",
        value: "Deletions of chromosome 17",
      },
      {
        label: "Deletions of the long arm of chromosome 17",
        value: "Deletions of the long arm of chromosome 17",
      },
      {
        label: "Deletions of the short arm of chromosome 17",
        value: "Deletions of the short arm of chromosome 17",
      },
      {
        label: "Other specified deletions of chromosome 17",
        value: "Other specified deletions of chromosome 17",
      },
      {
        label: "Deletions of chromosome 17, unspecified",
        value: "Deletions of chromosome 17, unspecified",
      },
      {
        label: "Deletions of chromosome 18",
        value: "Deletions of chromosome 18",
      },
      {
        label: "Deletions of the long arm of chromosome 18",
        value: "Deletions of the long arm of chromosome 18",
      },
      {
        label: "Deletions of the short arm of chromosome 18",
        value: "Deletions of the short arm of chromosome 18",
      },
      {
        label: "Other specified deletions of chromosome 18",
        value: "Other specified deletions of chromosome 18",
      },
      {
        label: "Deletions of chromosome 18, unspecified",
        value: "Deletions of chromosome 18, unspecified",
      },
      {
        label: "Deletions of chromosome 19",
        value: "Deletions of chromosome 19",
      },
      {
        label: "Deletions of the long arm of chromosome 19",
        value: "Deletions of the long arm of chromosome 19",
      },
      {
        label: "Deletions of the short arm of chromosome 19",
        value: "Deletions of the short arm of chromosome 19",
      },
      {
        label: "Other specified deletions of chromosome 19",
        value: "Other specified deletions of chromosome 19",
      },
      {
        label: "Deletions of chromosome 19, unspecified",
        value: "Deletions of chromosome 19, unspecified",
      },
      {
        label: "Deletions of chromosome 20",
        value: "Deletions of chromosome 20",
      },
      {
        label: "Deletions of the long arm of chromosome 20",
        value: "Deletions of the long arm of chromosome 20",
      },
      {
        label: "Deletions of the short arm of chromosome 20",
        value: "Deletions of the short arm of chromosome 20",
      },
      {
        label: "Other specified deletions of chromosome 20",
        value: "Other specified deletions of chromosome 20",
      },
      {
        label: "Deletions of chromosome 20, unspecified",
        value: "Deletions of chromosome 20, unspecified",
      },
      {
        label: "Deletions of chromosome 21",
        value: "Deletions of chromosome 21",
      },
      {
        label: "Deletions of chromosome 22",
        value: "Deletions of chromosome 22",
      },
      { label: "CATCH 22 phenotype", value: "CATCH 22 phenotype" },
      {
        label: "Other specified deletions of chromosome 22",
        value: "Other specified deletions of chromosome 22",
      },
      {
        label: "Deletions of chromosome 22, unspecified",
        value: "Deletions of chromosome 22, unspecified",
      },
      {
        label: "Deletions with other complex rearrangements",
        value: "Deletions with other complex rearrangements",
      },
      {
        label: "Other specified deletions of the autosomes",
        value: "Other specified deletions of the autosomes",
      },
      {
        label: "Deletions of the autosomes, unspecified",
        value: "Deletions of the autosomes, unspecified",
      },
      { label: "Uniparental disomies", value: "Uniparental disomies" },
      {
        label: "Uniparental disomies of maternal origin",
        value: "Uniparental disomies of maternal origin",
      },
      {
        label: "Uniparental disomies of paternal origin",
        value: "Uniparental disomies of paternal origin",
      },
      {
        label: "Other specified uniparental disomies",
        value: "Other specified uniparental disomies",
      },
      {
        label: "Uniparental disomies, unspecified",
        value: "Uniparental disomies, unspecified",
      },
      { label: "Imprinting errors", value: "Imprinting errors" },
      {
        label: "Maternal imprinting error",
        value: "Maternal imprinting error",
      },
      {
        label: "Paternal imprinting error",
        value: "Paternal imprinting error",
      },
      {
        label: "Other specified imprinting errors",
        value: "Other specified imprinting errors",
      },
      {
        label: "Imprinting errors, unspecified",
        value: "Imprinting errors, unspecified",
      },
      {
        label: "Balanced rearrangements or structural markers",
        value: "Balanced rearrangements or structural markers",
      },
      {
        label: "Balanced translocation and insertion in normal individual",
        value: "Balanced translocation and insertion in normal individual",
      },
      {
        label: "Chromosome inversion in normal individual",
        value: "Chromosome inversion in normal individual",
      },
      {
        label: "Balanced autosomal rearrangement in abnormal individual",
        value: "Balanced autosomal rearrangement in abnormal individual",
      },
      {
        label: "Balanced sex or autosomal rearrangement in abnormal individual",
        value: "Balanced sex or autosomal rearrangement in abnormal individual",
      },
      { label: "Autosomal fragile site", value: "Autosomal fragile site" },
      {
        label: "Other specified balanced rearrangements or structural markers",
        value: "Other specified balanced rearrangements or structural markers",
      },
      {
        label: "Balanced rearrangements or structural markers, unspecified",
        value: "Balanced rearrangements or structural markers, unspecified",
      },
      { label: "Sex chromosome anomalies", value: "Sex chromosome anomalies" },
      {
        label: "Number anomalies of chromosome X",
        value: "Number anomalies of chromosome X",
      },
      { label: "Turner syndrome", value: "Turner syndrome" },
      { label: "Karyotype 45, X", value: "Karyotype 45, X" },
      { label: "Karyotype 46, X iso Xq", value: "Karyotype 46, X iso Xq" },
      {
        label: "Karyotype 46, X with abnormal sex chromosome, except iso Xq",
        value: "Karyotype 46, X with abnormal sex chromosome, except iso Xq",
      },
      {
        label: "Mosaicism, 45, X, 46, XX or XY",
        value: "Mosaicism, 45, X, 46, XX or XY",
      },
      {
        label:
          "Mosaicism, 45, X or other cell line with abnormal sex chromosome",
        value:
          "Mosaicism, 45, X or other cell line with abnormal sex chromosome",
      },
      { label: "Karyotype 47,XXX", value: "Karyotype 47,XXX" },
      {
        label: "Mosaicism, lines with various numbers of X chromosomes",
        value: "Mosaicism, lines with various numbers of X chromosomes",
      },
      { label: "Klinefelter syndrome", value: "Klinefelter syndrome" },
      {
        label: "Klinefelter syndrome with karyotype 47,XXY, regular",
        value: "Klinefelter syndrome with karyotype 47,XXY, regular",
      },
      {
        label: "Klinefelter syndrome, male with more than two X chromosomes",
        value: "Klinefelter syndrome, male with more than two X chromosomes",
      },
      {
        label: "Other specified Klinefelter syndrome",
        value: "Other specified Klinefelter syndrome",
      },
      {
        label: "Other specified number anomalies of chromosome X",
        value: "Other specified number anomalies of chromosome X",
      },
      {
        label: "Number anomalies of chromosome X, unspecified",
        value: "Number anomalies of chromosome X, unspecified",
      },
      {
        label:
          "Structural anomalies of chromosome X, excluding Turner syndrome",
        value:
          "Structural anomalies of chromosome X, excluding Turner syndrome",
      },
      {
        label: "Number anomalies of chromosome Y",
        value: "Number anomalies of chromosome Y",
      },
      {
        label: "Male with 46,XX karyotype",
        value: "Male with 46,XX karyotype",
      },
      {
        label: "Male with double or multiple Y",
        value: "Male with double or multiple Y",
      },
      {
        label: "Other specified number anomalies of chromosome Y",
        value: "Other specified number anomalies of chromosome Y",
      },
      {
        label: "Number anomalies of chromosome Y, unspecified",
        value: "Number anomalies of chromosome Y, unspecified",
      },
      {
        label: "Structural anomalies of chromosome Y",
        value: "Structural anomalies of chromosome Y",
      },
      {
        label: "Male with sex chromosome mosaicism",
        value: "Male with sex chromosome mosaicism",
      },
      { label: "Fragile X chromosome", value: "Fragile X chromosome" },
      { label: "Chimaera 46, XX, 46, XY", value: "Chimaera 46, XX, 46, XY" },
      { label: "Androgenetic chimaera", value: "Androgenetic chimaera" },
      { label: "Gynogenetic chimaera", value: "Gynogenetic chimaera" },
      {
        label: "Other specified chimaera 46, XX, 46, XY",
        value: "Other specified chimaera 46, XX, 46, XY",
      },
      {
        label: "Chimaera 46, XX, 46, XY, unspecified",
        value: "Chimaera 46, XX, 46, XY, unspecified",
      },
      {
        label: "Other specified sex chromosome anomalies",
        value: "Other specified sex chromosome anomalies",
      },
      {
        label: "Sex chromosome anomalies, unspecified",
        value: "Sex chromosome anomalies, unspecified",
      },
      {
        label:
          "Other specified chromosomal anomalies, excluding gene mutations",
        value:
          "Other specified chromosomal anomalies, excluding gene mutations",
      },
      {
        label: "Chromosomal anomalies, excluding gene mutations, unspecified",
        value: "Chromosomal anomalies, excluding gene mutations, unspecified",
      },
      {
        label:
          "Conditions with disorders of intellectual development as a relevant clinical feature",
        value:
          "Conditions with disorders of intellectual development as a relevant clinical feature",
      },
      { label: "Angelman syndrome", value: "Angelman syndrome" },
      {
        label: "Early-onset parkinsonism - intellectual deficit",
        value: "Early-onset parkinsonism - intellectual deficit",
      },
      {
        label: "Pelizaeus-Merzbacher-like disease",
        value: "Pelizaeus-Merzbacher-like disease",
      },
      { label: "Prader-Willi syndrome", value: "Prader-Willi syndrome" },
      { label: "Rett syndrome", value: "Rett syndrome" },
      {
        label:
          "Other specified conditions with disorders of intellectual development as a relevant clinical feature",
        value:
          "Other specified conditions with disorders of intellectual development as a relevant clinical feature",
      },
      {
        label:
          "Conditions with disorders of intellectual development as a relevant clinical feature, unspecified",
        value:
          "Conditions with disorders of intellectual development as a relevant clinical feature, unspecified",
      },
      {
        label: "Other specified developmental anomalies",
        value: "Other specified developmental anomalies",
      },
      {
        label: "Developmental anomalies, unspecified",
        value: "Developmental anomalies, unspecified",
      },
    ];

    this.setState({
      options: options,
    });
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  onTableChange(event) {}

  proceedEvent(event) {
    window.location.href = "/triage/admission/triage";
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state.diagnosis);
    var values = [];
    var icdict = [];
    var obj = new Object();
    for (var i = 0; i < this.state.diagnosis.length; i++) {
      obj = this.state.diagnosis[i]["label"];

      icdict.push(obj);
    }
    console.log(icdict);
    var dict = {
      chiefComplaint: this.state.chiefComplaint,
      historyofPresentIllness: this.state.historyofPresentIllness,
      physicalGeneral: this.state.physicalGeneral,
      obstetricGynecologicalExam: this.state.obstetricGynecologicalExam,
      plan: this.state.plan,
      treatment: {
        Route: this.state.tablevaluesglobal["Route"],
        DrugName: this.state.tablevaluesglobal["DrugName"],
        Dosage: this.state.tablevaluesglobal["Dosage"],
        Frequency: this.state.tablevaluesglobal["Frequency"],
        Duration: this.state.tablevaluesglobal["Duration"],
        DrugAdministration: this.state.tablevaluesglobal["DrugAdministration"],
        midwifenursename: this.state.tablevaluesglobal["midwifenursename"],
        remarks: this.state.tablevaluesglobal["remarks"],
      },
      diagnosis: icdict.toString(),
    };

    console.log(dict);

    axios
      .post(this.api_url+""+localStorage.getItem('currentModule')+"/shorthistory/short", dict, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            // alert('sdsd')
            $(".HistoryModal").show();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.Route = data[i][0];
      trimobj.DrugName = data[i][1];
      trimobj.Dosage = data[i][2];
      trimobj.Frequency = data[i][3];
      trimobj.Duration = data[i][4];
      trimobj.DrugAdministration = data[i][6];
      trimobj.midwifenursename = data[i][7];
      trimobj.remarks = data[i][8];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }

  handleTableChange(event) {}

  getTableValues(event) {
    var data = event;
    let topobj = {};
    let tableobj = {};
    // console.log(event.length)
    // var data = event.
    // for (let i = 0; i < data.length; i++) {
    //     let trim = data[i];
    let trimobj = {};
    this.setState({
      Year: "1212",
    });
    console.log(data[0]);
    trimobj.Route = data[0][0];
    trimobj.DrugName = data[0][1];
    trimobj.Dosage = data[0][2];
    trimobj.Frequency = data[0][3];
    trimobj.Duration = data[0][4];
    trimobj.DrugAdministration = data[0][5];
    trimobj.midwifenursename = data[0][6];
    trimobj.remarks = data[0][7];

    tableobj = trimobj;
    topobj.prepplan = tableobj;
    // }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
    // let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  addNewDiagnosis(event) {
    var diagnosis = this.state.diagnosis;

    var object = new Object();
    var split = event.target.value.split(",");

    for (var i = 0; i < split.length; i++) {
      object["label"] = split[i];
      object["value"] = split[i];
      diagnosis.push(object);
    }
    this.setState({
      diagnosis: diagnosis,
    });
  }

  render() {
    //Editable table variables
    const data = [
      ["", "", "", "", "", "", "", "", localStorage.getItem("Currentusername")],
    ];

    const columns = [
      "Route",
      "Drug Name",
      "Dosage",
      "Frequency",
      "Duration",
      "Drug Administration Date Time Given",
      "Name of Midwife/Nurse",
      "Doctor`s Remarks",
      "Name of Doctor",
    ];
    const font16 = { fontSize: "22px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      chiefComplaint,
      historyofPresentIllness,
      physicalGeneral,
      obstetricGynecologicalExam,
      diagnosis,
      plan,
      treatment,
      options,
      patientName,
    } = this.state;

    return (
      <div>
        <Headers />
        <GynecologySidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 font-weight-bold p-1">
                  <p className="" style={font16}>
                    History Taking and Physical Examination
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Chief Complaint
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={chiefComplaint}
                      name="chiefComplaint"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      History Of Present Illness
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={historyofPresentIllness}
                      name="historyofPresentIllness"
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      General Physical Examination
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={physicalGeneral}
                      name="physicalGeneral"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Obstetric Gynecological Exam
                    </h6>
                    <textarea
                      rows="6"
                      className="form-control"
                      onChange={this.handleChange}
                      value={obstetricGynecologicalExam}
                      name="obstetricGynecologicalExam"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Diagnosis ICD Code
                    </h6>

                    <Select
                      options={options}
                      style={width100}
                      value={this.state.diagnosis}
                      name="filters"
                      onChange={this.handleMultiChange}
                      isSearchable
                      isMulti
                    />

                    <textarea
                      className="form-control"
                      onBlur={this.addNewDiagnosis}
                      placeholder="Add additional diagnosis(Please Separate the diagnoses with a comma)"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Plan
                    </h6>
                    <textarea
                      rows="6"
                      className="form-control"
                      onChange={this.handleChange}
                      value={plan}
                      name="plan"
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="form-row mb-2 pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <MDBCard>
                    <MDBCardHeader
                      tag="h3"
                      className="text-center font-weight-bold text-capitalise py-4"
                    >
                      Treatment
                    </MDBCardHeader>
                    <MDBCardBody>
                      <MDBTableEditable
                        onChange={(value) => this.handleTableChange(value)}
                        getValue={(value) => this.getTableValues(value)}
                        myParentTrigger={this.state.myParentTrigger}
                        id="#editablecard"
                        data={data}
                        columns={columns}
                        striped
                        bordered
                      />
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </div>

           <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
                 <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>History Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GHistoryTaking;
